webpackJsonp([0],{

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDashboard_vue__ = __webpack_require__(1242);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb728a46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDashboard_vue__ = __webpack_require__(1349);
function injectStyle (ssrContext) {
  __webpack_require__(1323)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb728a46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb728a46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useFormAlert() {
  var message = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var type = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('warning');
  var timer = null;

  function apply(msg, autoDismiss) {
    message.value = msg;

    if (autoDismiss) {
      timer = setTimeout(function () {
        message.value = null;
      }, 5000);
    }
  }

  function show(msg, alertType, autoDismiss) {
    clearTimeout(timer);
    type.value = alertType;

    if (message.value != null) {
      message.value = null;
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
        return apply(msg, autoDismiss);
      });
    } else {
      apply(msg, autoDismiss);
    }
  }

  function showError(msg) {
    show(msg, 'warning', true);
  }

  function showSuccess(msg) {
    show(msg != null ? msg : 'Success', 'success', true);
  }

  function showPersistentError(msg) {
    show(msg, 'warning', false);
  }

  function clear() {
    clearTimeout(timer);
    message.value = null;
  }

  return {
    message: message,
    type: type,
    showError: showError,
    showSuccess: showSuccess,
    showPersistentError: showPersistentError,
    clear: clear
  };
}

/***/ }),

/***/ 1135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridTable_vue__ = __webpack_require__(1136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b00a312_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridTable_vue__ = __webpack_require__(1141);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b00a312_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'GridTable',
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: null
    },
    direction: {
      type: String,
      default: 'asc'
    },
    emptyText: {
      type: String,
      default: null
    },
    openId: {
      type: [String, Number],
      default: undefined
    },
    draggable: {
      type: Boolean,
      default: false
    },

    /**
     * Opt-in grouped drag mode (with `draggable`): [{ id, units: [{ row, children: [] }] }].
     * The row's `cell:*` slot decides who may be dragged by putting `gt__drag-handle--group`
     * (moves the whole group) or `gt__drag-handle--child` (reorders inside its own unit) on
     * the handle element. `rows` is then rendered below as plain, non-draggable rows.
     * Emits `drag-end` with the flat ordered ids of everything inside the groups.
     */
    groups: {
      type: Array,
      default: null
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    noBorders: {
      type: Boolean,
      default: false
    },
    noStripes: {
      type: Boolean,
      default: false
    },
    borderMode: {
      type: String,
      default: null
    },
    borderColor: {
      type: String,
      default: null
    },
    borderWidth: {
      type: String,
      default: null
    },
    rowBg: {
      type: String,
      default: null
    },
    tabAlignTop: {
      type: Boolean,
      default: false
    },
    mobBreak: {
      type: Number,
      default: 575
    },
    tabBreak: {
      type: Number,
      default: 767
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var root = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var isMob = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var isTab = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var internalOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var ro = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      ro = new ResizeObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];

        var w = entry.contentRect.width;
        isMob.value = w <= props.mobBreak;
        isTab.value = !isMob.value && w <= props.tabBreak;
      });
      ro.observe(root.value);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
      if (ro) ro.disconnect();
    });
    var cachedRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])([function () {
      return props.rows;
    }, function () {
      return props.loading;
    }], function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          rows = _ref4[0],
          loading = _ref4[1];

      if (!loading) cachedRows.value = rows;
    }, {
      immediate: true
    });
    var displayRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.loading ? cachedRows.value : props.rows;
    }); // Local mutable copy: vuedraggable splices the arrays it is given in place.

    var groupList = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.groups;
    }, function (groups) {
      groupList.value = (groups || []).map(function (group) {
        return _objectSpread({}, group, {
          units: group.units.map(function (unit) {
            return _objectSpread({}, unit, {
              children: _toConsumableArray(unit.children)
            });
          })
        });
      });
    }, {
      immediate: true
    }); // Row position across all groups, so stripes alternate row by row exactly like the plain table.

    var groupRowIndex = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var index = {};
      var n = 0;
      groupList.value.forEach(function (group) {
        return group.units.forEach(function (unit) {
          index[unit.row.id] = n++;
          unit.children.forEach(function (child) {
            index[child.id] = n++;
          });
        });
      });
      return index;
    });
    var groupRowCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Object.keys(groupRowIndex.value).length;
    }); // Second argument: the id of the row that was dragged (a group's first row, or the child row), so
    // the page can show the result of the reorder next to it.

    function onGroupDragEnd(evt) {
      var ids = groupList.value.flatMap(function (group) {
        return group.units.flatMap(function (unit) {
          return [unit.row.id].concat(_toConsumableArray(unit.children.map(function (child) {
            return child.id;
          })));
        });
      });
      var item = evt && evt.item;
      var holder = item && (item.dataset.rowId != null ? item : item.querySelector('[data-row-id]'));
      var movedId = holder ? Number(holder.dataset.rowId) : null;
      proxy.$emit('drag-end', ids, Number.isNaN(movedId) ? null : movedId);
    }

    var resolvedOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.openId !== undefined ? props.openId : internalOpenId.value;
    });

    function toggleRow(id) {
      if (props.openId !== undefined) return;
      internalOpenId.value = internalOpenId.value === id ? null : id;
    }

    function colTrack(col) {
      var widthKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width';
      var w = col[widthKey] || col.width || 'max-content';
      return col.minWidth ? "minmax(".concat(col.minWidth, ", ").concat(w, ")") : w;
    }

    var cssVars = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var vars = {
        '--gt-cols': props.columns.map(function (c) {
          return colTrack(c);
        }).join(' '),
        '--gt-cols-mob': props.columns.filter(function (c) {
          return !c.mobile;
        }).map(function (c) {
          return colTrack(c, 'mobileWidth');
        }).join(' '),
        '--gt-cols-tab': props.columns.filter(function (c) {
          return !c.tabRow && c.tablet !== 'hide' && c.tablet !== 'wrap';
        }).map(function (c) {
          return colTrack(c, 'tabWidth');
        }).join(' ')
      };
      if (props.borderColor != null) vars['--gt-border-color'] = props.borderColor;
      if (props.borderWidth != null) vars['--gt-border-width'] = props.borderWidth;
      if (props.rowBg != null) vars['--gt-row-bg'] = props.rowBg;
      return vars;
    });
    var mobileLabelCols = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.columns.filter(function (c) {
        return c.mobile === 'label';
      });
    });
    var primaryIdx = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var explicit = props.columns.findIndex(function (c) {
        return c.primary;
      });
      return explicit !== -1 ? explicit : props.columns.findIndex(function (c) {
        return !c.mobile;
      });
    });
    var hasExpand = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return 'expand' in proxy.$scopedSlots;
    });

    function mobClass(col) {
      if (!col.mobile) return null;
      return col.mobile === 'label' ? 'gt__cell--mob-label' : 'gt__cell--mob-hide';
    }

    function tabHdrClass(col) {
      if (col.tablet === 'wrap' || col.tabRow) return 'gt__hdr--tab-wrap';
      if (col.tablet === 'hide') return 'gt__hdr--tab-hide';
      if (col.tabHideLabel) return 'gt__hdr--tab-no-label';
      return null;
    }

    function tabCellClass(col) {
      if (col.tablet === 'wrap' || col.tabRow) return 'gt__cell--tab-wrap';
      if (col.tablet === 'hide') return 'gt__cell--tab-hide';
      return null;
    }

    var tabWrapLayout = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var n = props.columns.filter(function (c) {
        return !c.tabRow && c.tablet !== 'hide' && c.tablet !== 'wrap';
      }).length;

      function calcRow(cols, row) {
        return cols.reduce(function (acc, col, i, arr) {
          var prevEnd = i === 0 ? 1 : acc[arr[i - 1].key].end;
          var isLast = i === arr.length - 1;
          var pct = col.tabletWidth ? parseFloat(col.tabletWidth) / 100 : 1 / arr.length;
          var span = isLast ? n + 1 - prevEnd : Math.max(1, Math.round(pct * n));
          acc[col.key] = {
            start: prevEnd,
            end: prevEnd + span,
            row: row
          };
          return acc;
        }, {});
      }

      var rowNumbers = _toConsumableArray(new Set(props.columns.map(function (c) {
        return c.tablet === 'wrap' ? 2 : c.tabRow;
      }).filter(function (row) {
        return row != null;
      })));

      return rowNumbers.reduce(function (acc, row) {
        var cols = props.columns.filter(function (c) {
          return (c.tablet === 'wrap' ? 2 : c.tabRow) === row;
        });
        return _objectSpread({}, acc, {}, calcRow(cols, row));
      }, {});
    });

    function tabCellStyle(col) {
      var pos = tabWrapLayout.value[col.key];
      if (!pos) return {};
      return {
        '--tab-col-start': pos.start,
        '--tab-col-end': pos.end,
        '--tab-row': pos.row
      };
    }

    var borderModeClass = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!props.borderMode) return null;
      return "gt--border-".concat(props.borderMode);
    });
    return {
      root: root,
      isMob: isMob,
      isTab: isTab,
      displayRows: displayRows,
      groupList: groupList,
      groupRowIndex: groupRowIndex,
      groupRowCount: groupRowCount,
      onGroupDragEnd: onGroupDragEnd,
      resolvedOpenId: resolvedOpenId,
      toggleRow: toggleRow,
      cssVars: cssVars,
      mobileLabelCols: mobileLabelCols,
      primaryIdx: primaryIdx,
      hasExpand: hasExpand,
      mobClass: mobClass,
      tabHdrClass: tabHdrClass,
      tabCellClass: tabCellClass,
      tabCellStyle: tabCellStyle,
      borderModeClass: borderModeClass
    };
  }
}));

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormAlert__ = __webpack_require__(1127);
//
//
//
//
//
//
 // A message overlaid on the bottom of the row above (its parent must be a zero-height, relatively
// positioned anchor — GridTable's `before-row` slot is one), so it appears right over the row it is
// about without pushing the table apart. `alertKey` changes for every new message, even with the
// same text, so it re-appears. Click dismisses it.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RowAlert',
  components: {
    FormAlert: __WEBPACK_IMPORTED_MODULE_0__components_FormAlert__["a" /* default */]
  },
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'success'
    },
    alertKey: {
      type: [Number, String],
      default: 0
    },
    // The alert lives inside a (position: relative) table row instead of a zero-height anchor above
    // it: place its bottom edge on that row's top edge.
    aboveRow: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppTabSwitcher',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    modelValue: function modelValue() {
      return this.value;
    }
  }
});

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  eventTypes: function eventTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/event-types');
  },
  create: function create(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/events"), data, {
      silent: true
    });
  },
  getEdit: function getEdit(draftId, eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/events/").concat(eventId, "/edit"));
  },
  update: function update(draftId, eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/drafts/".concat(draftId, "/events/").concat(eventId), data, {
      silent: true
    });
  },
  // localSuccess: the caller shows the result itself (next to the event); without it the http client
  // would also push it to the page-top alert and scroll the page up.
  destroy: function destroy(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/events/".concat(id), {
      silent: true,
      localSuccess: true
    });
  },
  reorder: function reorder(draftId, ids) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/events/reorder"), {
      ids: ids
    }, {
      silent: true,
      localSuccess: true
    });
  },
  nominationsDashboard: function nominationsDashboard(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/events/nominations-dashboard"));
  },
  lock: function lock(id, isLocked) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/events/".concat(id, "/lock"), {
      is_locked: isLocked
    }, {
      silent: true,
      localSuccess: true
    });
  },
  deleteSponsorLogo: function deleteSponsorLogo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/events/".concat(id, "/sponsor-logo"), {
      silent: true
    });
  },
  split: function split(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(id, "/split"), {}, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"gt",class:[{ 'gt--mob': _vm.isMob, 'gt--tab': _vm.isTab, 'gt--tab-top': _vm.tabAlignTop, 'gt--loading': _vm.loading, 'gt--no-borders': _vm.noBorders, 'gt--no-stripes': _vm.noStripes }, _vm.borderModeClass],style:(_vm.cssVars)},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),(!_vm.hideHeader)?_c('div',{staticClass:"gt__row gt__row--head"},_vm._l((_vm.columns),function(col){return _c('div',{key:col.key,staticClass:"gt__hdr",class:[_vm.mobClass(col), _vm.tabHdrClass(col), col.cellClass, { 'gt__hdr--sort': col.sortable }],on:{"click":function($event){col.sortable ? _vm.$emit('sort', col.key) : undefined}}},[_vm._v("\n      "+_vm._s(col.label)+"\n      "),(col.sortable)?_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.sort === col.key && _vm.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.sort === col.key && _vm.direction === 'desc' }]})]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.displayRows.length && !_vm.groupList.length)?_c('div',{staticClass:"gt__empty"},[_vm._v("\n    "+_vm._s(_vm.emptyText || 'No results found.')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.draggable && _vm.groups)?_c('draggable',{staticClass:"gt__draggable-body",attrs:{"tag":"div","list":_vm.groupList,"handle":".gt__drag-handle--group"},on:{"end":_vm.onGroupDragEnd}},_vm._l((_vm.groupList),function(group){return _c('div',{key:("g-" + (group.id)),staticClass:"gt__group",class:{ 'gt__group--single': group.units.length === 1 && !group.units[0].children.length }},[_vm._l((group.units),function(unit){return [(_vm.$scopedSlots['before-row'])?_c('div',{key:("before-" + (unit.row.id)),staticClass:"gt__before-row"},[_vm._t("before-row",null,{"row":unit.row})],2):_vm._e(),_vm._v(" "),_c('div',{key:String(unit.row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === unit.row.id, 'gt__row--odd': _vm.groupRowIndex[unit.row.id] % 2 === 0 },attrs:{"data-row-id":unit.row.id}},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(unit.row[col.key]))],{"row":unit.row}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(unit.row[mc.key]))],{"row":unit.row})],2)}),0):_vm._e()],2)}),0),_vm._v(" "),_c('draggable',{key:("u-" + (unit.row.id)),staticClass:"gt__draggable-body",attrs:{"tag":"div","list":unit.children,"group":("unit-" + (unit.row.id)),"handle":".gt__drag-handle--child"},on:{"end":_vm.onGroupDragEnd}},_vm._l((unit.children),function(child){return _c('div',{key:String(child.id),staticClass:"gt__row gt__row--data gt__row--child",class:{ 'gt__row--open': _vm.resolvedOpenId === child.id, 'gt__row--odd': _vm.groupRowIndex[child.id] % 2 === 0 },attrs:{"data-row-id":child.id}},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(child[col.key]))],{"row":child}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(child[mc.key]))],{"row":child})],2)}),0):_vm._e()],2)}),0)}),0)]})],2)}),0):_vm._e(),_vm._v(" "),(_vm.draggable && !_vm.groups)?_c('draggable',{staticClass:"gt__draggable-body",attrs:{"tag":"div","list":_vm.displayRows,"handle":".gt__drag-handle"},on:{"start":function($event){_vm.$emit('drag-start', _vm.displayRows.map(function (r) { return r.id; }))},"end":function($event){_vm.$emit('drag-end', _vm.displayRows.map(function (r) { return r.id; }))}}},_vm._l((_vm.displayRows),function(row,index){return _c('div',{key:String(row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === row.id, 'gt__row--odd': index % 2 === 0 }},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(row[col.key]))],{"row":row}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(row[mc.key]))],{"row":row})],2)}),0):_vm._e()],2)}),0)}),0):_vm._e(),_vm._v(" "),(!_vm.draggable || _vm.groups)?[_vm._l((_vm.displayRows),function(row,index){return [(_vm.$scopedSlots['before-row'])?_c('div',{key:("before-" + (row.id)),staticClass:"gt__before-row"},[_vm._t("before-row",null,{"row":row})],2):_vm._e(),_vm._v(" "),_c('div',{key:String(row.id),staticClass:"gt__row gt__row--data",class:{ 'gt__row--open': _vm.resolvedOpenId === row.id, 'gt__row--odd': (index + _vm.groupRowCount) % 2 === 0 }},_vm._l((_vm.columns),function(col,i){return _c('div',{key:col.key,staticClass:"gt__cell",class:[_vm.mobClass(col), _vm.tabCellClass(col), col.cellClass, { 'gt__cell--tab-labeled': _vm.isTab && col.tabLabel, 'gt__cell--tab-top': col.tabAlignTop }],style:(_vm.tabCellStyle(col))},[(_vm.isTab && col.tabLabel)?_c('strong',{staticClass:"gt__tab-label"},[_vm._v(_vm._s(col.label))]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (col.key)),[_vm._v(_vm._s(row[col.key]))],{"row":row,"toggle":function () { return _vm.toggleRow(row.id); },"isOpen":_vm.resolvedOpenId === row.id}),_vm._v(" "),(i === _vm.primaryIdx && _vm.mobileLabelCols.length)?_c('div',{staticClass:"gt__mob-labels"},_vm._l((_vm.mobileLabelCols),function(mc){return _c('div',{key:mc.key,staticClass:"gt__mob-label"},[_c('strong',[_vm._v(_vm._s(mc.label)+": ")]),_vm._v(" "),_vm._t(("cell:" + (mc.key)),[_vm._v(_vm._s(row[mc.key]))],{"row":row})],2)}),0):_vm._e()],2)}),0),_vm._v(" "),(_vm.hasExpand && _vm.resolvedOpenId === row.id)?_c('div',{key:("x-" + (row.id)),staticClass:"gt__expand"},[_vm._t("expand",null,{"row":row,"odd":(index + _vm.groupRowCount) % 2 === 0})],2):_vm._e()]})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowAlert_vue__ = __webpack_require__(1138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f28bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RowAlert_vue__ = __webpack_require__(1153);
function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69f28bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f28bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RowAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FRadioGroup',
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    value: {
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean,
    required: Boolean,
    inline: Boolean,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__ = __webpack_require__(145);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'BulkEditorTool',
  components: {
    FCheckbox: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FCheckbox__["a" /* default */]
  },
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['toggle-all']
}));

/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRowAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
 // The result of an action on one table row, shown right above that row (see RowAlert.vue) instead
// of at the top of the page. Auto-dismisses after 5s unless `persistent`; every call gets a new id
// so repeating an action with the same text re-creates the message and is visibly "new".

function useRowAlert() {
  var empty = function empty() {
    return {
      message: null,
      type: 'success',
      rowId: null,
      id: 0
    };
  };

  var alert = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(empty());
  var seq = 0;
  var timer = null;

  function clear() {
    clearTimeout(timer);
    alert.value = empty();
  }

  function show(message, type, rowId) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref$persistent = _ref.persistent,
        persistent = _ref$persistent === void 0 ? false : _ref$persistent;

    clearTimeout(timer);
    alert.value = {
      message: message,
      type: type,
      rowId: rowId,
      id: ++seq
    };
    if (!persistent) timer = setTimeout(clear, 5000);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
    return clearTimeout(timer);
  });
  return {
    alert: alert,
    show: show,
    clear: clear,
    showSuccess: function showSuccess(message, rowId) {
      return show(message, 'success', rowId);
    },
    showError: function showError(message, rowId, options) {
      return show(message, 'warning', rowId, options);
    }
  };
}

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("35f89dda", content, true, {});

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".row-alert[data-v-69f28bea]{position:absolute;right:0;bottom:0;left:0;height:0}.row-alert--above-row[data-v-69f28bea]{bottom:100%}.row-alert[data-v-69f28bea] .form-alert{position:absolute;right:8px;bottom:6px;left:8px}.row-alert[data-v-69f28bea] .alert{box-shadow:0 2px 8px rgba(0,0,0,.2)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/RowAlert.vue"],"names":[],"mappings":"AACA,4BACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,OAAQ,AACR,QAAU,CACX,AACD,uCACE,WAAa,CACd,AAID,wCACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,QAAU,CACX,AACD,mCACE,mCAAyC,CAC1C","file":"RowAlert.vue","sourcesContent":["\n.row-alert[data-v-69f28bea] {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 0;\n}\n.row-alert--above-row[data-v-69f28bea] {\n  bottom: 100%;\n}\n\n/* Absolute as well: while a new message replaces the old one (which is still fading out) the two\n   overlap in the same spot instead of stacking and shoving each other upwards. */\n.row-alert[data-v-69f28bea] .form-alert {\n  position: absolute;\n  right: 8px;\n  bottom: 6px;\n  left: 8px;\n}\n.row-alert[data-v-69f28bea] .alert {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"row-alert",class:{ 'row-alert--above-row': _vm.aboveRow }},[_c('form-alert',{key:_vm.alertKey,attrs:{"message":_vm.message,"type":_vm.type,"scroll-on-mount":"","flush":""},on:{"dismiss":function($event){return _vm.$emit('dismiss')}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getYears;
function getYears() {
  var currentYear = new Date().getFullYear();
  return Array.from({
    length: 6
  }, function (_, i) {
    return currentYear - i;
  });
}

/***/ }),

/***/ 1156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__ = __webpack_require__(1139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__ = __webpack_require__(1157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTabSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ae30f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTabSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-switcher"},_vm._l((_vm.items),function(item){return _c('a',{key:item.value,staticClass:"tab-switcher__tab",class:{ 'tab-switcher__tab--active': _vm.modelValue === item.value },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getInvoices: function getInvoices(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-invoices', {
      params: params
    });
  },
  getPdf: function getPdf(invoiceId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nomination-invoices/".concat(invoiceId, "/pdf"), {
      silent: true
    });
  },
  getStripeSecret: function getStripeSecret(invoiceId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nomination-invoices/".concat(invoiceId, "/stripe-client-secret"), {});
  },
  confirmPayment: function confirmPayment(invoiceId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nomination-invoices/".concat(invoiceId, "/confirm-payment"), data, {
      silent: true
    });
  },
  resend: function resend(draftId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nomination-invoices/users/").concat(userId, "/resend"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  remind: function remind(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nomination-invoices/remind"), {}, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),

/***/ 1161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getIncoming: function getIncoming(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/incoming', {
      params: params
    });
  },
  getIncomingPdf: function getIncomingPdf(reportId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/reports/incoming/".concat(reportId, "/pdf"), {
      silent: true
    });
  },
  getOutgoingPdf: function getOutgoingPdf(reportId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/reports/outgoing/".concat(reportId, "/pdf"), {
      silent: true
    });
  },
  getIncomingTotals: function getIncomingTotals(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/incoming/totals', {
      params: params
    });
  },
  getOutgoing: function getOutgoing(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing', {
      params: params
    });
  },
  getOutgoingTotals: function getOutgoingTotals(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing/totals', {
      params: params
    });
  },
  getOutgoingOptions: function getOutgoingOptions() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing/options');
  },
  exportIncoming: function exportIncoming(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/incoming/export', {
      params: params,
      responseType: 'blob'
    });
  },
  exportOutgoing: function exportOutgoing(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/reports/outgoing/export', {
      params: params,
      responseType: 'blob'
    });
  },
  updateIncomingAmount: function updateIncomingAmount(reportId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/reports/incoming/".concat(reportId, "/amount"), data, {
      silent: true,
      localSuccess: true
    });
  },
  updateOutgoingAmount: function updateOutgoingAmount(invoiceId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/reports/outgoing/invoices/".concat(invoiceId, "/amount"), data, {
      silent: true,
      localSuccess: true
    });
  },
  generateOutgoing: function generateOutgoing(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/reports/outgoing/generate"), data, {
      silent: true
    });
  },
  generationStatus: function generationStatus(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/reports/outgoing/generation-status"));
  },
  queueStatus: function queueStatus(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/reports/outgoing/queue-status"));
  },
  generateOutgoingAba: function generateOutgoingAba(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/reports/outgoing/aba', data, {
      silent: true,
      responseType: 'blob'
    });
  },
  updatePaymentType: function updatePaymentType(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/reports/outgoing/payment-type', data, {
      silent: true,
      localSuccess: true
    });
  },
  updatePaymentStatus: function updatePaymentStatus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/reports/outgoing/payment-status', data, {
      silent: true,
      localSuccess: true
    });
  },
  updateRefunds: function updateRefunds(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/reports/outgoing/refunds', data, {
      silent: true,
      localSuccess: true
    });
  },
  downloadVehiclesPdf: function downloadVehiclesPdf(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/reports/nominations-with-vehicles/pdf"), {
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildEventGroups;
/* harmony export (immutable) */ __webpack_exports__["c"] = flattenEventGroups;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildLeafEventGroups;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Groups a draft's flat, ordered event list for the Events table so that related events can
 * only be moved together:
 *   - a combined parent and its children form one unit (children only reorder inside it);
 *   - units tied by brother_id form one group (regular split A+B, combined split A+B, and a
 *     conjunction pair with its final) and are moved as a whole.
 * Units inside a group keep a fixed order (by id: the original/A row is always the lowest id).
 *
 * @param {Array} events flat list, already in display order
 * @returns {Array<{ id: number, units: Array<{ row: Object, children: Object[] }> }>}
 */
function buildEventGroups(events) {
  var position = new Map(events.map(function (event, index) {
    return [event.id, index];
  }));
  var ids = new Set(events.map(function (event) {
    return event.id;
  }));
  var childrenByParent = new Map();
  var roots = [];
  events.forEach(function (event) {
    if (event.parent_id != null && ids.has(event.parent_id)) {
      if (!childrenByParent.has(event.parent_id)) childrenByParent.set(event.parent_id, []);
      childrenByParent.get(event.parent_id).push(event);
    } else {
      roots.push(event);
    }
  });
  var rootById = new Map(roots.map(function (root) {
    return [root.id, root];
  }));
  var family = new Map(roots.map(function (root) {
    return [root.id, root.id];
  }));

  function find(id) {
    while (family.get(id) !== id) {
      id = family.get(id);
    }

    return id;
  }

  roots.forEach(function (root) {
    if (root.brother_id != null && rootById.has(root.brother_id)) {
      family.set(find(root.id), find(root.brother_id));
    }
  });
  var unitsByFamily = new Map();
  roots.forEach(function (root) {
    var key = find(root.id);
    if (!unitsByFamily.has(key)) unitsByFamily.set(key, []);
    unitsByFamily.get(key).push({
      row: root,
      children: childrenByParent.get(root.id) || []
    });
  });
  return _toConsumableArray(unitsByFamily.values()).map(function (units) {
    units.sort(function (a, b) {
      return a.row.id - b.row.id;
    });
    return {
      id: units[0].row.id,
      units: units,
      position: Math.min.apply(Math, _toConsumableArray(units.map(function (unit) {
        return position.get(unit.row.id);
      })))
    };
  }).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (_ref) {
    var id = _ref.id,
        units = _ref.units;
    return {
      id: id,
      units: units
    };
  });
}
function flattenEventGroups(groups) {
  return groups.flatMap(function (group) {
    return group.units.flatMap(function (unit) {
      return [unit.row.id].concat(_toConsumableArray(unit.children.map(function (child) {
        return child.id;
      })));
    });
  });
}
/**
 * Same grouping for a list that has no parent rows (only leaf events): a unit is the set of
 * rows sharing a parent_id (or a lone event), and units are tied into one group through
 * brother_id (own, or the parent's `parent_brother_id`) — a regular split pair, a combined
 * split A+B, or a conjunction pair with its final.
 *
 * @param {Array} events flat list, already in display order
 * @returns {Array<{ id: number, rows: Object[] }>} rows are ordered unit by unit (lowest id first)
 */

function buildLeafEventGroups(events) {
  var unitKey = function unitKey(event) {
    return event.parent_id != null ? event.parent_id : event.id;
  };

  var brotherKey = function brotherKey(event) {
    return event.parent_id != null ? event.parent_brother_id : event.brother_id;
  };

  var family = new Map(events.map(function (event) {
    return [unitKey(event), unitKey(event)];
  }));

  function find(key) {
    while (family.get(key) !== key) {
      key = family.get(key);
    }

    return key;
  }

  events.forEach(function (event) {
    var brother = brotherKey(event);

    if (brother != null && family.has(brother)) {
      family.set(find(unitKey(event)), find(brother));
    }
  });
  var groups = new Map();
  events.forEach(function (event, index) {
    var key = find(unitKey(event));
    if (!groups.has(key)) groups.set(key, {
      rows: [],
      position: index
    });
    groups.get(key).rows.push({
      event: event,
      index: index
    });
  });
  return _toConsumableArray(groups.values()).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (_ref2) {
    var rows = _ref2.rows;
    rows.sort(function (a, b) {
      return unitKey(a.event) - unitKey(b.event) || a.index - b.index;
    });
    return {
      id: rows[0].event.id,
      rows: rows.map(function (row) {
        return row.event;
      })
    };
  });
}

/***/ }),

/***/ 1169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FRadioGroup_vue__ = __webpack_require__(1143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df08032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FRadioGroup_vue__ = __webpack_require__(1170);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FRadioGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df08032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FRadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger ml-1"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:{ 'd-flex flex-wrap': _vm.inline }},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"custom-control custom-radio",class:{ 'mr-4': _vm.inline }},[_c('input',{staticClass:"custom-control-input",attrs:{"id":(_vm.name + "_" + (option.value)),"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":option.value,"checked":_vm.value === option.value},on:{"change":function($event){return _vm.$emit('input', option.value)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":(_vm.name + "_" + (option.value))}},[_vm._v(_vm._s(option.label))])])}),0),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"text-danger small mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_SPLIT_KIND_NONE */
/* unused harmony export EVENT_SPLIT_KIND_REGULAR_SPLIT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL; });
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT */
/* unused harmony export EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD */
// Mirror of App\Enums\EventSplitKind (campdraftone-api) — `split_kind` field, e.g. on
// EventNominationsDashboardResource. Not backed by a single DB column (derived from
// parent_id/brother_id/is_conjunction/children_count, see Event::splitKind()). Keep in sync by
// hand; there is no shared source of truth across the two repos. No labels here — this enum has
// none on the backend either, it's an internal classification, not something shown verbatim.
var EVENT_SPLIT_KIND_NONE = 'none';
var EVENT_SPLIT_KIND_REGULAR_SPLIT = 'regular_split';
var EVENT_SPLIT_KIND_COMBINED_UNSPLIT_PARENT = 'combined_unsplit_parent';
var EVENT_SPLIT_KIND_COMBINED_UNSPLIT_CHILD = 'combined_unsplit_child';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CONTAINER = 'combined_conjunction_container';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_CHILD = 'combined_conjunction_child';
var EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL = 'combined_conjunction_final';
var EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_PARENT = 'combined_split_side_parent';
var EVENT_SPLIT_KIND_COMBINED_SPLIT_SIDE_CHILD = 'combined_split_side_child';

/***/ }),

/***/ 1181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppTabSwitcher__ = __webpack_require__(1156);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TabSearchBar',
  components: {
    AppTabSwitcher: __WEBPACK_IMPORTED_MODULE_0__components_AppTabSwitcher__["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  }
});

/***/ }),

/***/ 1182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkEditorTool_vue__ = __webpack_require__(1146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e57b00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulkEditorTool_vue__ = __webpack_require__(1185);
function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1e57b00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkEditorTool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e57b00_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulkEditorTool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("5bbcc44f", content, true, {});

/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".bulk-editor-tool__title[data-v-e1e57b00]{display:block;margin-bottom:.3rem;font-weight:700;font-size:1.094rem}@media (max-width:1024px){.tools_events_bar[data-v-e1e57b00]{flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important}.tools_events_bar>[data-v-e1e57b00]{margin-bottom:.75rem}.tools_events_bar>[data-v-e1e57b00]:first-child{margin-bottom:.75rem!important}.tools_events_bar>[data-v-e1e57b00]:last-child{margin-bottom:0}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/BulkEditorTool.vue"],"names":[],"mappings":"AACA,0CACE,cAAe,AACf,oBAAsB,AACtB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,0BACA,mCACI,gCAAkC,AAClC,iCAAmC,AACnC,oCAAuC,CAC1C,AACD,oCACI,oBAAuB,CAC1B,AACD,gDACI,8BAAkC,CACrC,AACD,+CACI,eAAiB,CACpB,CACA","file":"BulkEditorTool.vue","sourcesContent":["\n.bulk-editor-tool__title[data-v-e1e57b00] {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-weight: 700;\n  font-size: 1.094rem;\n}\n@media (max-width: 1024px) {\n.tools_events_bar[data-v-e1e57b00] {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    justify-content: flex-start !important;\n}\n.tools_events_bar > *[data-v-e1e57b00] {\n    margin-bottom: 0.75rem;\n}\n.tools_events_bar > *[data-v-e1e57b00]:first-child {\n    margin-bottom: 0.75rem !important;\n}\n.tools_events_bar > *[data-v-e1e57b00]:last-child {\n    margin-bottom: 0;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"bulk-editor-tool__title"},[_vm._v("Bulk Editor Tool")]),_vm._v(" "),_c('div',{staticClass:"tools_events_bar mb-3 p-2 p-sm-3 bg-lighter border-top d-flex align-items-center flex-wrap justify-content-around"},[_c('f-checkbox',{staticClass:"mb-0 mr-3 flex-shrink-0",attrs:{"id":"bulk-select-all","label":"Select all","value":_vm.totalCount > 0 && _vm.selectedCount === _vm.totalCount,"font-normal":true},on:{"input":function($event){return _vm.$emit('toggle-all')}}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getForm: function getForm(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/biosecurity"));
  },
  createForm: function createForm(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/biosecurity"), data, {
      silent: true
    });
  },
  updateForm: function updateForm(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/biosecurity"), data, {
      silent: true
    });
  },
  getBlankPdf: function getBlankPdf() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nominations/biosecurity-blank-form', {
      responseType: 'blob'
    });
  },
  downloadReport: function downloadReport(draftId, format) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/biosecurity/report"), {
      params: {
        format: format
      },
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_events__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





function useDraftEvents() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;

  var events = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var deleting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var currentDraftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

  function emitError(msg) {
    if (onError) onError(msg);else __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('http-error', msg);
  }

  function emitSuccess(msg) {
    if (onSuccess) onSuccess(msg);else __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('show-success', msg);
  }

  function loadEvents(_x) {
    return _loadEvents.apply(this, arguments);
  }

  function _loadEvents() {
    _loadEvents = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(draftId) {
      var res, data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentDraftId.value = draftId;
              loading.value = true;
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].events(draftId);

            case 5:
              res = _context.sent;
              events.value = res.data.data;
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'Failed to load events.';
              emitError(msg);

            case 14:
              _context.prev = 14;
              loading.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9, 14, 17]]);
    }));
    return _loadEvents.apply(this, arguments);
  }

  function reorderEvents(_x2, _x3) {
    return _reorderEvents.apply(this, arguments);
  }

  function _reorderEvents() {
    _reorderEvents = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(orderedIds, draftId) {
      var id, res, msg, data, _msg;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = draftId != null ? draftId : currentDraftId.value;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_events__["a" /* default */].reorder(id, orderedIds);

            case 4:
              res = _context2.sent;
              msg = res.data != null && res.data.message != null ? res.data.message : 'Events order has been saved.';
              emitSuccess(msg);
              return _context2.abrupt("return", true);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              data = _context2.t0.response != null ? _context2.t0.response.data : null;
              _msg = data != null && data.message != null ? data.message : 'Failed to save order.';
              emitError(_msg);

              if (!(currentDraftId.value != null)) {
                _context2.next = 18;
                break;
              }

              _context2.next = 18;
              return loadEvents(currentDraftId.value);

            case 18:
              return _context2.abrupt("return", false);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    }));
    return _reorderEvents.apply(this, arguments);
  }

  function deleteEvent(_x4) {
    return _deleteEvent.apply(this, arguments);
  }

  function _deleteEvent() {
    _deleteEvent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(eventId) {
      var res, msg, data, _msg2;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              deleting.value = true;
              _context3.prev = 1;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_events__["a" /* default */].destroy(eventId);

            case 4:
              res = _context3.sent;
              msg = res.data != null && res.data.message != null ? res.data.message : 'The event has been deleted.';
              _context3.next = 8;
              return loadEvents(currentDraftId.value);

            case 8:
              emitSuccess(msg);
              _context3.next = 16;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              data = _context3.t0.response != null ? _context3.t0.response.data : null;
              _msg2 = data != null && data.message != null ? data.message : 'Failed to delete event.';
              emitError(_msg2);

            case 16:
              _context3.prev = 16;
              deleting.value = false;
              return _context3.finish(16);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11, 16, 19]]);
    }));
    return _deleteEvent.apply(this, arguments);
  }

  return {
    events: events,
    loading: loading,
    deleting: deleting,
    loadEvents: loadEvents,
    deleteEvent: deleteEvent,
    reorderEvents: reorderEvents
  };
}

/***/ }),

/***/ 1215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNominationLists;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useNominationLists() {
  var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
      proxy = _getCurrentInstance.proxy;

  proxy.$store.dispatch('nominations/fetchLists');
  return {
    listItems: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$store.getters['nominations/listItems'];
    }),
    defaultList: Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$store.getters['nominations/defaultList'];
    })
  };
}

/***/ }),

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabSearchBar_vue__ = __webpack_require__(1181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e38d96c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabSearchBar_vue__ = __webpack_require__(1219);
function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e38d96c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabSearchBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e38d96c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabSearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1217:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1218);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("5f78b919", content, true, {});

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".tab-search-bar__search[data-v-9e38d96c]{position:relative;flex-grow:1;min-width:220px;max-width:400px}.tab-search-bar__search .form-control[data-v-9e38d96c]{width:100%;padding-right:2rem}.tab-search-bar__icon[data-v-9e38d96c]{position:absolute;right:.6rem;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);pointer-events:none;opacity:.5}@media (max-width:768px){.tab-search-bar[data-v-9e38d96c]{flex-direction:column!important;align-items:flex-start!important}.tab-search-bar>[data-v-9e38d96c]{width:100%;margin-left:0!important;margin-right:0!important}.tab-search-bar__search[data-v-9e38d96c]{max-width:none}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/TabSearchBar.vue"],"names":[],"mappings":"AACA,yCACE,kBAAmB,AACnB,YAAa,AACb,gBAAiB,AACjB,eAAiB,CAClB,AACD,uDACE,WAAY,AACZ,kBAAoB,CACrB,AACD,uCACE,kBAAmB,AACnB,YAAc,AACd,QAAS,AACT,mCAAoC,AAC5B,2BAA4B,AACpC,oBAAqB,AACrB,UAAa,CACd,AACD,yBACA,iCACI,gCAAkC,AAClC,gCAAmC,CACtC,AACD,kCACI,WAAY,AACZ,wBAA0B,AAC1B,wBAA2B,CAC9B,AACD,yCACI,cAAgB,CACnB,CACA","file":"TabSearchBar.vue","sourcesContent":["\n.tab-search-bar__search[data-v-9e38d96c] {\n  position: relative;\n  flex-grow: 1;\n  min-width: 220px;\n  max-width: 400px;\n}\n.tab-search-bar__search .form-control[data-v-9e38d96c] {\n  width: 100%;\n  padding-right: 2rem;\n}\n.tab-search-bar__icon[data-v-9e38d96c] {\n  position: absolute;\n  right: 0.6rem;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  pointer-events: none;\n  opacity: 0.5;\n}\n@media (max-width: 768px) {\n.tab-search-bar[data-v-9e38d96c] {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n}\n.tab-search-bar > *[data-v-9e38d96c] {\n    width: 100%;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n.tab-search-bar__search[data-v-9e38d96c] {\n    max-width: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-search-bar d-flex flex-wrap align-items-center justify-content-between mb-3"},[_c('app-tab-switcher',{staticClass:"mr-3 mb-2",attrs:{"items":_vm.items,"value":_vm.activeTab},on:{"input":function($event){return _vm.$emit('tab-change', $event)}}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-end flex-grow-1 ml-3 mb-2"},[_c('label',{staticClass:"d-none d-lg-block mr-2 mb-0 font-weight-normal"},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"tab-search-bar__search"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.search},on:{"input":function($event){return _vm.$emit('search-input', $event.target.value)}}}),_vm._v(" "),_c('svg',{staticClass:"tab-search-bar__icon",attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DRAFT_STATE_OPEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DRAFT_STATE_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DRAFT_STATE_FINALISE; });
/* unused harmony export DRAFT_STATE_ON_HOLD */
// Mirror of App\Enums\DraftState (campdraftone-api)
var DRAFT_STATE_OPEN = 1;
var DRAFT_STATE_CLOSED = 3;
var DRAFT_STATE_FINALISE = 5;
var DRAFT_STATE_ON_HOLD = 6;

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Docs_DocModal__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppTooltip__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_committees_useCommitteeDrafts__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__composables_drafts_useDraftEventsDashboard__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__composables_drafts_useDraftEvents__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__composables_useYears__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_api_events__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__composables_nominations_useNominationLists__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_date__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_CommitteeDraftEventsTable__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_CommitteeDashboardNominations__ = __webpack_require__(1331);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















var COLUMNS = [{
  key: 'name',
  label: 'Name',
  width: '1fr',
  sortable: true
}, {
  key: 'noms_open',
  label: 'Noms Open',
  width: '1fr',
  sortable: true,
  mobile: 'label'
}, {
  key: 'start_date',
  label: 'Start Date',
  width: '1fr',
  sortable: true,
  mobile: 'label'
}, {
  key: 'end_date',
  label: 'End Date',
  width: '1fr',
  sortable: true,
  mobile: 'label'
}, {
  key: 'status',
  label: 'Status',
  width: '1fr',
  mobile: 'label',
  tablet: 'wrap',
  tabletWidth: '50%'
}, {
  key: 'actions',
  label: 'Actions',
  width: '0.6fr',
  tablet: 'wrap',
  tabletWidth: '25%'
}, {
  key: 'events',
  label: 'Events',
  width: '0.4fr',
  cellClass: 'text-center',
  tablet: 'wrap',
  tabletWidth: '25%'
}];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CommitteeDashboard',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FSearchSelect__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_3__components_ConfirmModal__["a" /* default */],
    DocModal: __WEBPACK_IMPORTED_MODULE_4__components_Docs_DocModal__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_16__components_FormAlert__["a" /* default */],
    GridTable: __WEBPACK_IMPORTED_MODULE_6__components_GridTable__["a" /* default */],
    AppTooltip: __WEBPACK_IMPORTED_MODULE_7__components_AppTooltip__["a" /* default */],
    CommitteeDraftEventsTable: __WEBPACK_IMPORTED_MODULE_17__components_CommitteeDraftEventsTable__["a" /* default */],
    CommitteeDashboardNominations: __WEBPACK_IMPORTED_MODULE_18__components_CommitteeDashboardNominations__["a" /* default */]
  },
  props: {
    draftId: {
      type: String,
      default: null
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy; // The result of an action on an event is shown right above that event's row (eventId) instead of
    // at the top of the events table, which is far away when the draft has many events. Actions that
    // are not tied to one event (reorder, loading) keep the notice above the table (eventId null).


    var alertEventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var subAlertSeq = 0;
    var subAlert = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
      message: null,
      type: 'success',
      eventId: null,
      id: 0
    }); // Disappears on its own after 5s, like the page-top alert (AppAlert) it replaces.

    var subAlertTimer = null;

    var showSubAlert = function showSubAlert(message, type) {
      clearTimeout(subAlertTimer);
      subAlert.value = {
        message: message,
        type: type,
        eventId: alertEventId.value,
        id: ++subAlertSeq
      };
      subAlertTimer = setTimeout(function () {
        subAlert.value = {
          message: null,
          type: 'success',
          eventId: null
        };
      }, 5000);
    };

    var clearSubAlert = function clearSubAlert() {
      clearTimeout(subAlertTimer);
      subAlert.value = {
        message: null,
        type: 'success',
        eventId: null,
        id: 0
      };
    };

    var setSubError = function setSubError(msg) {
      return showSubAlert(msg, 'warning');
    };

    var setSubSuccess = function setSubSuccess(msg) {
      return showSubAlert(msg, 'success');
    };

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(subAlertTimer);
    });

    var _useCommitteeDrafts = Object(__WEBPACK_IMPORTED_MODULE_8__composables_committees_useCommitteeDrafts__["a" /* default */])(),
        drafts = _useCommitteeDrafts.drafts,
        loading = _useCommitteeDrafts.loading,
        params = _useCommitteeDrafts.params,
        fetch = _useCommitteeDrafts.fetch,
        setYear = _useCommitteeDrafts.setYear,
        setSort = _useCommitteeDrafts.setSort;

    var _useDraftEventsDashbo = Object(__WEBPACK_IMPORTED_MODULE_9__composables_drafts_useDraftEventsDashboard__["a" /* default */])({
      onError: setSubError,
      onSuccess: setSubSuccess
    }),
        openDraftId = _useDraftEventsDashbo.openDraftId,
        events = _useDraftEventsDashbo.events,
        totals = _useDraftEventsDashbo.totals,
        loadingEvents = _useDraftEventsDashbo.loadingEvents,
        toggle = _useDraftEventsDashbo.toggle,
        reload = _useDraftEventsDashbo.reload,
        lockEvent = _useDraftEventsDashbo.lockEvent;

    var _useDraftEvents = Object(__WEBPACK_IMPORTED_MODULE_10__composables_drafts_useDraftEvents__["a" /* default */])({
      onError: setSubError,
      onSuccess: setSubSuccess
    }),
        deleting = _useDraftEvents.deleting,
        deleteEvent = _useDraftEvents.deleteEvent,
        reorderEvents = _useDraftEvents.reorderEvents;

    var years = Object(__WEBPACK_IMPORTED_MODULE_11__composables_useYears__["a" /* default */])();

    var _useNominationLists = Object(__WEBPACK_IMPORTED_MODULE_14__composables_nominations_useNominationLists__["a" /* default */])(),
        listTabItems = _useNominationLists.listItems,
        defaultList = _useNominationLists.defaultList;

    var eventToDelete = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var eventToSplit = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var showSplitInfo = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var splitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var reorderingEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var nominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var loadingNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var nominationFilters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
      event_id: null,
      list: defaultList.value,
      search: ''
    });
    var nominationEvent = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (nominationFilters.event_id == null) return null;
      return events.value.find(function (e) {
        return e.id === nominationFilters.event_id;
      }) || null;
    });
    var nominationSearchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(''); // Local-only collapse of the open draft's events subtable — toggled by the +/- icon
    // without touching the URL, and reset so the subtable is expanded on each navigation.

    var eventsCollapsed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var visibleOpenDraftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return eventsCollapsed.value ? null : openDraftId.value;
    });
    var openDraftEventMembersAllowed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (openDraftId.value == null) return false;
      var draft = drafts.value.find(function (d) {
        return d.id === openDraftId.value;
      });
      return draft != null ? !!draft.event_members_allowed : false;
    });
    var openDraftStateId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (openDraftId.value == null) return null;
      var draft = drafts.value.find(function (d) {
        return d.id === openDraftId.value;
      });
      return draft != null && draft.state != null ? draft.state.id : null;
    });
    var nominationSearchTimer = null;

    function fetchNominations() {
      return _fetchNominations.apply(this, arguments);
    }

    function _fetchNominations() {
      _fetchNominations = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var query, res, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(openDraftId.value == null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                loadingNominations.value = true;
                _context2.prev = 3;
                query = {};
                if (nominationFilters.event_id != null) query.event_id = nominationFilters.event_id;
                if (nominationFilters.list) query.list = nominationFilters.list;
                if (nominationFilters.search) query.search = nominationFilters.search;
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__["a" /* default */].getDashboard(String(openDraftId.value), query);

              case 10:
                res = _context2.sent;
                data = res.data.data;
                nominations.value = data.nominations != null ? data.nominations : data;
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](3);
                nominations.value = [];

              case 18:
                _context2.prev = 18;
                loadingNominations.value = false;
                return _context2.finish(18);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 15, 18, 21]]);
      }));
      return _fetchNominations.apply(this, arguments);
    }

    function moveGroup(_x, _x2) {
      return _moveGroup.apply(this, arguments);
    } // Nomination list moves change per-event counts in the events subtable,
    // so reload events together with the nominations list.


    function _moveGroup() {
      _moveGroup = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(group, list) {
        var ids;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ids = group.nominations.map(function (n) {
                  return n.id;
                });
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__services_api_nominations__["a" /* default */].bulkMove({
                  nomination_ids: ids,
                  list: list
                });

              case 3:
                _context3.next = 5;
                return fetchNominations();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _moveGroup.apply(this, arguments);
    }

    function onNominationsReload() {
      fetchNominations();
      reload();
    }

    function handleRouteChange(_x3) {
      return _handleRouteChange.apply(this, arguments);
    }

    function _handleRouteChange() {
      _handleRouteChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(route) {
        var draftId, numId, q;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                draftId = route.params.draftId;

                if (!(draftId == null || draftId === '')) {
                  _context4.next = 10;
                  break;
                }

                openDraftId.value = null;
                events.value = [];
                nominations.value = [];
                nominationFilters.event_id = null;
                nominationFilters.list = defaultList.value;
                nominationFilters.search = '';
                nominationSearchInput.value = '';
                return _context4.abrupt("return");

              case 10:
                numId = Number(draftId);

                if (!(openDraftId.value !== numId)) {
                  _context4.next = 15;
                  break;
                }

                eventsCollapsed.value = false;
                _context4.next = 15;
                return toggle(numId);

              case 15:
                q = route.query;
                nominationFilters.event_id = q.event_id != null ? Number(q.event_id) : null;
                nominationFilters.list = q.list != null ? q.list : defaultList.value;
                nominationFilters.search = q.search != null ? q.search : '';
                nominationSearchInput.value = nominationFilters.search;
                fetchNominations();

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _handleRouteChange.apply(this, arguments);
    }

    function onListChange(list) {
      nominationFilters.list = list;
      proxy.$router.replace({
        name: proxy.$route.name,
        params: proxy.$route.params,
        query: _objectSpread({}, proxy.$route.query, {
          list: list
        })
      }).catch(function () {});
    }

    function onSearchInput(val) {
      nominationSearchInput.value = val;
      clearTimeout(nominationSearchTimer);
      nominationSearchTimer = setTimeout(function () {
        var query = _objectSpread({}, proxy.$route.query);

        if (val) query.search = val;else delete query.search;
        proxy.$router.replace({
          name: proxy.$route.name,
          params: proxy.$route.params,
          query: query
        }).catch(function () {});
      }, 300);
    }

    function confirmDelete(event) {
      eventToDelete.value = event;
    }

    function onLock(eventId, isLocked) {
      alertEventId.value = eventId;
      return lockEvent(eventId, isLocked);
    } // The deleted row is gone by the time the result is shown, so the notice goes above the event
    // that followed it (or the one before it when it was the last).


    function neighbourEventId(eventId) {
      var list = events.value;
      var index = list.findIndex(function (e) {
        return e.id === eventId;
      });
      if (index === -1) return null;
      var next = list.slice(index + 1).find(function (e) {
        return e.parent_id == null || e.parent_id !== list[index].id;
      });
      var previous = list.slice(0, index).reverse().find(function (e) {
        return e.id !== list[index].parent_id;
      });
      return (next || previous || {}).id != null ? (next || previous).id : null;
    }

    function confirmSplit(event) {
      eventToSplit.value = event;
    }

    function handleSplit() {
      return _handleSplit.apply(this, arguments);
    }

    function _handleSplit() {
      _handleSplit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var res, msg;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(eventToSplit.value == null)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                splitting.value = true;
                alertEventId.value = eventToSplit.value.id;
                clearTimeout(subAlertTimer);
                subAlert.value = {
                  message: null,
                  type: 'success',
                  eventId: null
                };
                _context5.prev = 6;
                _context5.next = 9;
                return __WEBPACK_IMPORTED_MODULE_13__services_api_events__["a" /* default */].split(eventToSplit.value.id);

              case 9:
                res = _context5.sent;
                eventToSplit.value = null;
                _context5.next = 13;
                return reload();

              case 13:
                setSubSuccess(res.data.message || 'Event split successfully.');
                _context5.next = 21;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5["catch"](6);
                msg = _context5.t0.response != null && _context5.t0.response.data != null ? _context5.t0.response.data.message : 'Failed to split event.';
                eventToSplit.value = null;
                setSubError(msg);

              case 21:
                _context5.prev = 21;
                splitting.value = false;
                return _context5.finish(21);

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[6, 16, 21, 24]]);
      }));
      return _handleSplit.apply(this, arguments);
    }

    function handleDelete() {
      return _handleDelete.apply(this, arguments);
    }

    function _handleDelete() {
      _handleDelete = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        var id;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (eventToDelete.value) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                id = eventToDelete.value.id;
                eventToDelete.value = null;
                alertEventId.value = neighbourEventId(id);
                _context6.next = 7;
                return deleteEvent(id);

              case 7:
                _context6.next = 9;
                return reload();

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _handleDelete.apply(this, arguments);
    }

    function onDragEnd(_x4) {
      return _onDragEnd.apply(this, arguments);
    }

    function _onDragEnd() {
      _onDragEnd = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(orderedIds) {
        var movedId,
            previousEvents,
            eventsById,
            reorderedEvents,
            saved,
            _args7 = arguments;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                movedId = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;

                if (!reorderingEvents.value) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return");

              case 3:
                alertEventId.value = movedId;
                previousEvents = _toConsumableArray(events.value);
                eventsById = new Map(events.value.map(function (event) {
                  return [event.id, event];
                }));
                reorderedEvents = orderedIds.map(function (id) {
                  return eventsById.get(id);
                }).filter(Boolean);

                if (!(reorderedEvents.length !== events.value.length)) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 10;
                return reload();

              case 10:
                return _context7.abrupt("return");

              case 11:
                events.value = reorderedEvents;
                reorderingEvents.value = true;
                _context7.prev = 13;
                _context7.next = 16;
                return reorderEvents(orderedIds, openDraftId.value);

              case 16:
                saved = _context7.sent;

                if (saved) {
                  _context7.next = 21;
                  break;
                }

                events.value = previousEvents;
                _context7.next = 21;
                return reload();

              case 21:
                _context7.prev = 21;
                reorderingEvents.value = false;
                return _context7.finish(21);

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[13,, 21, 24]]);
      }));
      return _onDragEnd.apply(this, arguments);
    }

    function redirectToDefaultDraft() {
      if (drafts.value.length === 0) return;
      var now = new Date();
      var activeDrafts = drafts.value.filter(function (draft) {
        return new Date(draft.start_date) <= now && now <= new Date(draft.end_date);
      });
      var candidates = activeDrafts.length > 0 ? activeDrafts : drafts.value;
      var targetDraft = candidates.reduce(function (newest, draft) {
        return new Date(draft.start_date) > new Date(newest.start_date) ? draft : newest;
      });
      proxy.$router.replace({
        name: 'Committees Dashboard',
        params: {
          draftId: String(targetDraft.id)
        },
        query: proxy.$route.query
      }).catch(function () {});
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return proxy.$route.fullPath;
    }, function () {
      if (proxy.$route.params.draftId == null || proxy.$route.params.draftId === '') {
        redirectToDefaultDraft();
        return;
      }

      handleRouteChange(proxy.$route);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch();

            case 2:
              if (!props.draftId) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return handleRouteChange(proxy.$route);

            case 5:
              return _context.abrupt("return");

            case 6:
              redirectToDefaultDraft();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return {
      columns: COLUMNS,
      drafts: drafts,
      loading: loading,
      params: params,
      years: years,
      setYear: setYear,
      setSort: setSort,
      openDraftId: openDraftId,
      visibleOpenDraftId: visibleOpenDraftId,
      eventsCollapsed: eventsCollapsed,
      events: events,
      totals: totals,
      loadingEvents: loadingEvents,
      lockEvent: lockEvent,
      eventToDelete: eventToDelete,
      deleting: deleting,
      confirmDelete: confirmDelete,
      handleDelete: handleDelete,
      subAlert: subAlert,
      clearSubAlert: clearSubAlert,
      onLock: onLock,
      eventToSplit: eventToSplit,
      showSplitInfo: showSplitInfo,
      splitting: splitting,
      confirmSplit: confirmSplit,
      handleSplit: handleSplit,
      onDragEnd: onDragEnd,
      reorderingEvents: reorderingEvents,
      formatDate: __WEBPACK_IMPORTED_MODULE_15__utils_date__["a" /* formatDate */],
      formatDateTime: __WEBPACK_IMPORTED_MODULE_15__utils_date__["b" /* formatDateTime */],
      nominations: nominations,
      loadingNominations: loadingNominations,
      nominationEvent: nominationEvent,
      nominationFilters: nominationFilters,
      nominationSearchInput: nominationSearchInput,
      listTabItems: listTabItems,
      onListChange: onListChange,
      onSearchInput: onSearchInput,
      moveGroup: moveGroup,
      fetchNominations: fetchNominations,
      onNominationsReload: onNominationsReload,
      openDraftEventMembersAllowed: openDraftEventMembersAllowed,
      openDraftStateId: openDraftStateId
    };
  }
}));

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppTooltip__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RowAlert__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_eventSplitKind__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_eventGroups__ = __webpack_require__(1168);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var COLUMNS = [{
  key: 'drag',
  label: '',
  width: '50px',
  mobileWidth: '32px',
  cellClass: 'valign-center text-center'
}, {
  key: 'name',
  label: 'Event Name',
  width: '1fr',
  primary: true
}, {
  key: 'final_noms',
  label: 'Final Noms',
  width: '1fr',
  mobile: 'label',
  cellClass: 'text-center'
}, {
  key: 'total_noms',
  label: 'Total Noms',
  width: '1fr',
  mobile: 'label',
  cellClass: 'text-center'
}, {
  key: 'unprocessed',
  label: 'Unprocessed',
  width: '1fr',
  mobile: 'label',
  cellClass: 'text-center'
}, {
  key: 'accepted',
  label: 'Accepted',
  width: '1fr',
  mobile: 'label',
  cellClass: 'text-center'
}, {
  key: 'wait_list',
  label: 'Waitlist',
  width: '1fr',
  mobile: 'label',
  cellClass: 'text-center'
}, {
  key: 'scratched',
  label: 'Scratched',
  width: '1fr',
  mobile: 'label',
  cellClass: 'text-center'
}, {
  key: 'actions',
  label: 'Actions',
  width: '1fr',
  mobileWidth: '76px',
  cellClass: 'valign-center'
}];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CommitteeDraftEventsTable',
  components: {
    GridTable: __WEBPACK_IMPORTED_MODULE_1__components_GridTable__["a" /* default */],
    AppTooltip: __WEBPACK_IMPORTED_MODULE_2__components_AppTooltip__["a" /* default */],
    RowAlert: __WEBPACK_IMPORTED_MODULE_3__components_RowAlert__["a" /* default */]
  },
  props: {
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    totals: {
      type: Object,
      default: null
    },
    loadingEvents: {
      type: Boolean,
      default: false
    },
    reordering: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    },
    draftId: {
      type: Number,
      required: true
    },
    draftStateId: {
      type: Number,
      default: null
    },
    activeEventId: {
      type: Number,
      default: null
    },
    list: {
      type: String,
      default: null
    },
    // { message, type, eventId } — the result of an action, shown above the event it was done on
    alert: {
      type: Object,
      default: null
    }
  },
  emits: ['lock', 'drag-end', 'confirm-delete', 'confirm-split', 'dismiss-alert'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var DRAFT_STATE_FINALISE = 5;

    function canSplit(row) {
      return row.brother_id === null && row.rounds === 2 && props.draftStateId === DRAFT_STATE_FINALISE;
    }

    function splitTitle(row) {
      if (row.brother_id !== null) return 'Event already split';
      if (row.rounds !== 2) return 'Only 2-round events can be split';
      if (props.draftStateId !== DRAFT_STATE_FINALISE) return 'Split is only available when draft is in Finalise state';
      return 'Split event into A and B';
    }

    function eventLink(eventId) {
      var query = {};
      if (props.list) query.list = props.list;
      query.event_id = String(eventId);
      return {
        name: 'Committees Dashboard',
        params: {
          draftId: String(props.draftId)
        },
        query: query
      };
    }

    var groups = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils_eventGroups__["a" /* buildEventGroups */])(props.events);
    }); // Only top-level rows can carry the notice (rows inside a unit live in a nested sortable),
    // so a child event's notice goes above its parent row.

    var anchorRowId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!props.alert || props.alert.eventId == null) return null;
      var event = props.events.find(function (e) {
        return e.id === props.alert.eventId;
      });
      return event && event.parent_id != null ? event.parent_id : props.alert.eventId;
    }); // The totals row sits below the groups and is never draggable.

    var totalsRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.totals ? [_objectSpread({
        id: 'totals'
      }, props.totals)] : [];
    }); // Every top-level row (the original, its B half, a conjunction final) drags the whole group;
    // children only reorder inside their own parent.

    var groupSizes = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var sizes = new Map();
      groups.value.forEach(function (group) {
        var size = Object(__WEBPACK_IMPORTED_MODULE_5__utils_eventGroups__["c" /* flattenEventGroups */])([group]).length;
        group.units.forEach(function (unit) {
          return sizes.set(unit.row.id, size);
        });
      });
      return sizes;
    });

    function dragKind(row) {
      if (row.id === 'totals') return null;
      return row.parent_id != null ? 'child' : 'group';
    }

    function dragTitle(row) {
      if (props.reordering) return 'Saving event order';
      if (dragKind(row) === 'child') return 'Drag to reorder within the group';
      return groupSizes.value.get(row.id) > 1 ? 'Drag to move the whole group' : 'Drag to reorder';
    }

    function onDragEnd(orderedIds, movedId) {
      emit('drag-end', orderedIds, movedId);
    }

    return {
      columns: COLUMNS,
      anchorRowId: anchorRowId,
      eventLink: eventLink,
      canSplit: canSplit,
      splitTitle: splitTitle,
      groups: groups,
      totalsRows: totalsRows,
      dragKind: dragKind,
      dragTitle: dragTitle,
      onDragEnd: onDragEnd,
      EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL: __WEBPACK_IMPORTED_MODULE_4__constants_eventSplitKind__["a" /* EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL */]
    };
  }
}));

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabSearchBar__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BulkEditorTool__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RowAlert__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_useRowAlert__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FormFields_FRadioGroup__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Nominations_components_NominationsDashboardTable__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Nominations_components_NominationAccountDetailPopup__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__composables_nominations_useNominationLists__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__composables_useFormAlert__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_api_invoices__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_api_biosecurity__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_api_reports__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_api_draws__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_nominationMove__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CommitteePartialPaymentPopup__ = __webpack_require__(1344);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CommitteeDashboardNominations',
  components: {
    TabSearchBar: __WEBPACK_IMPORTED_MODULE_1__components_TabSearchBar__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_2__components_AppButton__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_3__components_AppMultiselect__["a" /* default */],
    BulkEditorTool: __WEBPACK_IMPORTED_MODULE_4__components_BulkEditorTool__["a" /* default */],
    NominationsDashboardTable: __WEBPACK_IMPORTED_MODULE_11__views_Nominations_components_NominationsDashboardTable__["a" /* default */],
    NominationAccountDetailPopup: __WEBPACK_IMPORTED_MODULE_12__views_Nominations_components_NominationAccountDetailPopup__["a" /* default */],
    CommitteePartialPaymentPopup: __WEBPACK_IMPORTED_MODULE_21__CommitteePartialPaymentPopup__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__["a" /* default */],
    RowAlert: __WEBPACK_IMPORTED_MODULE_6__components_RowAlert__["a" /* default */],
    FRadioGroup: __WEBPACK_IMPORTED_MODULE_8__components_FormFields_FRadioGroup__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_9__components_ConfirmModal__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_10__components_Modal__["a" /* default */]
  },
  props: {
    draftId: {
      type: Number,
      required: true
    },
    draftStateId: {
      type: Number,
      default: null
    },
    nominations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loadingNominations: {
      type: Boolean,
      default: false
    },
    listTabItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    activeList: {
      type: String,
      default: null
    },
    searchInput: {
      type: String,
      default: ''
    },
    drawIsPublished: {
      type: Boolean,
      default: false
    },
    eventMembersAllowed: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: null
    },
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['list-change', 'search-input', 'reload'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useNominationLists = Object(__WEBPACK_IMPORTED_MODULE_13__composables_nominations_useNominationLists__["a" /* default */])(),
        listItems = _useNominationLists.listItems;

    var moveableLists = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return listItems.value.filter(function (l) {
        return l.value !== 'scratchedByUser';
      });
    });
    var isLocked = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.event != null && !!props.event.is_locked;
    });
    var tableErrorKey = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);
    var partialPaymentTarget = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var partialPaymentHasChanges = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function onOpenPartialPayment(row) {
      var commits = row.nominations.map(function (n) {
        return n.commit;
      }).filter(function (commit) {
        return commit != null;
      });
      var uniqueCommits = commits.filter(function (commit, index) {
        return commits.indexOf(commit) === index;
      });
      partialPaymentHasChanges.value = false;
      partialPaymentTarget.value = {
        userId: row.user.id,
        paymentType: uniqueCommits.length === 1 ? uniqueCommits[0] : null
      };
    }

    function closePartialPayment() {
      partialPaymentTarget.value = null;
      tableErrorKey.value++;
    }

    function markPartialPaymentChanged() {
      partialPaymentHasChanges.value = true;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return partialPaymentTarget.value;
    }, function (val, prev) {
      if (prev != null && val == null && partialPaymentHasChanges.value) emit('reload');
    });
    var detailTarget = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var detailHasChanges = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function onOpenDetail(row) {
      detailHasChanges.value = false;
      detailTarget.value = {
        userId: row.user.id,
        list: props.activeList,
        eventId: props.event != null ? props.event.id : null
      };
    }

    function closeDetail() {
      detailTarget.value = null;
    }

    function markDetailChanged() {
      detailHasChanges.value = true;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return detailTarget.value;
    }, function (val, prev) {
      if (prev != null && val == null && detailHasChanges.value) emit('reload');
    });
    var commitOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].getCommits().then(function (res) {
      commitOptions.value = res.data.data;
    });
    var paymentStatusOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].getPaymentStatuses().then(function (res) {
      paymentStatusOptions.value = res.data.data;
    }); // Monolith parity: accept tab filters rows client-side by fully-paid status.

    var paymentFilterOptions = [{
      value: 'all',
      label: 'all'
    }, {
      value: 'paid',
      label: 'paid'
    }, {
      value: 'unpaid',
      label: 'unpaid'
    }];
    var paymentFilter = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('all');
    var filteredNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (props.activeList !== 'accept' || paymentFilter.value === 'all') return props.nominations;
      var wantPaid = paymentFilter.value === 'paid';
      return props.nominations.filter(function (g) {
        var fullyPaid = g.nominations.length > 0 && g.nominations.every(function (n) {
          return n.is_paid;
        });
        return wantPaid ? fullyPaid : !fullyPaid;
      });
    });
    var bulkAlert = Object(__WEBPACK_IMPORTED_MODULE_14__composables_useFormAlert__["a" /* default */])(); // Results of actions on one nomination row appear right above that row (not above the table);
    // bulk actions, which are not tied to one row, keep using bulkAlert.

    var rowAlert = Object(__WEBPACK_IMPORTED_MODULE_7__composables_useRowAlert__["a" /* default */])(); // A moved row leaves the current list once the list reloads, so its message goes above the row
    // that takes its place (the next one, or the previous when it was the last).

    function neighbourUserId(userId) {
      var list = filteredNominations.value;
      var index = list.findIndex(function (g) {
        return g.user.id === userId;
      });
      if (index === -1) return null;
      var neighbour = list[index + 1] || list[index - 1];
      return neighbour != null ? neighbour.user.id : null;
    }

    function notifyRow(rowUserId, message, type, options) {
      if (rowUserId == null) {
        if (type === 'success') bulkAlert.showSuccess(message);else if (options && options.persistent) bulkAlert.showPersistentError(message);else bulkAlert.showError(message);
        return;
      }

      bulkAlert.clear();
      rowAlert.show(message, type, rowUserId, options);
    }

    function onPartialPaymentSuccess(message) {
      notifyRow(partialPaymentTarget.value != null ? partialPaymentTarget.value.userId : null, message != null ? message : 'Success', 'success');
    } // Competitors that block a move-to-accept because they are already accepted into an
    // overlapping draft (structured payload from the API's `overlapping_accept` error).


    var blockedAccept = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var selectedGroupUserIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var bulkList = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var applyingBulk = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var bulkComment = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var applyingBulkComment = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var bulkPaymentStatus = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var applyingBulkPayment = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.activeList;
    }, function () {
      selectedGroupUserIds.value = [];
      paymentFilter.value = 'all';
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(paymentFilter, function () {
      selectedGroupUserIds.value = [];
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.nominations;
    }, function () {
      var currentIds = props.nominations.map(function (g) {
        return g.user.id;
      });
      selectedGroupUserIds.value = selectedGroupUserIds.value.filter(function (id) {
        return currentIds.indexOf(id) !== -1;
      });
    });

    function toggleSelect(userId) {
      var idx = selectedGroupUserIds.value.indexOf(userId);

      if (idx === -1) {
        selectedGroupUserIds.value = [].concat(_toConsumableArray(selectedGroupUserIds.value), [userId]);
      } else {
        selectedGroupUserIds.value = selectedGroupUserIds.value.filter(function (id) {
          return id !== userId;
        });
      }
    }

    function toggleSelectAll() {
      if (selectedGroupUserIds.value.length === filteredNominations.value.length) {
        selectedGroupUserIds.value = [];
      } else {
        selectedGroupUserIds.value = filteredNominations.value.map(function (g) {
          return g.user.id;
        });
      }
    } // Monolith parity: moving noms to accepted requires confirmation when the
    // draft is in Finalise (invoices are sent immediately) or Closed with
    // generated draws (the nomination will not be added to the draw).


    var pendingMove = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var drawExists = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.draftId;
    },
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(id) {
        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                drawExists.value = false;

                if (!(id == null)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].draft(id);

              case 6:
                res = _context.sent;
                data = res.data.data;
                drawExists.value = data != null ? !!data.draw_exists : false;
                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      immediate: true
    });

    function handleBulkMoveError(err) {
      var rowUserId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = err.response != null ? err.response.data : null; // Structured "already accepted into an overlapping draft" list — render it as its own
      // panel (each name gets a search action) instead of a flat, auto-dismissing alert.

      if (data != null && Array.isArray(data.blocked) && data.blocked.length > 0) {
        blockedAccept.value = data.blocked;
        bulkAlert.clear();
        return;
      }

      blockedAccept.value = [];
      var msg = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
      notifyRow(rowUserId, msg, 'warning', {
        persistent: true
      });
    }

    function doMoveGroup(_x2, _x3) {
      return _doMoveGroup.apply(this, arguments);
    }

    function _doMoveGroup() {
      _doMoveGroup = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(group, list) {
        var ids, successAnchor, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = group.nominations.map(function (n) {
                  return n.id;
                });
                successAnchor = neighbourUserId(group.user.id);
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].bulkMove({
                  nomination_ids: ids,
                  list: list
                });

              case 5:
                res = _context2.sent;
                blockedAccept.value = [];
                notifyRow(successAnchor, res.data.message, 'success');
                emit('reload');
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                handleBulkMoveError(_context2.t0, group.user.id);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11]]);
      }));
      return _doMoveGroup.apply(this, arguments);
    }

    function handleMoveGroup(_x4, _x5) {
      return _handleMoveGroup.apply(this, arguments);
    }

    function _handleMoveGroup() {
      _handleMoveGroup = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(group, list) {
        var fromList, warning;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fromList = group.list != null ? group.list : props.activeList;
                warning = Object(__WEBPACK_IMPORTED_MODULE_20__utils_nominationMove__["c" /* moveWarningType */])(fromList, list, props.draftStateId, drawExists.value);

                if (!(warning != null)) {
                  _context3.next = 5;
                  break;
                }

                pendingMove.value = {
                  type: 'group',
                  group: group,
                  list: list,
                  warning: warning
                };
                return _context3.abrupt("return");

              case 5:
                _context3.next = 7;
                return doMoveGroup(group, list);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _handleMoveGroup.apply(this, arguments);
    }

    function doApplyBulkStatus() {
      return _doApplyBulkStatus.apply(this, arguments);
    }

    function _doApplyBulkStatus() {
      _doApplyBulkStatus = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ids = props.nominations.filter(function (g) {
                  return selectedGroupUserIds.value.indexOf(g.user.id) !== -1;
                }).reduce(function (acc, g) {
                  return acc.concat(g.nominations.map(function (n) {
                    return n.id;
                  }));
                }, []);
                applyingBulk.value = true;
                _context4.prev = 2;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].bulkMove({
                  nomination_ids: ids,
                  list: bulkList.value.value
                });

              case 5:
                res = _context4.sent;
                blockedAccept.value = [];
                bulkAlert.showSuccess(res.data.message);
                bulkList.value = null;
                emit('reload');
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);
                handleBulkMoveError(_context4.t0);

              case 15:
                _context4.prev = 15;
                applyingBulk.value = false;
                return _context4.finish(15);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 12, 15, 18]]);
      }));
      return _doApplyBulkStatus.apply(this, arguments);
    }

    function applyBulkStatus() {
      if (bulkList.value == null || selectedGroupUserIds.value.length === 0) return;
      var warning = Object(__WEBPACK_IMPORTED_MODULE_20__utils_nominationMove__["c" /* moveWarningType */])(props.activeList, bulkList.value.value, props.draftStateId, drawExists.value);

      if (warning != null) {
        pendingMove.value = {
          type: 'bulk',
          warning: warning
        };
        return;
      }

      doApplyBulkStatus();
    }

    function confirmPendingMove() {
      return _confirmPendingMove.apply(this, arguments);
    }

    function _confirmPendingMove() {
      _confirmPendingMove = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var pending;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                pending = pendingMove.value;
                pendingMove.value = null;

                if (!(pending == null)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                if (!(pending.type === 'bulk')) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 7;
                return doApplyBulkStatus();

              case 7:
                _context5.next = 11;
                break;

              case 9:
                _context5.next = 11;
                return doMoveGroup(pending.group, pending.list);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _confirmPendingMove.apply(this, arguments);
    }

    function onRowCommitChange(_x6, _x7) {
      return _onRowCommitChange.apply(this, arguments);
    }

    function _onRowCommitChange() {
      _onRowCommitChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(row, commit) {
        var ids, res, msg;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ids = row.nominations.map(function (n) {
                  return n.id;
                });
                _context6.prev = 1;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].updateCommit(props.draftId, {
                  ids: ids,
                  commit: commit
                });

              case 4:
                res = _context6.sent;
                notifyRow(row.user.id, res.data.message, 'success');
                emit('reload');
                _context6.next = 14;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](1);
                tableErrorKey.value++;
                msg = _context6.t0.response != null && _context6.t0.response.data != null && _context6.t0.response.data.message != null ? _context6.t0.response.data.message : 'A server error occurred. Please try again later.';
                notifyRow(row.user.id, msg, 'warning');

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 9]]);
      }));
      return _onRowCommitChange.apply(this, arguments);
    }

    function applyBulkComment() {
      return _applyBulkComment.apply(this, arguments);
    }

    function _applyBulkComment() {
      _applyBulkComment = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7() {
        var ids, res, msg;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(bulkComment.value == null || selectedGroupUserIds.value.length === 0)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                ids = props.nominations.filter(function (g) {
                  return selectedGroupUserIds.value.indexOf(g.user.id) !== -1;
                }).reduce(function (acc, g) {
                  return acc.concat(g.nominations.map(function (n) {
                    return n.id;
                  }));
                }, []);
                applyingBulkComment.value = true;
                _context7.prev = 4;
                _context7.next = 7;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].updateCommit(props.draftId, {
                  ids: ids,
                  commit: bulkComment.value.value
                });

              case 7:
                res = _context7.sent;
                bulkAlert.showSuccess(res.data.message);
                bulkComment.value = null;
                emit('reload');
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](4);
                msg = _context7.t0.response != null && _context7.t0.response.data != null && _context7.t0.response.data.message != null ? _context7.t0.response.data.message : 'A server error occurred. Please try again later.';
                bulkAlert.showError(msg);

              case 17:
                _context7.prev = 17;
                applyingBulkComment.value = false;
                return _context7.finish(17);

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[4, 13, 17, 20]]);
      }));
      return _applyBulkComment.apply(this, arguments);
    }

    function onRowPaymentStatusChange(_x8, _x9) {
      return _onRowPaymentStatusChange.apply(this, arguments);
    }

    function _onRowPaymentStatusChange() {
      _onRowPaymentStatusChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(row, isPaid) {
        var items, res, msg;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                items = row.nominations.map(function (n) {
                  return {
                    id: n.id,
                    is_paid: isPaid
                  };
                });
                _context8.prev = 1;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].updatePaymentStatus(props.draftId, {
                  items: items
                });

              case 4:
                res = _context8.sent;
                notifyRow(row.user.id, res.data.message, 'success');
                emit('reload');
                _context8.next = 14;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](1);
                tableErrorKey.value++;
                msg = _context8.t0.response != null && _context8.t0.response.data != null && _context8.t0.response.data.message != null ? _context8.t0.response.data.message : 'A server error occurred. Please try again later.';
                notifyRow(row.user.id, msg, 'warning');

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[1, 9]]);
      }));
      return _onRowPaymentStatusChange.apply(this, arguments);
    }

    function applyBulkPaymentStatus() {
      return _applyBulkPaymentStatus.apply(this, arguments);
    }

    function _applyBulkPaymentStatus() {
      _applyBulkPaymentStatus = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee9() {
        var items, res, msg;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(bulkPaymentStatus.value == null || selectedGroupUserIds.value.length === 0)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                items = props.nominations.filter(function (g) {
                  return selectedGroupUserIds.value.indexOf(g.user.id) !== -1;
                }).reduce(function (acc, g) {
                  return acc.concat(g.nominations.map(function (n) {
                    return {
                      id: n.id,
                      is_paid: bulkPaymentStatus.value.value
                    };
                  }));
                }, []);
                applyingBulkPayment.value = true;
                _context9.prev = 4;
                _context9.next = 7;
                return __WEBPACK_IMPORTED_MODULE_15__services_api_nominations__["a" /* default */].updatePaymentStatus(props.draftId, {
                  items: items
                });

              case 7:
                res = _context9.sent;
                bulkAlert.showSuccess(res.data.message);
                bulkPaymentStatus.value = null;
                emit('reload');
                _context9.next = 17;
                break;

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9["catch"](4);
                msg = _context9.t0.response != null && _context9.t0.response.data != null && _context9.t0.response.data.message != null ? _context9.t0.response.data.message : 'A server error occurred. Please try again later.';
                bulkAlert.showError(msg);

              case 17:
                _context9.prev = 17;
                applyingBulkPayment.value = false;
                return _context9.finish(17);

              case 20:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[4, 13, 17, 20]]);
      }));
      return _applyBulkPaymentStatus.apply(this, arguments);
    }

    function onListChange(list) {
      bulkAlert.clear();
      rowAlert.clear();
      blockedAccept.value = [];
      emit('list-change', list);
    }

    function searchBlocked(competitor) {
      // Populate the nominations search with this competitor's name so the secretary
      // can jump straight to their row and move them off the accept list.
      emit('search-input', competitor.name);
    }

    function dismissBlockedAccept() {
      blockedAccept.value = [];
    }

    var downloadingBiosecurityPdf = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var downloadingBiosecurityCsv = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var downloadingVehiclesPdf = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function triggerDownload(res, fallbackName) {
      var disposition = res.headers['content-disposition'];
      var filename = fallbackName;

      if (disposition) {
        var match = disposition.match(/filename="?([^"]+)"?/);
        if (match) filename = match[1];
      }

      var url = URL.createObjectURL(new Blob([res.data]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }

    function downloadBiosecurityReport(_x10) {
      return _downloadBiosecurityReport.apply(this, arguments);
    }

    function _downloadBiosecurityReport() {
      _downloadBiosecurityReport = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee10(format) {
        var loading, res, blobUrl;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                loading = format === 'pdf' ? downloadingBiosecurityPdf : downloadingBiosecurityCsv;
                loading.value = true;
                _context10.prev = 2;
                _context10.next = 5;
                return __WEBPACK_IMPORTED_MODULE_17__services_api_biosecurity__["a" /* default */].downloadReport(props.draftId, format);

              case 5:
                res = _context10.sent;

                if (format === 'pdf') {
                  blobUrl = URL.createObjectURL(new Blob([res.data], {
                    type: 'application/pdf'
                  }));
                  window.open(blobUrl, '_blank');
                } else {
                  triggerDownload(res, "biosecurity-report.".concat(format));
                }

                _context10.next = 11;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](2);

              case 11:
                _context10.prev = 11;
                loading.value = false;
                return _context10.finish(11);

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[2, 9, 11, 14]]);
      }));
      return _downloadBiosecurityReport.apply(this, arguments);
    }

    function downloadVehiclesReport() {
      return _downloadVehiclesReport.apply(this, arguments);
    }

    function _downloadVehiclesReport() {
      _downloadVehiclesReport = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee11() {
        var res, blobUrl;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                downloadingVehiclesPdf.value = true;
                _context11.prev = 1;
                _context11.next = 4;
                return __WEBPACK_IMPORTED_MODULE_18__services_api_reports__["a" /* default */].downloadVehiclesPdf(props.draftId);

              case 4:
                res = _context11.sent;
                blobUrl = URL.createObjectURL(new Blob([res.data], {
                  type: 'application/pdf'
                }));
                window.open(blobUrl, '_blank');
                _context11.next = 11;
                break;

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](1);

              case 11:
                _context11.prev = 11;
                downloadingVehiclesPdf.value = false;
                return _context11.finish(11);

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[1, 9, 11, 14]]);
      }));
      return _downloadVehiclesReport.apply(this, arguments);
    }

    var sendingReminders = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function sendOverdueReminders() {
      return _sendOverdueReminders.apply(this, arguments);
    }

    function _sendOverdueReminders() {
      _sendOverdueReminders = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee12() {
        var res, msg;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                sendingReminders.value = true;
                _context12.prev = 1;
                _context12.next = 4;
                return __WEBPACK_IMPORTED_MODULE_16__services_api_invoices__["a" /* default */].remind(props.draftId);

              case 4:
                res = _context12.sent;
                bulkAlert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Reminders queued');
                _context12.next = 12;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](1);
                msg = _context12.t0.response != null && _context12.t0.response.data != null && _context12.t0.response.data.message != null ? _context12.t0.response.data.message : 'A server error occurred. Please try again later.';
                bulkAlert.showError(msg);

              case 12:
                _context12.prev = 12;
                sendingReminders.value = false;
                return _context12.finish(12);

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[1, 8, 12, 15]]);
      }));
      return _sendOverdueReminders.apply(this, arguments);
    }

    var showResendModal = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var resendEventIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var sendingResend = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function submitResend() {
      return _submitResend.apply(this, arguments);
    }

    function _submitResend() {
      _submitResend = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee13() {
        var res, msg;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                sendingResend.value = true;
                _context13.prev = 1;
                _context13.next = 4;
                return __WEBPACK_IMPORTED_MODULE_19__services_api_draws__["a" /* default */].resendNotifications(props.draftId, {
                  events_id: resendEventIds.value,
                  members_id: []
                });

              case 4:
                res = _context13.sent;
                bulkAlert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Notifications queued');
                showResendModal.value = false;
                resendEventIds.value = [];
                _context13.next = 14;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](1);
                msg = _context13.t0.response != null && _context13.t0.response.data != null && _context13.t0.response.data.message != null ? _context13.t0.response.data.message : 'A server error occurred. Please try again later.';
                bulkAlert.showError(msg);

              case 14:
                _context13.prev = 14;
                sendingResend.value = false;
                return _context13.finish(14);

              case 17:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[1, 10, 14, 17]]);
      }));
      return _submitResend.apply(this, arguments);
    }

    return {
      bulkAlert: bulkAlert,
      rowAlert: rowAlert,
      onPartialPaymentSuccess: onPartialPaymentSuccess,
      blockedAccept: blockedAccept,
      searchBlocked: searchBlocked,
      dismissBlockedAccept: dismissBlockedAccept,
      moveableLists: moveableLists,
      isLocked: isLocked,
      paymentFilter: paymentFilter,
      paymentFilterOptions: paymentFilterOptions,
      filteredNominations: filteredNominations,
      paymentStatusOptions: paymentStatusOptions,
      commitOptions: commitOptions,
      selectedGroupUserIds: selectedGroupUserIds,
      bulkList: bulkList,
      applyingBulk: applyingBulk,
      bulkComment: bulkComment,
      applyingBulkComment: applyingBulkComment,
      applyBulkComment: applyBulkComment,
      onRowCommitChange: onRowCommitChange,
      bulkPaymentStatus: bulkPaymentStatus,
      applyingBulkPayment: applyingBulkPayment,
      applyBulkPaymentStatus: applyBulkPaymentStatus,
      onRowPaymentStatusChange: onRowPaymentStatusChange,
      tableErrorKey: tableErrorKey,
      handleMoveGroup: handleMoveGroup,
      toggleSelect: toggleSelect,
      toggleSelectAll: toggleSelectAll,
      applyBulkStatus: applyBulkStatus,
      pendingMove: pendingMove,
      confirmPendingMove: confirmPendingMove,
      drawExists: drawExists,
      acceptInvoiceWarning: __WEBPACK_IMPORTED_MODULE_20__utils_nominationMove__["a" /* ACCEPT_INVOICE_WARNING */],
      closedDrawWarning: __WEBPACK_IMPORTED_MODULE_20__utils_nominationMove__["b" /* CLOSED_DRAW_WARNING */],
      onListChange: onListChange,
      partialPaymentTarget: partialPaymentTarget,
      onOpenPartialPayment: onOpenPartialPayment,
      closePartialPayment: closePartialPayment,
      markPartialPaymentChanged: markPartialPaymentChanged,
      detailTarget: detailTarget,
      detailHasChanges: detailHasChanges,
      markDetailChanged: markDetailChanged,
      onOpenDetail: onOpenDetail,
      closeDetail: closeDetail,
      downloadingBiosecurityPdf: downloadingBiosecurityPdf,
      downloadingBiosecurityCsv: downloadingBiosecurityCsv,
      downloadingVehiclesPdf: downloadingVehiclesPdf,
      downloadBiosecurityReport: downloadBiosecurityReport,
      downloadVehiclesReport: downloadVehiclesReport,
      sendingReminders: sendingReminders,
      sendOverdueReminders: sendOverdueReminders,
      showResendModal: showResendModal,
      resendEventIds: resendEventIds,
      sendingResend: sendingResend,
      submitResend: submitResend
    };
  }
}));

/***/ }),

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NominationListSelect__ = __webpack_require__(1246);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var COLUMNS = [{
  key: 'account',
  label: 'Account',
  width: '1fr',
  tabHideLabel: true
}, {
  key: 'name',
  label: 'Member Name',
  width: '2fr',
  primary: true,
  tabHideLabel: true
}, {
  key: 'list',
  label: 'Nomination Status',
  width: '2fr',
  tabWidth: '3fr',
  tabLabel: true,
  tabHideLabel: true
}, {
  key: 'suburb',
  label: 'Suburb',
  width: '1fr',
  tabRow: 2,
  tabletWidth: '50%',
  tabLabel: true
}, {
  key: 'payment',
  label: 'Payment Status',
  width: '2fr',
  tabRow: 2,
  tabletWidth: '50%',
  tabLabel: true
}, {
  key: 'comment',
  label: 'Payment type',
  width: '2fr',
  tabRow: 3,
  tabletWidth: '67%',
  tabLabel: true
}, {
  key: 'actions',
  label: 'Actions',
  width: '2fr',
  tabRow: 3,
  tabletWidth: '33%',
  tabLabel: true
}];

function paymentLabel(group) {
  var noms = group.nominations;
  if (!noms.length) return '—';
  var paidCount = noms.filter(function (n) {
    return n.is_paid;
  }).length;
  if (paidCount === noms.length) return 'Paid';
  if (paidCount === 0) return 'Unpaid';
  return 'Partially Paid';
}

function paymentClass(group) {
  var noms = group.nominations;
  var paidCount = noms.filter(function (n) {
    return n.is_paid;
  }).length;
  return paidCount === noms.length ? 'green_text' : 'red_text';
}

function paymentOptionClass(value) {
  return value === 1 ? 'green_text' : 'red_text';
}

function isPartiallyPaid(group) {
  var noms = group.nominations;
  if (!noms.length) return false;
  var paidCount = noms.filter(function (n) {
    return n.is_paid;
  }).length;
  return paidCount > 0 && paidCount < noms.length;
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationsDashboardTable',
  components: {
    GridTable: __WEBPACK_IMPORTED_MODULE_1__components_GridTable__["a" /* default */],
    NominationListSelect: __WEBPACK_IMPORTED_MODULE_4__NominationListSelect__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FCheckbox__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_3__components_AppMultiselect__["a" /* default */]
  },
  props: {
    nominations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    draftId: {
      type: [String, Number],
      required: true
    },
    moveGroup: {
      type: Function,
      default: null
    },
    commitOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paymentStatusOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    errorKey: {
      type: Number,
      default: 0
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    activeList: {
      type: String,
      default: null
    },
    eventMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-select', 'open-detail', 'commit-change', 'payment-status-change', 'open-partial-payment'],
  setup: function setup(props) {
    var rows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.nominations.map(function (g) {
        return g.id != null ? g : _objectSpread({}, g, {
          id: g.user.id
        });
      });
    });
    var AMOUNT_COLUMN = {
      key: 'amount',
      label: 'Amount',
      width: '1fr',
      tabRow: 3,
      tabletWidth: '33%',
      tabLabel: true
    };
    var tableColumns = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (props.activeList === 'accept' && !props.eventMode) {
        var actionsCol = _objectSpread({}, COLUMNS[COLUMNS.length - 1], {
          tabRow: 4,
          tabletWidth: '100%'
        });

        return [].concat(_toConsumableArray(COLUMNS.slice(0, -1)), [AMOUNT_COLUMN, actionsCol]);
      }

      return COLUMNS;
    });

    function unpaidAmount(group) {
      return group.nominations.filter(function (n) {
        return !n.is_paid;
      }).reduce(function (sum, n) {
        return sum + (n.event != null ? Number(n.event.cost) : 0);
      }, 0);
    }

    function formatAmount(val) {
      return val === 0 ? '0' : val.toFixed(2);
    }

    var commitOptionsWithNull = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return [{
        value: null,
        label: 'Payment type'
      }].concat(props.commitOptions);
    });

    function groupCommitOption(group) {
      // Ignore nominations without a commit yet (e.g. just added to an otherwise-set group) —
      // matches monolith's COUNT(DISTINCT Nomination.commit), which SQL excludes NULLs from,
      // so an unset commit on one nomination doesn't blank out an already-agreed payment type.
      var commits = group.nominations.map(function (n) {
        return n.commit;
      }).filter(function (c) {
        return c != null;
      });
      if (commits.length === 0) return commitOptionsWithNull.value[0];
      var unique = commits.filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      if (unique.length !== 1) return commitOptionsWithNull.value[0];
      return commitOptionsWithNull.value.find(function (o) {
        return o.value === unique[0];
      }) || commitOptionsWithNull.value[0];
    }

    function groupPaymentOption(group) {
      var values = group.nominations.map(function (n) {
        return n.is_paid;
      });
      if (values.length === 0) return null;
      var unique = values.filter(function (v, i, a) {
        return a.indexOf(v) === i;
      });
      if (unique.length !== 1) return props.paymentStatusOptions.find(function (o) {
        return o.value === 2;
      }) || null;
      return props.paymentStatusOptions.find(function (o) {
        return o.value === unique[0];
      }) || null;
    }

    return {
      rows: rows,
      tableColumns: tableColumns,
      paymentLabel: paymentLabel,
      paymentClass: paymentClass,
      paymentOptionClass: paymentOptionClass,
      isPartiallyPaid: isPartiallyPaid,
      unpaidAmount: unpaidAmount,
      formatAmount: formatAmount,
      commitOptionsWithNull: commitOptionsWithNull,
      groupCommitOption: groupCommitOption,
      groupPaymentOption: groupPaymentOption
    };
  }
}));

/***/ }),

/***/ 1246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationListSelect_vue__ = __webpack_require__(1247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e1f856_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationListSelect_vue__ = __webpack_require__(1337);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationListSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e1f856_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationListSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_nominations_useNominationLists__ = __webpack_require__(1215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationListSelect',
  components: {
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: String,
      required: true
    },
    sizeClass: {
      type: String,
      default: null
    }
  },
  emits: ['input'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useNominationLists = Object(__WEBPACK_IMPORTED_MODULE_2__composables_nominations_useNominationLists__["a" /* default */])(),
        listItems = _useNominationLists.listItems;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return listItems.value.filter(function (l) {
        return l.value !== 'scratchedByUser';
      });
    });
    var selectedOption = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return options.value.find(function (l) {
        return l.value === props.value;
      });
    });

    function onInput(option) {
      emit('input', option.value);
    }

    return {
      options: options,
      selectedOption: selectedOption,
      onInput: onInput
    };
  }
}));

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_nominations_useNominationAccountDetail__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_useFormAlert__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api_invoices__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_nominationMove__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NominationListSelect__ = __webpack_require__(1246);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var BASE_COLUMNS = [{
  key: 'draw_order',
  width: '36px'
}, {
  key: 'drag',
  width: '36px'
}, {
  key: 'horse',
  width: '1fr',
  minWidth: '120px'
}, {
  key: 'owner',
  width: '1fr',
  minWidth: '100px'
}, {
  key: 'status',
  width: 'auto'
}, {
  key: 'scratch',
  width: '30px'
}];
var NTBP_COLUMN = {
  key: 'ntbp',
  width: 'auto'
};
var MOVE_COLUMN = {
  key: 'move',
  width: 'auto'
};

function columnsForEvent(event) {
  var hasNtbp = event.nominations.some(function (n) {
    return n.needs_to_be_processed;
  });
  var hasMoveTarget = event.move_to_event != null;
  var cols = BASE_COLUMNS;
  if (hasNtbp) cols = [cols[0], cols[1], NTBP_COLUMN].concat(_toConsumableArray(cols.slice(2)));
  if (hasMoveTarget) cols = [].concat(_toConsumableArray(cols), [MOVE_COLUMN]);
  return cols;
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationAccountDetailPopup',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_2__components_AppButton__["a" /* default */],
    GridTable: __WEBPACK_IMPORTED_MODULE_3__components_GridTable__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_4__components_FormAlert__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_5__components_ConfirmModal__["a" /* default */],
    NominationListSelect: __WEBPACK_IMPORTED_MODULE_11__NominationListSelect__["a" /* default */]
  },
  props: {
    draftId: {
      type: [String, Number],
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    list: {
      type: String,
      required: true
    },
    eventId: {
      type: Number,
      default: null
    },
    draftStateId: {
      type: Number,
      default: null
    },
    drawExists: {
      type: Boolean,
      default: false
    },
    onChanged: {
      type: Function,
      default: null
    }
  },
  emits: ['close', 'resend-draw'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useNominationAccount = Object(__WEBPACK_IMPORTED_MODULE_6__composables_nominations_useNominationAccountDetail__["a" /* default */])(),
        data = _useNominationAccount.data,
        loading = _useNominationAccount.loading,
        fetch = _useNominationAccount.fetch;

    var alert = Object(__WEBPACK_IMPORTED_MODULE_7__composables_useFormAlert__["a" /* default */])();
    var profileRoute = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (data.value == null) return null;
      return {
        name: 'Member Profile',
        params: {
          slug: data.value.user.id
        }
      };
    });
    var openMemberId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var openEventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var selectedMemberIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var allSelected = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (data.value == null || data.value.members.length === 0) return false;
      return selectedMemberIds.value.length === data.value.members.length;
    });
    var someSelected = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return selectedMemberIds.value.length > 0 && !allSelected.value;
    });

    function toggleSelectMember(id) {
      var idx = selectedMemberIds.value.indexOf(id);

      if (idx === -1) {
        selectedMemberIds.value = selectedMemberIds.value.concat(id);
      } else {
        selectedMemberIds.value = selectedMemberIds.value.filter(function (x) {
          return x !== id;
        });
      }
    }

    function toggleSelectAll() {
      if (allSelected.value) {
        selectedMemberIds.value = [];
      } else {
        selectedMemberIds.value = data.value.members.map(function (m) {
          return m.id;
        });
      }
    } // Auto-open the first member/event only when nothing is open yet — on the initial load for
    // this target (see the props watcher below, which clears openMemberId before fetching). A
    // background refetch of the *same* target (e.g. after editing a quantity inline) must not
    // collapse whatever the secretary currently has expanded, so it's skipped once something is open.


    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(data, function (val) {
      if (val != null && openMemberId.value == null && val.members.length > 0) {
        var first = val.members[0];
        openMemberId.value = first.id;
        openEventId.value = first.events.length > 0 ? first.events[0].id : null;
      }
    });

    function toggleMember(memberId, events) {
      if (openMemberId.value === memberId) {
        openMemberId.value = null;
        openEventId.value = null;
      } else {
        openMemberId.value = memberId;
        openEventId.value = events.length > 0 ? events[0].id : null;
      }
    }

    function toggleEvent(eventId) {
      openEventId.value = openEventId.value === eventId ? null : eventId;
    }

    function buildParams() {
      var params = {
        user_id: props.userId,
        list: props.list
      };
      if (props.eventId != null) params.event_id = props.eventId;
      return params;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return [props.draftId, props.userId, props.list, props.eventId];
    }, function () {
      selectedMemberIds.value = [];
      openMemberId.value = null;
      openEventId.value = null;
      fetch(props.draftId, buildParams());
    }, {
      immediate: true
    });

    function extractMsg(err, fallback) {
      return err != null && err.response != null && err.response.data != null ? err.response.data.message : fallback;
    } // Monolith parity: moving a nom to accepted requires confirmation when the
    // draft is in Finalise (invoices are sent immediately) or Closed with
    // generated draws (the nomination will not be added to the draw).


    var pendingListChange = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function doListChange(_x, _x2) {
      return _doListChange.apply(this, arguments);
    }

    function _doListChange() {
      _doListChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(nom, list) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].bulkMove({
                  nomination_ids: [nom.id],
                  list: list
                });

              case 3:
                res = _context.sent;
                if (props.onChanged != null) props.onChanged();
                alert.showSuccess(res != null && res.data != null ? res.data.message : null);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                alert.showError(extractMsg(_context.t0, 'Failed to update status'));
                return _context.abrupt("return");

              case 12:
                fetch(props.draftId, buildParams());

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
      return _doListChange.apply(this, arguments);
    }

    function onListChange(_x3, _x4) {
      return _onListChange.apply(this, arguments);
    }

    function _onListChange() {
      _onListChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(nom, list) {
        var warning;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                warning = Object(__WEBPACK_IMPORTED_MODULE_10__utils_nominationMove__["c" /* moveWarningType */])(nom.list, list, props.draftStateId, props.drawExists);

                if (!(warning != null)) {
                  _context2.next = 4;
                  break;
                }

                pendingListChange.value = {
                  nom: nom,
                  list: list,
                  warning: warning
                };
                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return doListChange(nom, list);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onListChange.apply(this, arguments);
    }

    function confirmPendingListChange() {
      return _confirmPendingListChange.apply(this, arguments);
    }

    function _confirmPendingListChange() {
      _confirmPendingListChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var pending;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                pending = pendingListChange.value;
                pendingListChange.value = null;

                if (!(pending == null)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.next = 6;
                return doListChange(pending.nom, pending.list);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _confirmPendingListChange.apply(this, arguments);
    }

    var dragOriginalIds = [];

    function onDragStart(ids) {
      dragOriginalIds = ids.slice();
    }

    function applyDrawOrders(items) {
      if (data.value == null || items == null) return;
      var drawOrderByNominationId = items.reduce(function (result, item) {
        result[item.nomination_id] = item.draw_order;
        return result;
      }, {});
      data.value.members.forEach(function (member) {
        member.events.forEach(function (event) {
          event.nominations.forEach(function (nomination) {
            if (drawOrderByNominationId[nomination.id] != null) {
              nomination.draw_order = drawOrderByNominationId[nomination.id];
            }
          });
        });
      });
    }

    function onDragEnd(_x5, _x6) {
      return _onDragEnd.apply(this, arguments);
    }

    function _onDragEnd() {
      _onDragEnd = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(ids, eventId) {
        var items, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(ids.join(',') === dragOriginalIds.join(','))) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                items = ids.map(function (id, i) {
                  return {
                    id: id,
                    order: i + 1
                  };
                });
                _context4.prev = 3;
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].reorderRuns(props.draftId, eventId, {
                  items: items
                });

              case 6:
                res = _context4.sent;
                applyDrawOrders(res != null && res.data != null && res.data.data != null ? res.data.data.items : null);
                if (props.onChanged != null) props.onChanged();
                alert.showSuccess(res != null && res.data != null ? res.data.message : null);
                _context4.next = 16;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](3);
                fetch(props.draftId, buildParams());
                alert.showError(extractMsg(_context4.t0, 'Reorder failed'));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 12]]);
      }));
      return _onDragEnd.apply(this, arguments);
    }

    function onMoveToEvent(_x7, _x8) {
      return _onMoveToEvent.apply(this, arguments);
    } // Per-member remaining Quantity quota for a no-horse event, keyed by nomination id — mirrors
    // the backend's per-person max_submissions check (this member's other quantities in the same
    // event, capped at event.max_submissions). Same pattern as NominationsAddList.vue.


    function _onMoveToEvent() {
      _onMoveToEvent = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(nom, targetEventId) {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].moveToEvent(nom.id, targetEventId);

              case 3:
                res = _context5.sent;
                if (props.onChanged != null) props.onChanged();
                alert.showSuccess(res != null && res.data != null ? res.data.message : null);
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                alert.showError(extractMsg(_context5.t0, 'Failed to move nomination'));

              case 11:
                fetch(props.draftId, buildParams());

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 8]]);
      }));
      return _onMoveToEvent.apply(this, arguments);
    }

    var quantityMaxByNomId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var result = {};
      if (data.value == null) return result;
      data.value.members.forEach(function (member) {
        member.events.forEach(function (event) {
          if (event.max_submissions == null) return;
          var total = event.nominations.reduce(function (sum, n) {
            return sum + (n.quantity || 0);
          }, 0);
          event.nominations.forEach(function (n) {
            result[n.id] = event.max_submissions - (total - (n.quantity || 0));
          });
        });
      });
      return result;
    });
    var quantityOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
    var quantityUpdatingIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);

    function handleQuantityChange(_x9, _x10) {
      return _handleQuantityChange.apply(this, arguments);
    }

    function _handleQuantityChange() {
      _handleQuantityChange = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(nomId, quantity) {
        var res, reverted;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                quantityUpdatingIds.value = quantityUpdatingIds.value.concat(nomId);
                _context6.prev = 1;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_nominations__["a" /* default */].updateNomination(nomId, {
                  quantity: quantity,
                  keep_original_status: true
                });

              case 4:
                res = _context6.sent;
                if (props.onChanged != null) props.onChanged();
                alert.showSuccess(res != null && res.data != null ? res.data.message : null);
                _context6.next = 15;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](1);
                reverted = _objectSpread({}, quantityOverrides.value);
                delete reverted[nomId];
                quantityOverrides.value = reverted;
                alert.showError(extractMsg(_context6.t0, 'Failed to update quantity'));

              case 15:
                _context6.prev = 15;
                quantityUpdatingIds.value = quantityUpdatingIds.value.filter(function (id) {
                  return id !== nomId;
                });
                return _context6.finish(15);

              case 18:
                fetch(props.draftId, buildParams());

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 9, 15, 18]]);
      }));
      return _handleQuantityChange.apply(this, arguments);
    }

    function onQuantityChange(nomId, value) {
      var quantity = Number(value);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      var max = quantityMaxByNomId.value[nomId];
      if (max != null && quantity > max) quantity = max;
      quantityOverrides.value = _objectSpread({}, quantityOverrides.value, _defineProperty({}, nomId, quantity));
      handleQuantityChange(nomId, quantity);
    }

    var hasInvoices = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return data.value != null && data.value.invoices != null && data.value.invoices.length > 0;
    });
    var resending = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function resendInvoice() {
      return _resendInvoice.apply(this, arguments);
    }

    function _resendInvoice() {
      _resendInvoice = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                resending.value = true;
                _context7.prev = 1;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__services_api_invoices__["a" /* default */].resend(props.draftId, props.userId);

              case 4:
                res = _context7.sent;
                alert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Invoice queued for resend');
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](1);
                alert.showError(extractMsg(_context7.t0, 'Failed to resend invoice'));

              case 11:
                _context7.prev = 11;
                resending.value = false;
                return _context7.finish(11);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 8, 11, 14]]);
      }));
      return _resendInvoice.apply(this, arguments);
    }

    function onClose() {
      emit('close');
    }

    function openPdf(url) {
      window.open(url, '_blank');
    }

    var generatingPdfIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(new Set());

    function generateInvoicePdf(_x11) {
      return _generateInvoicePdf.apply(this, arguments);
    }

    function _generateInvoicePdf() {
      _generateInvoicePdf = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(inv) {
        var res, url, next;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!generatingPdfIds.value.has(inv.id)) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                generatingPdfIds.value = new Set([].concat(_toConsumableArray(generatingPdfIds.value), [inv.id]));
                _context8.prev = 3;
                _context8.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__services_api_invoices__["a" /* default */].getPdf(inv.id);

              case 6:
                res = _context8.sent;
                url = res.data.data.url;

                if (url) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt("return");

              case 10:
                inv.pdf_path = url;
                window.open(url, '_blank');
                _context8.next = 16;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](3);

              case 16:
                _context8.prev = 16;
                next = new Set(generatingPdfIds.value);
                next.delete(inv.id);
                generatingPdfIds.value = next;
                return _context8.finish(16);

              case 21:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[3, 14, 16, 21]]);
      }));
      return _generateInvoicePdf.apply(this, arguments);
    }

    return {
      data: data,
      loading: loading,
      alert: alert,
      hasInvoices: hasInvoices,
      resending: resending,
      resendInvoice: resendInvoice,
      columnsForEvent: columnsForEvent,
      openMemberId: openMemberId,
      openEventId: openEventId,
      profileRoute: profileRoute,
      selectedMemberIds: selectedMemberIds,
      allSelected: allSelected,
      someSelected: someSelected,
      toggleSelectMember: toggleSelectMember,
      toggleSelectAll: toggleSelectAll,
      toggleMember: toggleMember,
      toggleEvent: toggleEvent,
      onListChange: onListChange,
      pendingListChange: pendingListChange,
      confirmPendingListChange: confirmPendingListChange,
      acceptInvoiceWarning: __WEBPACK_IMPORTED_MODULE_10__utils_nominationMove__["a" /* ACCEPT_INVOICE_WARNING */],
      closedDrawWarning: __WEBPACK_IMPORTED_MODULE_10__utils_nominationMove__["b" /* CLOSED_DRAW_WARNING */],
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      onMoveToEvent: onMoveToEvent,
      onClose: onClose,
      openPdf: openPdf,
      generateInvoicePdf: generateInvoicePdf,
      generatingPdfIds: generatingPdfIds,
      quantityMaxByNomId: quantityMaxByNomId,
      quantityOverrides: quantityOverrides,
      quantityUpdatingIds: quantityUpdatingIds,
      onQuantityChange: onQuantityChange
    };
  }
}));

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNominationAccountDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__ = __webpack_require__(437);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useNominationAccountDetail() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetch(_x, _x2) {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(draftId, params) {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].accountDetail(draftId, params);

            case 4:
              res = _context.sent;
              data.value = res.data.data;

            case 6:
              _context.prev = 6;
              loading.value = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _fetch.apply(this, arguments);
  }

  return {
    data: data,
    loading: loading,
    fetch: fetch
  };
}

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_INVOICE_WARNING; });
/* unused harmony export needsAcceptInvoiceWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSED_DRAW_WARNING; });
/* unused harmony export needsClosedDrawWarning */
/* harmony export (immutable) */ __webpack_exports__["c"] = moveWarningType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_draftStates__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_nominationLists__ = __webpack_require__(1342);

 // Mirrors the monolith committees dashboard prompt: moving a nomination from
// unprocessed/waitlist to accepted while the draft is in Finalise immediately
// notifies the member and generates an invoice.

var ACCEPT_INVOICE_WARNING = 'The member/s you are about to move to accepted will be notified immediately and sent an invoice for their nominations.';
function needsAcceptInvoiceWarning(fromList, toList, draftStateId) {
  return toList === __WEBPACK_IMPORTED_MODULE_1__constants_nominationLists__["a" /* NOMINATION_LIST_ACCEPT */] && (fromList === __WEBPACK_IMPORTED_MODULE_1__constants_nominationLists__["b" /* NOMINATION_LIST_UNPROCESSED */] || fromList === __WEBPACK_IMPORTED_MODULE_1__constants_nominationLists__["c" /* NOMINATION_LIST_WAITLIST */]) && draftStateId === __WEBPACK_IMPORTED_MODULE_0__constants_draftStates__["b" /* DRAFT_STATE_FINALISE */];
} // Monolith parity: once draws are generated for a closed draft, accepting a
// nomination does not add it to the draw — it must be added on the Draws page.

var CLOSED_DRAW_WARNING = 'Moving members to accepted after the draws are generated does not add the nominations to the draw. All nominations must be added directly to the draw after draws have been generated.';
function needsClosedDrawWarning(toList, draftStateId, drawExists) {
  return toList === __WEBPACK_IMPORTED_MODULE_1__constants_nominationLists__["a" /* NOMINATION_LIST_ACCEPT */] && draftStateId === __WEBPACK_IMPORTED_MODULE_0__constants_draftStates__["a" /* DRAFT_STATE_CLOSED */] && drawExists === true;
} // Returns which confirmation (if any) a list move requires: 'invoice', 'draw' or null.

function moveWarningType(fromList, toList, draftStateId, drawExists) {
  if (needsAcceptInvoiceWarning(fromList, toList, draftStateId)) return 'invoice';
  if (needsClosedDrawWarning(toList, draftStateId, drawExists)) return 'draw';
  return null;
}

/***/ }),

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GridTable__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__composables_nominations_useNominationAccountDetail__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_useFormAlert__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_nominations__ = __webpack_require__(437);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var COLUMNS = [{
  key: 'check',
  label: '',
  width: '36px'
}, {
  key: 'ntbp',
  label: '',
  width: 'auto'
}, {
  key: 'event',
  label: 'Event',
  width: '1fr',
  minWidth: '120px'
}, {
  key: 'horse',
  label: 'Horse',
  width: '1fr',
  minWidth: '120px'
}, {
  key: 'owner',
  label: 'Horse Owner',
  width: '1fr',
  minWidth: '100px'
}, {
  key: 'cost',
  label: 'Cost',
  width: '80px'
}];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CommitteePartialPaymentPopup',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_2__components_AppButton__["a" /* default */],
    GridTable: __WEBPACK_IMPORTED_MODULE_3__components_GridTable__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_4__components_FormAlert__["a" /* default */]
  },
  props: {
    draftId: {
      type: [String, Number],
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    paymentType: {
      type: String,
      default: null
    },
    onChanged: {
      type: Function,
      default: null
    }
  },
  emits: ['close', 'success'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useNominationAccount = Object(__WEBPACK_IMPORTED_MODULE_5__composables_nominations_useNominationAccountDetail__["a" /* default */])(),
        data = _useNominationAccount.data,
        loading = _useNominationAccount.loading,
        fetch = _useNominationAccount.fetch;

    var alert = Object(__WEBPACK_IMPORTED_MODULE_6__composables_useFormAlert__["a" /* default */])();
    var saving = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var selectedIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    var profileRoute = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (data.value == null) return null;
      return {
        name: 'Member Profile',
        params: {
          slug: data.value.user.id
        }
      };
    });

    function memberNominations(member) {
      var result = [];
      member.events.forEach(function (event) {
        event.nominations.forEach(function (nom) {
          result.push(nom);
        });
      });
      return result;
    }

    var flatNominations = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (data.value == null) return [];
      var result = [];
      data.value.members.forEach(function (member) {
        member.events.forEach(function (event) {
          event.nominations.forEach(function (nom) {
            result.push(nom);
          });
        });
      });
      return result;
    });
    var totalPaid = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var sum = flatNominations.value.filter(function (n) {
        return selectedIds.value.indexOf(n.id) !== -1;
      }).reduce(function (acc, n) {
        return acc + (n.cost != null ? Number(n.cost) : 0);
      }, 0);
      return sum.toFixed(2);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(data, function () {
      if (data.value != null) {
        selectedIds.value = flatNominations.value.filter(function (n) {
          return n.is_paid;
        }).map(function (n) {
          return n.id;
        });
      } else {
        selectedIds.value = [];
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return [props.draftId, props.userId];
    }, function () {
      return fetch(props.draftId, {
        user_id: props.userId,
        list: 'accept'
      });
    }, {
      immediate: true
    });

    function toggleSelect(id) {
      var idx = selectedIds.value.indexOf(id);
      var nom = flatNominations.value.find(function (n) {
        return n.id === id;
      });
      var pairId = nom != null ? nom.comb_nomination_id : null;

      if (idx === -1) {
        var toAdd = pairId != null && selectedIds.value.indexOf(pairId) === -1 ? [id, pairId] : [id];
        selectedIds.value = selectedIds.value.concat(toAdd);
      } else {
        selectedIds.value = selectedIds.value.filter(function (x) {
          return x !== id && x !== pairId;
        });
      }
    }

    function onUpdate() {
      return _onUpdate.apply(this, arguments);
    }

    function _onUpdate() {
      _onUpdate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var items, res, msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                saving.value = true;
                alert.clear();
                _context.prev = 2;

                if (!(props.paymentType != null)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__services_api_nominations__["a" /* default */].updateCommit(props.draftId, {
                  ids: flatNominations.value.map(function (n) {
                    return n.id;
                  }),
                  commit: props.paymentType
                });

              case 6:
                items = flatNominations.value.map(function (n) {
                  return {
                    id: n.id,
                    is_paid: selectedIds.value.indexOf(n.id) !== -1 ? 1 : 0
                  };
                });
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7__services_api_nominations__["a" /* default */].updatePaymentStatus(props.draftId, {
                  items: items
                });

              case 9:
                res = _context.sent;
                if (props.onChanged != null) props.onChanged();
                emit('success', res != null && res.data != null ? res.data.message : null);
                emit('close');
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                msg = _context.t0 != null && _context.t0.response != null && _context.t0.response.data != null ? _context.t0.response.data.message : 'Failed to update payment status';
                alert.showError(msg);

              case 19:
                _context.prev = 19;
                saving.value = false;
                return _context.finish(19);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 15, 19, 22]]);
      }));
      return _onUpdate.apply(this, arguments);
    }

    return {
      COLUMNS: COLUMNS,
      data: data,
      loading: loading,
      alert: alert,
      saving: saving,
      selectedIds: selectedIds,
      profileRoute: profileRoute,
      flatNominations: flatNominations,
      totalPaid: totalPaid,
      memberNominations: memberNominations,
      toggleSelect: toggleSelect,
      onUpdate: onUpdate
    };
  }
}));

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1324);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("14b0dae5", content, true, {});

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".historical_filter ::v-deep label[data-v-eb728a46]{font-size:1.1rem;font-weight:700;margin-bottom:.25rem}.drafts-filter[data-v-eb728a46]{margin-bottom:.5rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Committees/Dashboard/CommitteeDashboard.vue"],"names":[],"mappings":"AACA,mDACE,iBAAkB,AAClB,gBAAkB,AAClB,oBAAuB,CACxB,AACD,gCACE,mBAAsB,CACvB","file":"CommitteeDashboard.vue","sourcesContent":["\n.historical_filter ::v-deep label[data-v-eb728a46] {\n  font-size: 1.1rem;\n  font-weight: bold;\n  margin-bottom: 0.25rem;\n}\n.drafts-filter[data-v-eb728a46] {\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCommitteeDrafts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_committees__ = __webpack_require__(93);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useCommitteeDrafts() {
  var drafts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var params = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    season: new Date().getFullYear(),
    sort: null,
    direction: null
  });

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var query, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              query = {
                year: params.season
              };

              if (params.sort) {
                query.sort = params.sort;
                query.direction = params.direction;
              }

              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_committees__["a" /* default */].drafts(query);

            case 6:
              res = _context.sent;
              drafts.value = res.data.data;

            case 8:
              _context.prev = 8;
              loading.value = false;
              return _context.finish(8);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 8, 11]]);
    }));
    return _fetch.apply(this, arguments);
  }

  function setYear(year) {
    params.season = year;
    fetch();
  }

  function setSort(field) {
    if (params.sort !== field) {
      params.sort = field;
      params.direction = 'asc';
    } else if (params.direction === 'asc') {
      params.direction = 'desc';
    } else {
      params.sort = null;
      params.direction = null;
    }

    fetch();
  }

  return {
    drafts: drafts,
    loading: loading,
    params: params,
    fetch: fetch,
    setYear: setYear,
    setSort: setSort
  };
}

/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftEventsDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_events__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useDraftEventsDashboard() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;

  var openDraftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var events = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var totals = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var loadingEvents = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function emitError(msg) {
    if (onError) onError(msg);else __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', msg);
  }

  function emitSuccess(msg) {
    if (onSuccess) onSuccess(msg);else __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-success', msg);
  }

  function load(_x) {
    return _load.apply(this, arguments);
  }

  function _load() {
    _load = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(draftId) {
      var res, data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loadingEvents.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_events__["a" /* default */].nominationsDashboard(draftId);

            case 4:
              res = _context.sent;
              events.value = res.data.data;
              totals.value = res.data.meta != null ? res.data.meta.totals : null;
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'Failed to load events.';
              emitError(msg);

            case 14:
              _context.prev = 14;
              loadingEvents.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9, 14, 17]]);
    }));
    return _load.apply(this, arguments);
  }

  function toggle(_x2) {
    return _toggle.apply(this, arguments);
  }

  function _toggle() {
    _toggle = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(draftId) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(openDraftId.value === draftId)) {
                _context2.next = 5;
                break;
              }

              openDraftId.value = null;
              events.value = [];
              totals.value = null;
              return _context2.abrupt("return");

            case 5:
              openDraftId.value = draftId;
              _context2.next = 8;
              return load(draftId);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _toggle.apply(this, arguments);
  }

  function reload() {
    return _reload.apply(this, arguments);
  }

  function _reload() {
    _reload = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(openDraftId.value != null)) {
                _context3.next = 3;
                break;
              }

              _context3.next = 3;
              return load(openDraftId.value);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _reload.apply(this, arguments);
  }

  function lockEvent(_x3, _x4) {
    return _lockEvent.apply(this, arguments);
  }

  function _lockEvent() {
    _lockEvent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(eventId, isLocked) {
      var res, idx, data, msg;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_events__["a" /* default */].lock(eventId, isLocked);

            case 3:
              res = _context4.sent;
              emitSuccess(res.data != null && res.data.message != null ? res.data.message : 'Event lock updated.');
              idx = events.value.findIndex(function (e) {
                return e.id === eventId;
              });

              if (idx !== -1) {
                events.value.splice(idx, 1, _objectSpread({}, events.value[idx], {
                  is_locked: isLocked
                }));
              }

              _context4.next = 14;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              data = _context4.t0.response != null ? _context4.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'Failed to update event lock.';
              emitError(msg);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));
    return _lockEvent.apply(this, arguments);
  }

  return {
    openDraftId: openDraftId,
    events: events,
    totals: totals,
    loadingEvents: loadingEvents,
    toggle: toggle,
    reload: reload,
    lockEvent: lockEvent
  };
}

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDraftEventsTable_vue__ = __webpack_require__(1243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3496b923_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDraftEventsTable_vue__ = __webpack_require__(1330);
function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3496b923"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDraftEventsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3496b923_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDraftEventsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1329);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("9564d150", content, true, {});

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".events-subtable[data-v-3496b923]{padding:20px 0}.event-name-btn[data-v-3496b923]{text-decoration:none}.event-name-btn--child[data-v-3496b923]{padding-left:22px!important;position:relative}.event-name-btn--child[data-v-3496b923]:before{content:\"\\21B3\";position:absolute;left:4px;color:var(--gray-500)}.events-subtable[data-v-3496b923] .gt__drag-handle--child{opacity:.45;-webkit-transform:scale(.8);transform:scale(.8)}.event-name-btn--active[data-v-3496b923]{text-decoration:underline;font-weight:700}.events-subtable[data-v-3496b923] .actions__wrap{flex-wrap:wrap;row-gap:4px}.events-subtable[data-v-3496b923] .gt__cell,.events-subtable[data-v-3496b923] .gt__hdr{overflow-wrap:break-word;white-space:normal}.gt__drag-handle.is-disabled[data-v-3496b923],.gt__drag-handle.is-disabled[data-v-3496b923]:hover{cursor:default;opacity:.35}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Committees/Dashboard/components/CommitteeDraftEventsTable.vue"],"names":[],"mappings":"AACA,kCACE,cAAgB,CACjB,AACD,iCACE,oBAAsB,CACvB,AACD,wCACE,4BAA8B,AAC9B,iBAAmB,CACpB,AACD,+CACE,gBAAiB,AACjB,kBAAmB,AACnB,SAAU,AACV,qBAAuB,CACxB,AACD,0DACE,YAAc,AACd,4BAA8B,AACtB,mBAAsB,CAC/B,AACD,yCACE,0BAA2B,AAC3B,eAAkB,CACnB,AACD,iDACE,eAAgB,AAChB,WAAa,CACd,AACD,uFAEE,yBAA0B,AAC1B,kBAAoB,CACrB,AACD,kGAEE,eAAgB,AAChB,WAAc,CACf","file":"CommitteeDraftEventsTable.vue","sourcesContent":["\n.events-subtable[data-v-3496b923] {\n  padding: 20px 0;\n}\n.event-name-btn[data-v-3496b923] {\n  text-decoration: none;\n}\n.event-name-btn--child[data-v-3496b923] {\n  padding-left: 22px !important;\n  position: relative;\n}\n.event-name-btn--child[data-v-3496b923]::before {\n  content: '\\21B3';\n  position: absolute;\n  left: 4px;\n  color: var(--gray-500);\n}\n.events-subtable[data-v-3496b923] .gt__drag-handle--child {\n  opacity: 0.45;\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n}\n.event-name-btn--active[data-v-3496b923] {\n  text-decoration: underline;\n  font-weight: bold;\n}\n.events-subtable[data-v-3496b923] .actions__wrap {\n  flex-wrap: wrap;\n  row-gap: 4px;\n}\n.events-subtable[data-v-3496b923] .gt__hdr,\n.events-subtable[data-v-3496b923] .gt__cell {\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n.gt__drag-handle.is-disabled[data-v-3496b923],\n.gt__drag-handle.is-disabled[data-v-3496b923]:hover {\n  cursor: default;\n  opacity: 0.35;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative events-subtable"},[_c('grid-table',{staticClass:"gt--nested",attrs:{"columns":_vm.columns,"rows":_vm.totalsRows,"groups":_vm.groups,"loading":_vm.loadingEvents || _vm.reordering,"open-id":_vm.activeEventId,"draggable":true,"empty-text":"No events found for this draft.","mob-break":868},on:{"drag-end":_vm.onDragEnd},scopedSlots:_vm._u([{key:"before-row",fn:function(ref){
var row = ref.row;
return [(_vm.alert && _vm.alert.message && _vm.anchorRowId === row.id)?_c('row-alert',{attrs:{"message":_vm.alert.message,"type":_vm.alert.type,"alert-key":_vm.alert.id},on:{"dismiss":function($event){return _vm.$emit('dismiss-alert')}}}):_vm._e()]}},{key:"cell:drag",fn:function(ref){
var row = ref.row;
return [(_vm.dragKind(row))?_c('app-tooltip',{attrs:{"text":_vm.dragTitle(row)}},[_c('div',{staticClass:"icon-btn icon-btn--drag gt__drag-handle",class:[_vm.dragKind(row) === 'group' ? 'gt__drag-handle--group' : 'gt__drag-handle--child', { 'is-disabled': _vm.reordering }]})]):_vm._e()]}},{key:"cell:name",fn:function(ref){
var row = ref.row;
return [(row.id === 'totals')?_c('div',[_c('strong',[_vm._v("Total")]),_vm._v(" "),(row.unique_accepted_competitors != null)?_c('small',{staticClass:"d-block text-muted"},[_vm._v("\n          Unique accepted"),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-nowrap"},[_vm._v("competitors: "),_c('strong',[_vm._v(_vm._s(row.unique_accepted_competitors))])])]):_vm._e()]):(row.is_parent)?_c('span',{staticClass:"text-primary font-weight-bold"},[_vm._v(_vm._s(row.name)+" (original)")]):_c('router-link',{staticClass:"btn btn-link p-0 text-left event-name-btn",class:{ 'event-name-btn--active': _vm.activeEventId === row.id, 'event-name-btn--child': row.parent_id != null },attrs:{"to":_vm.eventLink(row.id)}},[_vm._v("\n        "+_vm._s(row.name)+"\n      ")])]}},{key:"cell:final_noms",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.final_noms || '')+"\n    ")]}},{key:"cell:total_noms",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.total_noms)),(row.total_noms_quantity !== row.total_noms)?_c('span',{staticClass:"text-primary"},[_vm._v(" ("+_vm._s(row.total_noms_quantity)+")")]):_vm._e()]}},{key:"cell:unprocessed",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.unprocessed)),(row.unprocessed_quantity !== row.unprocessed)?_c('span',{staticClass:"text-primary"},[_vm._v(" ("+_vm._s(row.unprocessed_quantity)+")")]):_vm._e()]}},{key:"cell:accepted",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.accepted)),(row.accepted_first_round && row.parent_id !== null)?_c('span',{staticClass:"text-primary"},[_vm._v(" ("+_vm._s(row.accepted_first_round)+")")]):(row.accepted_quantity !== row.accepted)?_c('span',{staticClass:"text-primary"},[_vm._v(" ("+_vm._s(row.accepted_quantity)+")")]):_vm._e()]}},{key:"cell:wait_list",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.wait_list)),(row.wait_list_quantity !== row.wait_list)?_c('span',{staticClass:"text-primary"},[_vm._v(" ("+_vm._s(row.wait_list_quantity)+")")]):_vm._e()]}},{key:"cell:scratched",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.scratched)),(row.scratched_quantity !== row.scratched)?_c('span',{staticClass:"text-primary"},[_vm._v(" ("+_vm._s(row.scratched_quantity)+")")]):_vm._e()]}},{key:"cell:actions",fn:function(ref){
var row = ref.row;
return [(row.id !== 'totals')?_c('div',{staticClass:"actions__wrap"},[(row.parent_id === null)?_c('app-tooltip',{attrs:{"text":_vm.splitTitle(row)}},[_c('button',{staticClass:"btn-actions icon-btn icon-btn--split",class:{ 'is-split': row.brother_id !== null || !_vm.canSplit(row) },on:{"click":function($event){_vm.canSplit(row) && _vm.$emit('confirm-split', row)}}})]):_vm._e(),_vm._v(" "),(!row.is_parent)?_c('app-tooltip',{attrs:{"text":row.is_locked ? 'Unlock Event Nominations' : 'Lock Event Nominations'}},[_c('button',{staticClass:"btn-actions icon-btn",class:row.is_locked ? 'icon-btn--lock' : 'icon-btn--unlock',on:{"click":function($event){return _vm.$emit('lock', row.id, !row.is_locked)}}})]):_vm._e(),_vm._v(" "),_c('app-tooltip',{attrs:{"text":"Edit Event Details, Change Event Restrictions","align":"right"}},[_c('router-link',{staticClass:"icon-btn icon-btn--edit",attrs:{"to":{ name: 'Event Edit', params: { id: _vm.draftId, eventId: row.parent_id != null ? row.parent_id : row.id } }}})],1),_vm._v(" "),(row.parent_id === null && row.split_kind !== _vm.EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL)?_c('app-tooltip',{attrs:{"text":"Delete Event","align":"right"}},[_c('button',{staticClass:"btn-actions btn-delete",attrs:{"disabled":_vm.deleting},on:{"click":function($event){return _vm.$emit('confirm-delete', row)}}})]):_vm._e()],1):_vm._e()]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDashboardNominations_vue__ = __webpack_require__(1244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6106a1c9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDashboardNominations_vue__ = __webpack_require__(1348);
function injectStyle (ssrContext) {
  __webpack_require__(1332)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6106a1c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDashboardNominations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6106a1c9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDashboardNominations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1333);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("ad0e6192", content, true, {});

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".bulk-action-group__label[data-v-6106a1c9]{display:block;font-weight:600;margin-bottom:.25rem}.bulk-action-group__select[data-v-6106a1c9]{min-width:160px}.nominations-section__event-name[data-v-6106a1c9]{font-size:2rem;font-weight:600}.blocked-accept[data-v-6106a1c9]{position:relative}.blocked-accept__close[data-v-6106a1c9]{position:absolute;top:.5rem;right:.75rem}.blocked-accept__row[data-v-6106a1c9]{display:flex;align-items:center;padding:.15rem 0}.blocked-accept__search[data-v-6106a1c9]{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:24px;height:24px;margin-right:.5rem;padding:0;border:1px solid currentColor;border-radius:4px;background:transparent;color:inherit;cursor:pointer;opacity:.75}.blocked-accept__search[data-v-6106a1c9]:hover{opacity:1}.blocked-accept__name[data-v-6106a1c9]{line-height:1.3}@media only screen and (max-width:600px){.action-buttons[data-v-6106a1c9]{flex-direction:column}.action-buttons__right[data-v-6106a1c9]{margin-top:1rem}.action-buttons__right .justify-content-end[data-v-6106a1c9]{justify-content:flex-start!important}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Committees/Dashboard/components/CommitteeDashboardNominations.vue"],"names":[],"mappings":"AACA,2CACE,cAAe,AACf,gBAAiB,AACjB,oBAAuB,CACxB,AACD,4CACE,eAAiB,CAClB,AACD,kDACE,eAAgB,AAChB,eAAiB,CAClB,AACD,iCACE,iBAAmB,CACpB,AACD,wCACE,kBAAmB,AACnB,UAAY,AACZ,YAAe,CAChB,AACD,sCACE,aAAc,AACd,mBAAoB,AACpB,gBAAmB,CACpB,AACD,yCACE,oBAAqB,AACrB,mBAAoB,AACpB,uBAAwB,AACxB,cAAe,AACf,WAAY,AACZ,YAAa,AACb,mBAAqB,AACrB,UAAW,AACX,8BAA+B,AAC/B,kBAAmB,AACnB,uBAAwB,AACxB,cAAe,AACf,eAAgB,AAChB,WAAc,CACf,AACD,+CACE,SAAW,CACZ,AACD,uCACE,eAAiB,CAClB,AACD,yCACA,iCACI,qBAAuB,CAC1B,AACD,wCACI,eAAiB,CACpB,AACD,6DACI,oCAAuC,CAC1C,CACA","file":"CommitteeDashboardNominations.vue","sourcesContent":["\n.bulk-action-group__label[data-v-6106a1c9] {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n.bulk-action-group__select[data-v-6106a1c9] {\n  min-width: 160px;\n}\n.nominations-section__event-name[data-v-6106a1c9] {\n  font-size: 2rem;\n  font-weight: 600;\n}\n.blocked-accept[data-v-6106a1c9] {\n  position: relative;\n}\n.blocked-accept__close[data-v-6106a1c9] {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.75rem;\n}\n.blocked-accept__row[data-v-6106a1c9] {\n  display: flex;\n  align-items: center;\n  padding: 0.15rem 0;\n}\n.blocked-accept__search[data-v-6106a1c9] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  margin-right: 0.5rem;\n  padding: 0;\n  border: 1px solid currentColor;\n  border-radius: 4px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  opacity: 0.75;\n}\n.blocked-accept__search[data-v-6106a1c9]:hover {\n  opacity: 1;\n}\n.blocked-accept__name[data-v-6106a1c9] {\n  line-height: 1.3;\n}\n@media only screen and (max-width: 600px) {\n.action-buttons[data-v-6106a1c9] {\n    flex-direction: column;\n}\n.action-buttons__right[data-v-6106a1c9] {\n    margin-top: 1rem;\n}\n.action-buttons__right .justify-content-end[data-v-6106a1c9] {\n    justify-content: flex-start !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsDashboardTable_vue__ = __webpack_require__(1245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ce659c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsDashboardTable_vue__ = __webpack_require__(1338);
function injectStyle (ssrContext) {
  __webpack_require__(1335)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58ce659c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationsDashboardTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ce659c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationsDashboardTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1336);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("325a763e", content, true, {});

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".member_name[data-v-58ce659c]{font-size:.85em;color:#888}.nom-ntbp-icon[data-v-58ce659c]{display:inline-block;vertical-align:middle;margin-left:6px;position:relative;top:2px}.invoice-not-sent-icon[data-v-58ce659c],.invoice-sent-icon[data-v-58ce659c]{display:inline-block;background-repeat:no-repeat;cursor:default}.invoice-sent-icon[data-v-58ce659c]{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='32' height='17' viewBox='0 0 32 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M31.4415 16.2083C31.4535 16.2059 31.4652 16.2027 31.4771 16.1996C31.4872 16.197 31.4974 16.1949 31.5073 16.1919C31.5188 16.1883 31.5301 16.184 31.5414 16.1799C31.5514 16.1763 31.5615 16.1731 31.5714 16.1689C31.582 16.1645 31.5923 16.1593 31.6026 16.1544C31.6127 16.1496 31.623 16.1451 31.6329 16.1398C31.6428 16.1345 31.6522 16.1285 31.6618 16.1227C31.6717 16.1168 31.6817 16.1113 31.6913 16.1048C31.7016 16.0979 31.7111 16.0903 31.721 16.0829C31.7293 16.0767 31.7378 16.0709 31.746 16.0643C31.761 16.052 31.7752 16.0388 31.7891 16.0253C31.7916 16.0229 31.7943 16.0209 31.7968 16.0184C31.7994 16.0158 31.8016 16.0129 31.8041 16.0102C31.8174 15.9965 31.8304 15.9825 31.8426 15.9677C31.8497 15.959 31.8559 15.9499 31.8626 15.9409C31.8694 15.9317 31.8766 15.9227 31.883 15.9131C31.8899 15.9028 31.8959 15.8922 31.9022 15.8816C31.9074 15.8727 31.9131 15.864 31.918 15.8549C31.9237 15.8442 31.9285 15.8332 31.9336 15.8224C31.9382 15.8128 31.943 15.8032 31.9471 15.7933C31.9516 15.7827 31.9551 15.7719 31.959 15.761C31.9628 15.7505 31.9668 15.74 31.9701 15.7293C31.9734 15.7184 31.9758 15.7073 31.9786 15.6962C31.9813 15.6853 31.9844 15.6745 31.9866 15.6635C31.9891 15.6505 31.9907 15.6373 31.9926 15.6242C31.9939 15.6149 31.9956 15.6058 31.9965 15.5964C31.9989 15.5734 32.0001 15.5503 32.0001 15.5272V0.693972C32.0001 0.310622 31.6894 0 31.3061 0H9.44595C9.43984 0 9.43392 0.000739729 9.42781 0.000924788C9.41458 0.00129491 9.40144 0.00185038 9.3883 0.00296073C9.37785 0.0037935 9.36748 0.00499662 9.35712 0.00638457C9.34527 0.00786504 9.33352 0.00962298 9.32177 0.0117512C9.31076 0.0136943 9.29984 0.0160073 9.28902 0.0185056C9.27801 0.0210965 9.26699 0.0238726 9.25608 0.0270186C9.24525 0.0300721 9.23461 0.0334027 9.22406 0.0369188C9.21323 0.04062 9.20241 0.0445068 9.19177 0.0487632C9.18168 0.0527419 9.17178 0.0568127 9.16197 0.0612542C9.15105 0.0661582 9.14023 0.071433 9.1295 0.0768923C9.12034 0.0816113 9.11136 0.0864225 9.10248 0.0915117C9.09174 0.0976186 9.08119 0.104096 9.07074 0.110758C9.06213 0.11631 9.05371 0.122046 9.04539 0.127876C9.03558 0.134815 9.02586 0.142033 9.01633 0.14962C9.00763 0.15656 8.99912 0.163685 8.9907 0.170995C8.98237 0.178305 8.97414 0.185614 8.96609 0.193387C8.95693 0.202177 8.94814 0.211337 8.93944 0.22059C8.93509 0.225217 8.93046 0.229288 8.9263 0.234007C8.9238 0.236783 8.92186 0.239837 8.91945 0.242613C8.91076 0.252699 8.90261 0.263247 8.89447 0.273888C8.88855 0.28166 8.88244 0.289432 8.87689 0.29739C8.86967 0.307753 8.86301 0.318394 8.85635 0.329128C8.85089 0.337918 8.84524 0.346616 8.84025 0.355591C8.83442 0.365954 8.82933 0.376595 8.82405 0.387236C8.81924 0.396952 8.81425 0.406668 8.8099 0.416568C8.80536 0.427024 8.80138 0.43785 8.79741 0.448491C8.79343 0.458947 8.78936 0.46931 8.78593 0.479858C8.78251 0.490499 8.77973 0.501325 8.77677 0.512151C8.77381 0.523255 8.77067 0.534266 8.76817 0.545462C8.76585 0.555918 8.76428 0.566559 8.76243 0.577107C8.76039 0.589136 8.75836 0.601165 8.75688 0.613194C8.75568 0.623187 8.75512 0.633365 8.75438 0.643543C8.75345 0.656497 8.75262 0.669452 8.75244 0.682499C8.75234 0.686292 8.75188 0.689994 8.75188 0.693787V4.97347C8.75188 5.35682 9.0625 5.66744 9.44585 5.66744C9.82921 5.66744 10.1398 5.35682 10.1398 4.97347V2.23505L16.3098 7.69773C16.2776 7.7204 16.2466 7.74547 16.2177 7.77425L10.1397 13.8522V9.29164C10.1397 8.90829 9.82911 8.59767 9.44576 8.59767C9.06241 8.59767 8.75179 8.90829 8.75179 9.29164V10.1396H5.16626C4.78291 10.1396 4.47229 10.4502 4.47229 10.8336C4.47229 11.2169 4.78291 11.5275 5.16626 11.5275H8.75179V15.5277C8.75179 15.911 9.06241 16.2216 9.44576 16.2216H31.3059C31.3288 16.2216 31.3516 16.2204 31.3744 16.2182C31.385 16.2172 31.3953 16.2152 31.4057 16.2137C31.4178 16.212 31.4296 16.2106 31.4415 16.2083ZM30.612 13.8523L24.5339 7.77434C24.53 7.77045 24.5259 7.76722 24.5219 7.76351L29.0913 3.8868C29.3835 3.63882 29.4194 3.20097 29.1714 2.90867C28.9236 2.61655 28.4858 2.58047 28.1933 2.82854L20.3856 9.45274L11.2766 1.38804H30.612V13.8523ZM17.1993 8.7559C17.2488 8.70639 17.289 8.65124 17.3203 8.59258L19.9159 10.8906C20.0471 11.0067 20.2114 11.065 20.3759 11.065C20.5356 11.065 20.6952 11.0101 20.825 10.9002L23.4701 8.65596C23.4942 8.69112 23.5213 8.72471 23.5525 8.7559L29.6305 14.8339H11.1213L17.1993 8.7559Z' fill='%2320A81E'/%3e%3cpath d='M0.693973 7.90357H12.4144C12.7978 7.90357 13.1084 7.59295 13.1084 7.2096C13.1084 6.82625 12.7978 6.51562 12.4144 6.51562H0.693973C0.310622 6.51562 0 6.82625 0 7.2096C0 7.59295 0.310622 7.90357 0.693973 7.90357Z' fill='%2320A81E'/%3e%3cpath d='M1.90851 4.07886H7.17114C7.55449 4.07886 7.86511 3.76824 7.86511 3.38489C7.86511 3.00154 7.55449 2.69092 7.17114 2.69092H1.90851C1.52516 2.69092 1.21454 3.00154 1.21454 3.38489C1.21454 3.76824 1.52516 4.07886 1.90851 4.07886Z' fill='%2320A81E'/%3e%3cpath d='M5.7831 13.0693H0.693973C0.310622 13.0693 0 13.38 0 13.7633C0 14.1467 0.310622 14.4573 0.693973 14.4573H5.7831C6.16645 14.4573 6.47708 14.1467 6.47708 13.7633C6.47708 13.38 6.16645 13.0693 5.7831 13.0693Z' fill='%2320A81E'/%3e%3c/svg%3e\");width:30px;height:30px;background-size:30px 30px}.invoice-not-sent-icon[data-v-58ce659c]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='27' height='23' viewBox='0 0 27 23' fill='none'%3E%3Cpath d='M3.164 10.052V.743c0-.411.36-.743.791-.743H26.21c.433 0 .791.334.791.743v13.383c0 .41-.354.744-.791.744H14.194c.029.244.044.492.044.743 0 3.69-3.193 6.691-7.119 6.691C3.194 22.304 0 19.303 0 15.613c0-2.315 1.258-4.36 3.164-5.56zm3.26-8.565l8.607 5.78 8.69-5.78H6.424zm18.994 11.896V2.18l-9.932 6.605a.825.825 0 0 1-.917-.002L4.746 2.188v7.116a7.495 7.495 0 0 1 2.373-.382c3.094 0 5.733 1.864 6.712 4.46h11.587zM7.119 20.817c3.053 0 5.537-2.334 5.537-5.204 0-2.87-2.484-5.204-5.537-5.204s-5.537 2.334-5.537 5.204c0 2.87 2.484 5.204 5.537 5.204z' fill='%23D92340'/%3E%3Cpath d='M9.979 17.605l-4.693-4.692a.831.831 0 0 0-1.175.002.831.831 0 0 0-.003 1.176l4.693 4.692a.831.831 0 0 0 1.175-.002.831.831 0 0 0 .003-1.176z' fill='%23D92340'/%3E%3Cpath d='M5.286 18.784l4.693-4.692a.831.831 0 0 0-.003-1.176.831.831 0 0 0-1.175-.002l-4.693 4.692a.831.831 0 0 0 .003 1.176.831.831 0 0 0 1.175.002z' fill='%23D92340'/%3E%3C/svg%3E\");width:26px;height:26px;background-size:26px 26px}@media (max-width:848px){[data-v-58ce659c] .gt__row--head{display:none}}.multiselect__option--highlight .green_text[data-v-58ce659c],.multiselect__option--highlight .red_text[data-v-58ce659c]{color:#fff}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/components/NominationsDashboardTable.vue"],"names":[],"mappings":"AACA,8BACE,gBAAkB,AAClB,UAAY,CACb,AACD,gCACE,qBAAsB,AACtB,sBAAuB,AACvB,gBAAiB,AACjB,kBAAmB,AACnB,OAAS,CACV,AACD,4EAEE,qBAAsB,AACtB,4BAA6B,AAC7B,cAAgB,CACjB,AACD,oCACE,kjKAAmjK,AACnjK,WAAY,AACZ,YAAa,AACb,yBAA2B,CAC5B,AACD,wCACE,ikCAAgjD,AAChjD,WAAY,AACZ,YAAa,AACb,yBAA2B,CAC5B,AACD,yBACA,iCACI,YAAc,CACjB,CACA,AACD,wHAEE,UAAY,CACb","file":"NominationsDashboardTable.vue","sourcesContent":["\n.member_name[data-v-58ce659c] {\n  font-size: 0.85em;\n  color: #888;\n}\n.nom-ntbp-icon[data-v-58ce659c] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 6px;\n  position: relative;\n  top: 2px;\n}\n.invoice-sent-icon[data-v-58ce659c],\n.invoice-not-sent-icon[data-v-58ce659c] {\n  display: inline-block;\n  background-repeat: no-repeat;\n  cursor: default;\n}\n.invoice-sent-icon[data-v-58ce659c] {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='32' height='17' viewBox='0 0 32 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M31.4415 16.2083C31.4535 16.2059 31.4652 16.2027 31.4771 16.1996C31.4872 16.197 31.4974 16.1949 31.5073 16.1919C31.5188 16.1883 31.5301 16.184 31.5414 16.1799C31.5514 16.1763 31.5615 16.1731 31.5714 16.1689C31.582 16.1645 31.5923 16.1593 31.6026 16.1544C31.6127 16.1496 31.623 16.1451 31.6329 16.1398C31.6428 16.1345 31.6522 16.1285 31.6618 16.1227C31.6717 16.1168 31.6817 16.1113 31.6913 16.1048C31.7016 16.0979 31.7111 16.0903 31.721 16.0829C31.7293 16.0767 31.7378 16.0709 31.746 16.0643C31.761 16.052 31.7752 16.0388 31.7891 16.0253C31.7916 16.0229 31.7943 16.0209 31.7968 16.0184C31.7994 16.0158 31.8016 16.0129 31.8041 16.0102C31.8174 15.9965 31.8304 15.9825 31.8426 15.9677C31.8497 15.959 31.8559 15.9499 31.8626 15.9409C31.8694 15.9317 31.8766 15.9227 31.883 15.9131C31.8899 15.9028 31.8959 15.8922 31.9022 15.8816C31.9074 15.8727 31.9131 15.864 31.918 15.8549C31.9237 15.8442 31.9285 15.8332 31.9336 15.8224C31.9382 15.8128 31.943 15.8032 31.9471 15.7933C31.9516 15.7827 31.9551 15.7719 31.959 15.761C31.9628 15.7505 31.9668 15.74 31.9701 15.7293C31.9734 15.7184 31.9758 15.7073 31.9786 15.6962C31.9813 15.6853 31.9844 15.6745 31.9866 15.6635C31.9891 15.6505 31.9907 15.6373 31.9926 15.6242C31.9939 15.6149 31.9956 15.6058 31.9965 15.5964C31.9989 15.5734 32.0001 15.5503 32.0001 15.5272V0.693972C32.0001 0.310622 31.6894 0 31.3061 0H9.44595C9.43984 0 9.43392 0.000739729 9.42781 0.000924788C9.41458 0.00129491 9.40144 0.00185038 9.3883 0.00296073C9.37785 0.0037935 9.36748 0.00499662 9.35712 0.00638457C9.34527 0.00786504 9.33352 0.00962298 9.32177 0.0117512C9.31076 0.0136943 9.29984 0.0160073 9.28902 0.0185056C9.27801 0.0210965 9.26699 0.0238726 9.25608 0.0270186C9.24525 0.0300721 9.23461 0.0334027 9.22406 0.0369188C9.21323 0.04062 9.20241 0.0445068 9.19177 0.0487632C9.18168 0.0527419 9.17178 0.0568127 9.16197 0.0612542C9.15105 0.0661582 9.14023 0.071433 9.1295 0.0768923C9.12034 0.0816113 9.11136 0.0864225 9.10248 0.0915117C9.09174 0.0976186 9.08119 0.104096 9.07074 0.110758C9.06213 0.11631 9.05371 0.122046 9.04539 0.127876C9.03558 0.134815 9.02586 0.142033 9.01633 0.14962C9.00763 0.15656 8.99912 0.163685 8.9907 0.170995C8.98237 0.178305 8.97414 0.185614 8.96609 0.193387C8.95693 0.202177 8.94814 0.211337 8.93944 0.22059C8.93509 0.225217 8.93046 0.229288 8.9263 0.234007C8.9238 0.236783 8.92186 0.239837 8.91945 0.242613C8.91076 0.252699 8.90261 0.263247 8.89447 0.273888C8.88855 0.28166 8.88244 0.289432 8.87689 0.29739C8.86967 0.307753 8.86301 0.318394 8.85635 0.329128C8.85089 0.337918 8.84524 0.346616 8.84025 0.355591C8.83442 0.365954 8.82933 0.376595 8.82405 0.387236C8.81924 0.396952 8.81425 0.406668 8.8099 0.416568C8.80536 0.427024 8.80138 0.43785 8.79741 0.448491C8.79343 0.458947 8.78936 0.46931 8.78593 0.479858C8.78251 0.490499 8.77973 0.501325 8.77677 0.512151C8.77381 0.523255 8.77067 0.534266 8.76817 0.545462C8.76585 0.555918 8.76428 0.566559 8.76243 0.577107C8.76039 0.589136 8.75836 0.601165 8.75688 0.613194C8.75568 0.623187 8.75512 0.633365 8.75438 0.643543C8.75345 0.656497 8.75262 0.669452 8.75244 0.682499C8.75234 0.686292 8.75188 0.689994 8.75188 0.693787V4.97347C8.75188 5.35682 9.0625 5.66744 9.44585 5.66744C9.82921 5.66744 10.1398 5.35682 10.1398 4.97347V2.23505L16.3098 7.69773C16.2776 7.7204 16.2466 7.74547 16.2177 7.77425L10.1397 13.8522V9.29164C10.1397 8.90829 9.82911 8.59767 9.44576 8.59767C9.06241 8.59767 8.75179 8.90829 8.75179 9.29164V10.1396H5.16626C4.78291 10.1396 4.47229 10.4502 4.47229 10.8336C4.47229 11.2169 4.78291 11.5275 5.16626 11.5275H8.75179V15.5277C8.75179 15.911 9.06241 16.2216 9.44576 16.2216H31.3059C31.3288 16.2216 31.3516 16.2204 31.3744 16.2182C31.385 16.2172 31.3953 16.2152 31.4057 16.2137C31.4178 16.212 31.4296 16.2106 31.4415 16.2083ZM30.612 13.8523L24.5339 7.77434C24.53 7.77045 24.5259 7.76722 24.5219 7.76351L29.0913 3.8868C29.3835 3.63882 29.4194 3.20097 29.1714 2.90867C28.9236 2.61655 28.4858 2.58047 28.1933 2.82854L20.3856 9.45274L11.2766 1.38804H30.612V13.8523ZM17.1993 8.7559C17.2488 8.70639 17.289 8.65124 17.3203 8.59258L19.9159 10.8906C20.0471 11.0067 20.2114 11.065 20.3759 11.065C20.5356 11.065 20.6952 11.0101 20.825 10.9002L23.4701 8.65596C23.4942 8.69112 23.5213 8.72471 23.5525 8.7559L29.6305 14.8339H11.1213L17.1993 8.7559Z' fill='%2320A81E'/%3e%3cpath d='M0.693973 7.90357H12.4144C12.7978 7.90357 13.1084 7.59295 13.1084 7.2096C13.1084 6.82625 12.7978 6.51562 12.4144 6.51562H0.693973C0.310622 6.51562 0 6.82625 0 7.2096C0 7.59295 0.310622 7.90357 0.693973 7.90357Z' fill='%2320A81E'/%3e%3cpath d='M1.90851 4.07886H7.17114C7.55449 4.07886 7.86511 3.76824 7.86511 3.38489C7.86511 3.00154 7.55449 2.69092 7.17114 2.69092H1.90851C1.52516 2.69092 1.21454 3.00154 1.21454 3.38489C1.21454 3.76824 1.52516 4.07886 1.90851 4.07886Z' fill='%2320A81E'/%3e%3cpath d='M5.7831 13.0693H0.693973C0.310622 13.0693 0 13.38 0 13.7633C0 14.1467 0.310622 14.4573 0.693973 14.4573H5.7831C6.16645 14.4573 6.47708 14.1467 6.47708 13.7633C6.47708 13.38 6.16645 13.0693 5.7831 13.0693Z' fill='%2320A81E'/%3e%3c/svg%3e\");\n  width: 30px;\n  height: 30px;\n  background-size: 30px 30px;\n}\n.invoice-not-sent-icon[data-v-58ce659c] {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='27' height='23' viewBox='0 0 27 23' fill='none'%3E%3Cpath d='M3.16406 10.0521V0.743478C3.16406 0.331938 3.52387 0 3.95508 0H26.209C26.6423 0 27 0.333624 27 0.743478V14.1261C27 14.5367 26.6458 14.8696 26.209 14.8696H14.1941C14.2229 15.1138 14.2383 15.3618 14.2383 15.613C14.2383 19.3026 11.0446 22.3044 7.11914 22.3044C3.19365 22.3044 0 19.3026 0 15.613C0 13.298 1.25751 11.2539 3.16406 10.0521ZM6.42342 1.48696L15.0315 7.26606L23.7215 1.48696H6.42342ZM25.418 13.3826V2.18028L15.4862 8.78519C15.3493 8.87624 15.1893 8.92174 15.0293 8.92174C14.8681 8.92174 14.707 8.87555 14.5695 8.78326L4.74609 2.18821V9.30449C5.4887 9.05696 6.28741 8.92174 7.11914 8.92174C10.2129 8.92174 12.8516 10.7864 13.8311 13.3826H25.418ZM7.11914 20.8174C10.1723 20.8174 12.6562 18.4827 12.6562 15.613C12.6562 12.7434 10.1723 10.4087 7.11914 10.4087C4.06598 10.4087 1.58203 12.7434 1.58203 15.613C1.58203 18.4827 4.06598 20.8174 7.11914 20.8174Z' fill='%23D92340'/%3E%3Cpath d='M9.97867 17.6053L5.2861 12.9127C4.96216 12.5888 4.43587 12.5898 4.11066 12.915C3.78544 13.2403 3.78441 13.7665 4.10836 14.0905L8.80093 18.7831C9.12487 19.107 9.65116 19.106 9.97637 18.7808C10.3016 18.4556 10.3026 17.9293 9.97867 17.6053Z' fill='%23D92340'/%3E%3Cpath d='M5.28616 18.784L9.97873 14.0915C10.3027 13.7675 10.3016 13.2412 9.97643 12.916C9.65122 12.5908 9.12493 12.5898 8.80099 12.9137L4.10841 17.6063C3.78447 17.9302 3.7855 18.4565 4.11071 18.7817C4.43593 19.1069 4.96221 19.108 5.28616 18.784Z' fill='%23D92340'/%3E%3C/svg%3E\");\n  width: 26px;\n  height: 26px;\n  background-size: 26px 26px;\n}\n@media (max-width: 848px) {\n[data-v-58ce659c] .gt__row--head {\n    display: none;\n}\n}\n.multiselect__option--highlight .red_text[data-v-58ce659c],\n.multiselect__option--highlight .green_text[data-v-58ce659c] {\n  color: #fff;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-multiselect',{class:_vm.sizeClass,attrs:{"value":_vm.selectedOption,"options":_vm.options,"label":"label","track-by":"value","searchable":false,"allow-empty":false,"select-label":"","deselect-label":"","selected-label":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-table',{attrs:{"columns":_vm.tableColumns,"rows":_vm.rows,"loading":_vm.loading,"mob-break":0,"tab-break":768,"tab-align-top":"","empty-text":"No nominations found."},scopedSlots:_vm._u([(_vm.$scopedSlots['before-row'])?{key:"before-row",fn:function(ref){
var row = ref.row;
return [_vm._t("before-row",null,{"row":row})]}}:null,{key:"cell:account",fn:function(ref){
var row = ref.row;
return [_c('small',[_vm._v("#"+_vm._s(row.user.member_number))])]}},{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('span',[_vm._v(_vm._s(row.user.full_name))]),_vm._v(" "),(row.user.deleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"js-membersCount"},[_vm._v(" ("+_vm._s(row.nominations.length)+")")]),_vm._v(" "),(row.needs_to_be_processed)?_c('i',{staticClass:"nomination_need_to_be_processed nom-ntbp-icon",attrs:{"title":"The user has unprocessed nominations after the draft rules has changed."}}):_vm._e(),_vm._v(" "),_vm._l((row.members),function(m){return _c('div',{key:m.id,staticClass:"member_name"},[_vm._v("\n        "+_vm._s(m.full_name)+"\n        "),(m.is_event_member)?_c('span',[_vm._v(" (EM)")]):_vm._e(),_vm._v(" "),(m.deleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e()])})],2)]}},{key:"cell:list",fn:function(ref){
var row = ref.row;
return [_c('nomination-list-select',{attrs:{"value":row.list,"size-class":"multiselect--sm"},on:{"input":function($event){_vm.moveGroup != null && _vm.moveGroup(row, $event)}}})]}},{key:"cell:suburb",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.user.suburb)),(row.user.distance_to_draft != null)?[_vm._v(" ("+_vm._s(row.user.distance_to_draft)+" km)")]:_vm._e()],2)]}},{key:"cell:payment",fn:function(ref){
var row = ref.row;
return [(_vm.activeList === 'accept' && !_vm.eventMode)?_c('app-multiselect',{key:("payment-" + (row.user.id) + "-" + _vm.errorKey),staticClass:"multiselect--sm",class:_vm.paymentClass(row),attrs:{"value":_vm.groupPaymentOption(row),"options":_vm.paymentStatusOptions,"label":"label","track-by":"value","searchable":false,"allow-empty":false,"placeholder":"-","select-label":"","deselect-label":"","selected-label":"","size-class":"multiselect--sm"},on:{"select":function($event){$event != null && $event.value === 2 && _vm.$emit('open-partial-payment', row)},"input":function($event){$event != null && $event.value !== 2 && _vm.$emit('payment-status-change', row, $event.value)}},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [(option.value === 2)?_c('span',{class:_vm.paymentOptionClass(option.value),staticStyle:{"display":"block","width":"100%"},on:{"click":function($event){_vm.groupPaymentOption(row) != null && _vm.groupPaymentOption(row).value === 2 && _vm.$emit('open-partial-payment', row)}}},[_vm._v(_vm._s(option.label))]):_c('span',{class:_vm.paymentOptionClass(option.value)},[_vm._v(_vm._s(option.label))])]}}],null,true)}):_vm._e()]}},{key:"cell:comment",fn:function(ref){
var row = ref.row;
return [(_vm.activeList === 'accept' && !_vm.eventMode)?_c('app-multiselect',{key:("commit-" + (row.user.id) + "-" + _vm.errorKey),staticClass:"multiselect--sm",attrs:{"value":_vm.groupCommitOption(row),"options":_vm.commitOptionsWithNull,"label":"label","track-by":"value","searchable":false,"allow-empty":false,"placeholder":"Payment type","select-label":"","deselect-label":"","selected-label":"","size-class":"multiselect--sm"},on:{"input":function($event){$event != null && _vm.$emit('commit-change', row, $event.value)}}}):_vm._e()]}},(_vm.activeList === 'accept' && !_vm.eventMode)?{key:"cell:amount",fn:function(ref){
var row = ref.row;
return [_c('strong',[_vm._v(_vm._s(_vm.formatAmount(_vm.unpaidAmount(row))))])]}}:null,{key:"cell:actions",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"15px"}},[(_vm.activeList === 'accept')?_c('i',{class:row.invoice_is_sent ? 'invoice-sent-icon' : 'invoice-not-sent-icon',attrs:{"title":row.invoice_is_sent ? 'Invoice sent.' : 'Invoice not sent.'}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"icon-btn icon-btn--edit",attrs:{"title":"View/edit nominations"},on:{"click":function($event){return _vm.$emit('open-detail', row)}}}),_vm._v(" "),(_vm.selectable)?_c('f-checkbox',{staticClass:"mb-0",attrs:{"id":("row-check-" + (row.user.id)),"label":"","value":_vm.selectedIds.indexOf(row.user.id) !== -1},on:{"input":function($event){return _vm.$emit('toggle-select', row.user.id)}}}):_vm._e()],1)]}}],null,true)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationAccountDetailPopup_vue__ = __webpack_require__(1248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49da1c5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationAccountDetailPopup_vue__ = __webpack_require__(1343);
function injectStyle (ssrContext) {
  __webpack_require__(1340)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49da1c5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominationAccountDetailPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49da1c5c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominationAccountDetailPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1341);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("4047ed5f", content, true, {});

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".nom-detail-popup[data-v-49da1c5c]{position:relative;min-width:560px}.nom-detail-popup__overlay[data-v-49da1c5c]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:hsla(0,0%,100%,.6);z-index:5}.nom-detail-popup__toolbar[data-v-49da1c5c]{display:flex;align-items:center;gap:12px}.nom-detail-popup__member[data-v-49da1c5c]{margin-bottom:4px}.nom-detail-popup__member-header[data-v-49da1c5c]{padding:5px 20px 5px 0;margin-bottom:4px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.nom-detail-popup__member-header--toggle[data-v-49da1c5c]{display:flex;align-items:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.nom-detail-popup__member-name[data-v-49da1c5c]{font-size:16px;font-weight:600;color:#000}.nom-detail-popup__event[data-v-49da1c5c]{margin-bottom:4px}.nom-detail-popup__event-header[data-v-49da1c5c]{font-size:13px;font-weight:600;color:#666;padding:5px 20px;height:30px;line-height:21px;margin-bottom:4px}.nom-detail-popup__event-header--toggle[data-v-49da1c5c]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.nom-detail-popup__chevron[data-v-49da1c5c]{display:inline-block;width:7px;height:7px;border-bottom:2px solid #000;border-right:2px solid #000;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:center center;transform-origin:center center;transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;flex-shrink:0;margin:2px 0 0 8px}.nom-detail-popup__chevron--open[data-v-49da1c5c]{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.nom-detail-popup__chevron--sm[data-v-49da1c5c]{border-color:#666}.nom-detail-popup__order[data-v-49da1c5c]{font-size:.8em;color:#666;width:100%;text-align:center}.nom-detail-popup__horse-name[data-v-49da1c5c]{font-weight:500}.nom-detail-popup__quantity-input[data-v-49da1c5c]{max-width:100px}.nom-detail-popup__invoice-block[data-v-49da1c5c]{display:flex;align-items:center;gap:8px;margin-right:36px}.nom-detail-popup__download-link[data-v-49da1c5c]{display:flex;align-items:center;color:var(--primary);&:hover{color:var(--primary-dark)}&\\--disabled{opacity:.4;cursor:pointer}&\\--loading{cursor:default;pointer-events:none}}.nom-detail-popup__btn[data-v-49da1c5c]{font-size:.9rem}.nom-detail-popup__spinner[data-v-49da1c5c]{display:inline-block;width:16px;height:16px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;-webkit-animation:nom-spin-data-v-49da1c5c .7s linear infinite;animation:nom-spin-data-v-49da1c5c .7s linear infinite}@-webkit-keyframes nom-spin-data-v-49da1c5c{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes nom-spin-data-v-49da1c5c{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.nom-detail-popup__move-link[data-v-49da1c5c]{font-size:.8rem;color:var(--primary);cursor:pointer;white-space:nowrap;&:hover{color:var(--primary-dark);text-decoration:underline}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/components/NominationAccountDetailPopup.vue"],"names":[],"mappings":"AACA,mCACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,4CACE,kBAAmB,AACnB,QAAS,AACT,aAAc,AACd,mBAAoB,AACpB,uBAAwB,AACxB,8BAAqC,AACrC,SAAW,CACZ,AACD,4CACE,aAAc,AACd,mBAAoB,AACpB,QAAU,CACX,AACD,2CACE,iBAAmB,CACpB,AACD,kDACE,uBAAwB,AACxB,kBAAmB,AACnB,0BAA2B,AAC3B,uBAAwB,AACxB,iBAAmB,CACpB,AACD,0DACE,aAAc,AACd,mBAAoB,AACpB,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,gDACE,eAAgB,AAChB,gBAAiB,AACjB,UAAY,CACb,AACD,0CACE,iBAAmB,CACpB,AACD,iDACE,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,yDACE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,4CACE,qBAAsB,AACtB,UAAW,AACX,WAAY,AACZ,6BAA8B,AAC9B,4BAA6B,AAC7B,iCAAkC,AAC1B,yBAA0B,AAClC,uCAAwC,AAChC,+BAAgC,AACxC,0CAA4C,AAC5C,kCAAoC,AACpC,iEAAqE,AACrE,cAAe,AACf,kBAAoB,CACrB,AACD,kDACE,gCAAiC,AACzB,uBAAyB,CAClC,AACD,gDACE,iBAAmB,CACpB,AACD,0CACE,eAAiB,AACjB,WAAY,AACZ,WAAY,AACZ,iBAAmB,CACpB,AACD,+CACE,eAAiB,CAClB,AACD,mDACE,eAAiB,CAClB,AACD,kDACE,aAAc,AACd,mBAAoB,AACpB,QAAS,AACT,iBAAmB,CACpB,AACD,kDACE,aAAc,AACd,mBAAoB,AACpB,qBAAsB,AACxB,QACI,yBAA2B,CAC9B,AACD,aACI,WAAa,AACb,cAAgB,CACnB,AACD,YACI,eAAgB,AAChB,mBAAqB,CACxB,CACA,AACD,wCACE,eAAkB,CACnB,AACD,4CACE,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,8BAA+B,AAC/B,6BAA8B,AAC9B,kBAAmB,AACnB,+DAAiE,AACzD,sDAAyD,CAClE,AACD,4CACA,GAAK,gCAAkC,AAAC,uBAA0B,CACjE,CACA,AACD,oCACA,GAAK,gCAAkC,AAAC,uBAA0B,CACjE,CACA,AACD,8CACE,gBAAkB,AAClB,qBAAsB,AACtB,eAAgB,AAChB,mBAAoB,AACtB,QACI,0BAA2B,AAC3B,yBAA2B,CAC9B,CACA","file":"NominationAccountDetailPopup.vue","sourcesContent":["\n.nom-detail-popup[data-v-49da1c5c] {\n  position: relative;\n  min-width: 560px;\n}\n.nom-detail-popup__overlay[data-v-49da1c5c] {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.6);\n  z-index: 5;\n}\n.nom-detail-popup__toolbar[data-v-49da1c5c] {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.nom-detail-popup__member[data-v-49da1c5c] {\n  margin-bottom: 4px;\n}\n.nom-detail-popup__member-header[data-v-49da1c5c] {\n  padding: 5px 20px 5px 0;\n  margin-bottom: 4px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.nom-detail-popup__member-header--toggle[data-v-49da1c5c] {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.nom-detail-popup__member-name[data-v-49da1c5c] {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000;\n}\n.nom-detail-popup__event[data-v-49da1c5c] {\n  margin-bottom: 4px;\n}\n.nom-detail-popup__event-header[data-v-49da1c5c] {\n  font-size: 13px;\n  font-weight: 600;\n  color: #666;\n  padding: 5px 20px;\n  height: 30px;\n  line-height: 21px;\n  margin-bottom: 4px;\n}\n.nom-detail-popup__event-header--toggle[data-v-49da1c5c] {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.nom-detail-popup__chevron[data-v-49da1c5c] {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-bottom: 2px solid #000;\n  border-right: 2px solid #000;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  flex-shrink: 0;\n  margin: 2px 0 0 8px;\n}\n.nom-detail-popup__chevron--open[data-v-49da1c5c] {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.nom-detail-popup__chevron--sm[data-v-49da1c5c] {\n  border-color: #666;\n}\n.nom-detail-popup__order[data-v-49da1c5c] {\n  font-size: 0.8em;\n  color: #666;\n  width: 100%;\n  text-align: center;\n}\n.nom-detail-popup__horse-name[data-v-49da1c5c] {\n  font-weight: 500;\n}\n.nom-detail-popup__quantity-input[data-v-49da1c5c] {\n  max-width: 100px;\n}\n.nom-detail-popup__invoice-block[data-v-49da1c5c] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: 36px;\n}\n.nom-detail-popup__download-link[data-v-49da1c5c] {\n  display: flex;\n  align-items: center;\n  color: var(--primary);\n&:hover {\n    color: var(--primary-dark);\n}\n&--disabled {\n    opacity: 0.4;\n    cursor: pointer;\n}\n&--loading {\n    cursor: default;\n    pointer-events: none;\n}\n}\n.nom-detail-popup__btn[data-v-49da1c5c] {\n  font-size: 0.9rem;\n}\n.nom-detail-popup__spinner[data-v-49da1c5c] {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: nom-spin-data-v-49da1c5c 0.7s linear infinite;\n          animation: nom-spin-data-v-49da1c5c 0.7s linear infinite;\n}\n@-webkit-keyframes nom-spin-data-v-49da1c5c {\nto { -webkit-transform: rotate(360deg); transform: rotate(360deg);\n}\n}\n@keyframes nom-spin-data-v-49da1c5c {\nto { -webkit-transform: rotate(360deg); transform: rotate(360deg);\n}\n}\n.nom-detail-popup__move-link[data-v-49da1c5c] {\n  font-size: 0.8rem;\n  color: var(--primary);\n  cursor: pointer;\n  white-space: nowrap;\n&:hover {\n    color: var(--primary-dark);\n    text-decoration: underline;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOMINATION_LIST_UNPROCESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOMINATION_LIST_ACCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOMINATION_LIST_WAITLIST; });
// Mirror of App\Enums\NominationList (campdraftone-api)
var NOMINATION_LIST_UNPROCESSED = 'unprocessed';
var NOMINATION_LIST_ACCEPT = 'accept';
var NOMINATION_LIST_WAITLIST = 'waitlist';

/***/ }),

/***/ 1343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"size":"lg","content-class":"bg-gray-200"},on:{"close":_vm.onClose},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"w-100 d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"8px"}},[(_vm.data != null)?_c('span',{staticClass:"font-weight-bold"},[_vm._v("\n          Account #"+_vm._s(_vm.data.user.member_number)+"\n          "),_c('span',{staticClass:"text-muted font-weight-normal ml-1"},[_vm._v("("+_vm._s(_vm.data.total_nominations)+")")])]):_c('span',{staticClass:"font-weight-bold"},[_vm._v("Account detail")]),_vm._v(" "),(_vm.profileRoute != null)?_c('router-link',{staticClass:"icon-btn icon-btn--view",attrs:{"to":_vm.profileRoute,"target":"_blank","title":"View profile"}}):_vm._e()],1),_vm._v(" "),(_vm.data != null && _vm.hasInvoices)?_c('div',{staticClass:"nom-detail-popup__invoice-block"},[_c('app-button',{staticClass:"nom-detail-popup__btn",attrs:{"variant":"primary","block":false,"size":"sm","loading":_vm.resending,"disabled":_vm.resending},on:{"click":_vm.resendInvoice}},[_c('svg',{staticStyle:{"margin-right":"5px","vertical-align":"middle"},attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.7158 9.37948V2.22974C17.7158 1.91365 17.4561 1.65869 17.1448 1.65869H1.07929C0.766467 1.65869 0.50824 1.91494 0.50824 2.22974V12.5086C0.50824 12.824 0.763917 13.0796 1.07929 13.0796H9.75304C9.73222 13.2672 9.72114 13.4577 9.72114 13.6507C9.72114 16.4846 12.0267 18.7901 14.8606 18.7901C17.6944 18.7901 20 16.4846 20 13.6507C20 11.8725 19.0922 10.3026 17.7158 9.37948ZM15.3628 2.80079L9.14853 7.23958L2.87504 2.80079H15.3628ZM1.65033 11.9375V3.33331L8.82026 8.40638C8.91908 8.47631 9.03459 8.51126 9.15009 8.51126C9.26643 8.51126 9.38274 8.47578 9.48202 8.40489L16.5737 3.3394V8.80524C16.0376 8.61512 15.461 8.51126 14.8606 8.51126C12.6271 8.51126 10.7222 9.94345 10.0151 11.9375H1.65033ZM14.8606 17.648C12.6564 17.648 10.8632 15.8548 10.8632 13.6507C10.8632 11.4466 12.6564 9.65336 14.8606 9.65336C17.0647 9.65336 18.8579 11.4466 18.8579 13.6507C18.8579 15.8548 17.0647 17.648 14.8606 17.648Z","fill":"white"}}),_c('path',{attrs:{"d":"M17.9045 12.8131C17.7629 12.6536 17.5157 12.6363 17.3524 12.7744L17.0739 13.0097C16.8399 11.8652 15.8023 11 14.5612 11C13.149 11 12 12.1212 12 13.4995C12 14.8783 13.149 16 14.5612 16C15.0657 16 15.5528 15.8575 15.9699 15.5879C16.1501 15.4714 16.1995 15.2344 16.0801 15.0586C15.9607 14.8827 15.7178 14.8346 15.5377 14.9511C15.2491 15.1376 14.9115 15.2361 14.5612 15.2361C13.5806 15.2361 12.7828 14.4571 12.7828 13.4995C12.7828 12.5425 13.5806 11.7639 14.5612 11.7639C15.3765 11.7639 16.0651 12.3016 16.2748 13.0324L15.9862 12.8214C15.8131 12.6949 15.5679 12.7292 15.4383 12.8981C15.3087 13.0669 15.3439 13.3063 15.5169 13.4328L16.472 14.1311C16.5417 14.182 16.6243 14.2073 16.7066 14.2073C16.7982 14.2073 16.8896 14.176 16.9629 14.1141L17.8648 13.352C18.0282 13.2138 18.046 12.9726 17.9045 12.8131Z","fill":"white"}})]),_vm._v(" "),_c('small',[_vm._v("RESEND INVOICE")])]),_vm._v(" "),_vm._l((_vm.data.invoices),function(inv){return [(inv.pdf_path)?_c('a',{key:inv.id,staticClass:"nom-detail-popup__download-link",attrs:{"href":inv.pdf_path,"target":"_blank","rel":"noopener","title":'Download invoice #' + inv.invoice_number}},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.00001 10.1333C7.89335 10.1333 7.68001 10.1333 7.57335 10.0267L4.37335 6.82668C4.16002 6.61335 4.16002 6.29335 4.37335 6.08001C4.58668 5.86668 4.90668 5.86668 5.12002 6.08001L7.89335 8.85335L10.6667 6.08001C10.88 5.86668 11.2 5.86668 11.4133 6.08001C11.6267 6.29335 11.6267 6.61335 11.4133 6.82668L8.21335 10.0267C8.32001 10.1333 8.10668 10.1333 8.00001 10.1333Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.00001 9.6C7.68001 9.6 7.46667 9.38667 7.46667 9.06667V0.533333C7.46667 0.213333 7.68001 0 8.00001 0C8.32001 0 8.53334 0.213333 8.53334 0.533333V9.06667C8.53334 9.38667 8.32001 9.6 8.00001 9.6Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.3333 16H2.66667C1.17333 16 0 14.8267 0 13.3333V11.2C0 10.88 0.213333 10.6667 0.533333 10.6667C0.853333 10.6667 1.06667 10.88 1.06667 11.2V13.3333C1.06667 14.1867 1.81333 14.9333 2.66667 14.9333H13.3333C14.1867 14.9333 14.9333 14.1867 14.9333 13.3333V11.2C14.9333 10.88 15.1467 10.6667 15.4667 10.6667C15.7867 10.6667 16 10.88 16 11.2V13.3333C16 14.8267 14.8267 16 13.3333 16Z","fill":"currentColor"}})])]):_c('a',{key:inv.id + '-gen',class:['nom-detail-popup__download-link', { 'nom-detail-popup__download-link--loading': _vm.generatingPdfIds.has(inv.id) }],attrs:{"href":"#","title":'Download invoice #' + inv.invoice_number},on:{"click":function($event){$event.preventDefault();return _vm.generateInvoicePdf(inv)}}},[(_vm.generatingPdfIds.has(inv.id))?_c('span',{staticClass:"nom-detail-popup__spinner"}):_c('svg',{staticStyle:{"opacity":"0.4"},attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.00001 10.1333C7.89335 10.1333 7.68001 10.1333 7.57335 10.0267L4.37335 6.82668C4.16002 6.61335 4.16002 6.29335 4.37335 6.08001C4.58668 5.86668 4.90668 5.86668 5.12002 6.08001L7.89335 8.85335L10.6667 6.08001C10.88 5.86668 11.2 5.86668 11.4133 6.08001C11.6267 6.29335 11.6267 6.61335 11.4133 6.82668L8.21335 10.0267C8.32001 10.1333 8.10668 10.1333 8.00001 10.1333Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.00001 9.6C7.68001 9.6 7.46667 9.38667 7.46667 9.06667V0.533333C7.46667 0.213333 7.68001 0 8.00001 0C8.32001 0 8.53334 0.213333 8.53334 0.533333V9.06667C8.53334 9.38667 8.32001 9.6 8.00001 9.6Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.3333 16H2.66667C1.17333 16 0 14.8267 0 13.3333V11.2C0 10.88 0.213333 10.6667 0.533333 10.6667C0.853333 10.6667 1.06667 10.88 1.06667 11.2V13.3333C1.06667 14.1867 1.81333 14.9333 2.66667 14.9333H13.3333C14.1867 14.9333 14.9333 14.1867 14.9333 13.3333V11.2C14.9333 10.88 15.1467 10.6667 15.4667 10.6667C15.7867 10.6667 16 10.88 16 11.2V13.3333C16 14.8267 14.8267 16 13.3333 16Z","fill":"currentColor"}})])])]})],2):_vm._e()])]},proxy:true},{key:"body",fn:function(){return [(_vm.loading && _vm.data == null)?_c('div',{staticClass:"text-center py-4"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}})]):(_vm.data != null)?_c('div',{staticClass:"nom-detail-popup"},[(_vm.loading)?_c('div',{staticClass:"nom-detail-popup__overlay"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}})]):_vm._e(),_vm._v(" "),_c('form-alert',{staticClass:"mb-3",attrs:{"message":_vm.alert.message.value,"type":_vm.alert.type.value}}),_vm._v(" "),(_vm.data.tags && _vm.data.tags.length)?_c('div',{staticClass:"mb-3"},_vm._l((_vm.data.tags),function(tag){return _c('span',{key:tag.id,staticClass:"badge alert-success mr-2",staticStyle:{"text-transform":"inherit","font-size":"12px"}},[_vm._v("\n          "+_vm._s(tag.name)+"\n        ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nom-detail-popup__toolbar mb-3"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"id":"nom-select-all","type":"checkbox"},domProps:{"checked":_vm.allSelected,"indeterminate":_vm.someSelected},on:{"change":_vm.toggleSelectAll}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label mb-0 h6 text-dark",attrs:{"for":"nom-select-all"}},[_vm._v("Select all")])]),_vm._v(" "),_c('app-button',{staticClass:"nom-detail-popup__btn",attrs:{"variant":"primary","block":false,"size":"sm","disabled":!_vm.data.draw_is_published,"title":!_vm.data.draw_is_published ? 'Draw is not published yet' : undefined},on:{"click":function($event){return _vm.$emit('resend-draw', _vm.data.user.id)}}},[_c('small',[_vm._v("Resend draw notifications")])])],1),_vm._v(" "),_vm._l((_vm.data.members),function(member,mi){return _c('div',{key:member.id,staticClass:"nom-detail-popup__member"},[_c('div',{staticClass:"nom-detail-popup__member-header nom-detail-popup__member-header--toggle",on:{"click":function($event){return _vm.toggleMember(member.id, member.events)}}},[_c('div',{staticClass:"custom-control custom-checkbox mr-2",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{staticClass:"custom-control-input",attrs:{"id":'nom-member-check-' + member.id,"type":"checkbox"},domProps:{"checked":_vm.selectedMemberIds.indexOf(member.id) !== -1},on:{"change":function($event){return _vm.toggleSelectMember(member.id)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label mb-0",attrs:{"for":'nom-member-check-' + member.id}})]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center flex-wrap",staticStyle:{"gap":"8px"}},[_c('span',{staticClass:"nom-detail-popup__member-name"},[_vm._v("\n              "+_vm._s(member.full_name)+"\n              "),(member.deleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text-muted font-weight-normal"},[_vm._v("("+_vm._s(member.nominations_count)+")")]),_vm._v(" "),_c('i',{staticClass:"nom-detail-popup__chevron",class:{ 'nom-detail-popup__chevron--open': _vm.openMemberId === member.id }})]),_vm._v(" "),(member.is_young || member.is_old)?_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"5px"}},[_c('i',{staticClass:"nom-red-person-icon"}),_vm._v(" "),_c('small',{staticClass:"badge alert-danger",staticStyle:{"text-transform":"inherit","font-size":"12px"}},[_vm._v("\n                The competitor will be too "+_vm._s(member.is_young ? 'young' : 'old')+" on date of campdraft\n              ")])]):_vm._e()])]),_vm._v(" "),(member.needs_to_be_processed)?_c('small',{staticClass:"badge alert-warning",staticStyle:{"text-transform":"inherit","font-size":"12px"}},[_vm._v("\n          Some nominations needs to be processed\n        ")]):_vm._e(),_vm._v(" "),(_vm.openMemberId === member.id)?_c('div',_vm._l((member.events),function(event,ei){return _c('div',{key:event.id,staticClass:"nom-detail-popup__event"},[_c('div',{staticClass:"nom-detail-popup__event-header nom-detail-popup__event-header--toggle",on:{"click":function($event){return _vm.toggleEvent(event.id)}}},[_c('span',[_vm._v(_vm._s(event.name)+" "),_c('span',{staticClass:"text-muted"},[_vm._v("("+_vm._s(event.nominations_count)+")")]),_c('i',{staticClass:"nom-detail-popup__chevron nom-detail-popup__chevron--sm",class:{ 'nom-detail-popup__chevron--open': _vm.openEventId === event.id }})])]),_vm._v(" "),(_vm.openEventId === event.id)?_c('grid-table',{attrs:{"rows":event.nominations,"columns":_vm.columnsForEvent(event),"hide-header":true,"no-borders":true,"no-stripes":true,"draggable":true,"border-color":"white","border-width":"2px","row-bg":"var(--gray-200)"},on:{"drag-start":function($event){return _vm.onDragStart($event)},"drag-end":function($event){return _vm.onDragEnd($event, event.id)}},scopedSlots:_vm._u([{key:"cell:drag",fn:function(){return [_c('span',{staticClass:"gt__drag-handle icon-btn icon-btn--drag",attrs:{"title":"Drag to reorder"}})]},proxy:true},{key:"cell:draw_order",fn:function(ref){
var row = ref.row;
return [(row.draw_order != null)?_c('span',{staticClass:"nom-detail-popup__order"},[_vm._v(_vm._s(row.draw_order))]):_vm._e()]}},{key:"cell:ntbp",fn:function(ref){
var row = ref.row;
return [(row.needs_to_be_processed)?_c('i',{staticClass:"nomination_need_to_be_processed",attrs:{"title":"The user has unprocessed nominations after the draft rules has changed."}}):_vm._e()]}},{key:"cell:horse",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"d-flex flex-column align-items-start",staticStyle:{"gap":"2px"}},[_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"6px"}},[_c('i',{staticClass:"nom-horse-icon",class:{ 'nom-horse-icon--crossed': !event.requires_horse }}),_vm._v(" "),_c('span',{staticClass:"nom-detail-popup__horse-name"},[_vm._v(_vm._s(event.requires_horse ? row.horse.name : '—'))]),_vm._v(" "),(event.requires_horse && row.horse.deleted)?_c('small',{staticClass:"text-primary"},[_vm._v("(deleted)")]):_vm._e()]),_vm._v(" "),(row.comb_nomination_id != null)?_c('small',{staticClass:"text-primary"},[_vm._v("(Combined)")]):_vm._e()])]}},{key:"cell:owner",fn:function(ref){
var row = ref.row;
return [(!event.requires_horse)?_c('div',{staticClass:"font-weight-bold",on:{"click":function($event){$event.stopPropagation();}}},[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{staticClass:"form-control nom-detail-popup__quantity-input",attrs:{"type":"number","min":"1","max":_vm.quantityMaxByNomId[row.id],"disabled":_vm.quantityUpdatingIds.indexOf(row.id) !== -1},domProps:{"value":_vm.quantityOverrides[row.id] != null ? _vm.quantityOverrides[row.id] : row.quantity},on:{"change":function($event){return _vm.onQuantityChange(row.id, $event.target.value, event.id)}}})]):_c('div',{staticClass:"font-weight-bold"},[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Horse owner")]),_vm._v("\n                "+_vm._s(row.horse.owner_name != null ? row.horse.owner_name : '—')+"\n              ")])]}},{key:"cell:status",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Nomination Status")]),_vm._v(" "),_c('nomination-list-select',{attrs:{"value":row.list,"size-class":"multiselect--sm"},on:{"input":function($event){return _vm.onListChange(row, $event)}}})],1)]}},(event.move_to_event != null)?{key:"cell:move",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Move to")]),_vm._v(" "),_c('a',{staticClass:"nom-detail-popup__move-link",on:{"click":function($event){return _vm.onMoveToEvent(row, event.move_to_event.id)}}},[_vm._v("\n                  "+_vm._s(event.move_to_event.name)+"\n                ")])])]}}:null,{key:"cell:scratch",fn:function(ref){
var row = ref.row;
return [(row.is_scratched_by_user)?_c('i',{staticClass:"nom-scratched-icon",attrs:{"title":"The user scratched the nomination"}}):_vm._e()]}}],null,true)}):_vm._e()],1)}),0):_vm._e()])}),_vm._v(" "),(_vm.pendingListChange != null)?_c('confirm-modal',{on:{"confirm":_vm.confirmPendingListChange,"cancel":function($event){_vm.pendingListChange = null}}},[(_vm.pendingListChange.warning === 'draw')?[_c('p',[_vm._v(_vm._s(_vm.closedDrawWarning))]),_vm._v(" "),_c('p',[_vm._v("To do this go to the "),_c('router-link',{attrs:{"to":{ name: 'DrawsDashboard' }}},[_vm._v("Draws page")]),_vm._v(".")],1),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Proceed anyway?")])]:_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.acceptInvoiceWarning))])],2):_vm._e()],2):_vm._e()]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteePartialPaymentPopup_vue__ = __webpack_require__(1251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bedbd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteePartialPaymentPopup_vue__ = __webpack_require__(1347);
function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17bedbd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteePartialPaymentPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bedbd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteePartialPaymentPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1346);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("3d815f2f", content, true, {});

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".partial-payment-popup[data-v-17bedbd6]{min-width:560px}.partial-payment-popup__member-name[data-v-17bedbd6]{font-size:15px;padding:4px 0}.partial-payment-popup__horse-name[data-v-17bedbd6]{font-weight:500}.partial-payment-popup__footer[data-v-17bedbd6],.partial-payment-popup__total[data-v-17bedbd6]{font-size:1rem}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Committees/Dashboard/components/CommitteePartialPaymentPopup.vue"],"names":[],"mappings":"AACA,wCACE,eAAiB,CAClB,AACD,qDACE,eAAgB,AAChB,aAAe,CAChB,AACD,oDACE,eAAiB,CAClB,AAID,+FACE,cAAgB,CACjB","file":"CommitteePartialPaymentPopup.vue","sourcesContent":["\n.partial-payment-popup[data-v-17bedbd6] {\n  min-width: 560px;\n}\n.partial-payment-popup__member-name[data-v-17bedbd6] {\n  font-size: 15px;\n  padding: 4px 0;\n}\n.partial-payment-popup__horse-name[data-v-17bedbd6] {\n  font-weight: 500;\n}\n.partial-payment-popup__footer[data-v-17bedbd6] {\n  font-size: 1rem;\n}\n.partial-payment-popup__total[data-v-17bedbd6] {\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"size":"lg","content-class":"bg-gray-200"},on:{"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"w-100 d-flex align-items-center",staticStyle:{"gap":"8px"}},[(_vm.data != null)?_c('span',{staticClass:"font-weight-bold"},[_vm._v("\n        Account #"+_vm._s(_vm.data.user.member_number)+"\n        "),_c('span',{staticClass:"text-muted font-weight-normal ml-1"},[_vm._v("("+_vm._s(_vm.data.total_nominations)+")")])]):_c('span',{staticClass:"font-weight-bold"},[_vm._v("Account detail")]),_vm._v(" "),(_vm.profileRoute != null)?_c('router-link',{staticClass:"icon-btn icon-btn--view",attrs:{"to":_vm.profileRoute,"target":"_blank","title":"View profile"}}):_vm._e()],1)]},proxy:true},{key:"body",fn:function(){return [(_vm.loading)?_c('div',{staticClass:"text-center py-4"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}})]):(_vm.data != null)?_c('div',{staticClass:"partial-payment-popup"},[_c('form-alert',{staticClass:"mb-3",attrs:{"message":_vm.alert.message.value,"type":_vm.alert.type.value}}),_vm._v(" "),_vm._l((_vm.data.members),function(member){return _c('div',{key:member.id,staticClass:"mb-3"},[_c('div',{staticClass:"partial-payment-popup__member-name mb-1"},[_c('strong',[_vm._v(_vm._s(member.full_name))])]),_vm._v(" "),_c('grid-table',{attrs:{"rows":_vm.memberNominations(member),"columns":_vm.COLUMNS,"hide-header":true,"no-borders":true,"no-stripes":true,"border-color":"white","border-width":"2px","row-bg":"var(--gray-200)"},scopedSlots:_vm._u([{key:"cell:check",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"id":'partial-nom-' + row.id,"type":"checkbox"},domProps:{"checked":_vm.selectedIds.indexOf(row.id) !== -1},on:{"change":function($event){return _vm.toggleSelect(row.id)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label mb-0",attrs:{"for":'partial-nom-' + row.id}})])]}},{key:"cell:ntbp",fn:function(ref){
var row = ref.row;
return [(row.needs_to_be_processed)?_c('i',{staticClass:"nomination_need_to_be_processed",attrs:{"title":"The user has unprocessed nominations after the draft rules has changed."}}):_vm._e()]}},{key:"cell:event",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Event name")]),_vm._v("\n              "+_vm._s(row.event_name)+"\n            ")])]}},{key:"cell:horse",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"d-flex flex-column align-items-start",staticStyle:{"gap":"2px"}},[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Horse")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"6px"}},[_c('i',{staticClass:"nom-horse-icon",class:{ 'nom-horse-icon--crossed': row.horse.id == null }}),_vm._v(" "),_c('span',{staticClass:"partial-payment-popup__horse-name"},[_vm._v(_vm._s(row.horse.name))])]),_vm._v(" "),(row.comb_nomination_id != null)?_c('small',{staticClass:"text-primary"},[_vm._v("(Combined)")]):_vm._e()])]}},{key:"cell:owner",fn:function(ref){
var row = ref.row;
return [(row.horse.id == null)?_c('div',{staticClass:"font-weight-bold"},[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Quantity")]),_vm._v("\n              "+_vm._s(row.quantity)+"\n            ")]):_c('div',{staticClass:"font-weight-bold"},[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Horse owner")]),_vm._v("\n              "+_vm._s(row.horse.owner_name != null ? row.horse.owner_name : '—')+"\n            ")])]}},{key:"cell:cost",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('small',{staticClass:"d-block font-weight-bold"},[_vm._v("Cost")]),_vm._v(" "),(row.cost != null)?_c('span',[_vm._v("$"+_vm._s(Number(row.cost).toFixed(2)))]):_c('span',[_vm._v("—")])])]}}],null,true)})],1)}),_vm._v(" "),_c('div',{staticClass:"partial-payment-popup__footer mt-3 pt-3 border-top d-flex align-items-center justify-content-between"},[_c('app-button',{attrs:{"variant":"primary","block":false,"size":"sm","loading":_vm.saving},on:{"click":_vm.onUpdate}},[_vm._v("\n          Update\n        ")]),_vm._v(" "),_c('div',{staticClass:"partial-payment-popup__total"},[_vm._v("\n          Total paid: "),_c('strong',{staticClass:"ml-1"},[_vm._v("$"+_vm._s(_vm.totalPaid))])])],1)],2):_vm._e()]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nominations-section mt-4 border-top pt-4"},[(_vm.event != null)?_c('div',{staticClass:"d-flex flex-wrap align-items-center mb-3"},[_c('span',{staticClass:"mr-3 mb-2 nominations-section__event-name"},[_vm._v(_vm._s(_vm.event.name)+" nominations")])]):_vm._e(),_vm._v(" "),(_vm.isLocked)?_c('div',{staticClass:"text-muted font-italic py-3 text-center"},[_vm._v("\n    This event is locked, unlock the event to edit it.\n  ")]):[_c('bulk-editor-tool',{attrs:{"total-count":_vm.filteredNominations.length,"selected-count":_vm.selectedGroupUserIds.length},on:{"toggle-all":_vm.toggleSelectAll}},[(_vm.activeList === 'accept')?_c('div',{staticClass:"bulk-action-group mr-3"},[_c('label',{staticClass:"bulk-action-group__label"},[_vm._v("Payment status")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('app-multiselect',{staticClass:"bulk-action-group__select mr-2",attrs:{"value":_vm.bulkPaymentStatus,"options":_vm.paymentStatusOptions,"label":"label","track-by":"value","searchable":false,"allow-empty":true,"placeholder":"-","select-label":"","deselect-label":"","selected-label":""},on:{"input":function($event){_vm.bulkPaymentStatus = $event}}}),_vm._v(" "),_c('app-button',{attrs:{"type":"button","variant":"outline-primary","block":false,"loading":_vm.applyingBulkPayment,"disabled":_vm.selectedGroupUserIds.length === 0 || _vm.bulkPaymentStatus == null || _vm.applyingBulkPayment},on:{"click":_vm.applyBulkPaymentStatus}},[_vm._v("\n          Apply\n        ")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bulk-action-group mr-3"},[_c('label',{staticClass:"bulk-action-group__label"},[_vm._v("Nomination status")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('app-multiselect',{staticClass:"bulk-action-group__select mr-2",attrs:{"value":_vm.bulkList,"options":_vm.moveableLists,"label":"label","track-by":"value","searchable":false,"allow-empty":true,"placeholder":"-","select-label":"","deselect-label":"","selected-label":""},on:{"input":function($event){_vm.bulkList = $event}}}),_vm._v(" "),_c('app-button',{attrs:{"type":"button","variant":"outline-primary","block":false,"loading":_vm.applyingBulk,"disabled":_vm.selectedGroupUserIds.length === 0 || _vm.bulkList == null || _vm.applyingBulk},on:{"click":_vm.applyBulkStatus}},[_vm._v("\n          Apply\n        ")])],1)]),_vm._v(" "),(_vm.activeList === 'accept')?_c('div',{staticClass:"bulk-action-group"},[_c('label',{staticClass:"bulk-action-group__label"},[_vm._v("Payment type")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('app-multiselect',{staticClass:"bulk-action-group__select mr-2",attrs:{"value":_vm.bulkComment,"options":_vm.commitOptions,"label":"label","track-by":"value","searchable":false,"allow-empty":true,"placeholder":"-","select-label":"","deselect-label":"","selected-label":""},on:{"input":function($event){_vm.bulkComment = $event}}}),_vm._v(" "),_c('app-button',{attrs:{"type":"button","variant":"outline-primary","block":false,"loading":_vm.applyingBulkComment,"disabled":_vm.selectedGroupUserIds.length === 0 || _vm.bulkComment == null || _vm.applyingBulkComment},on:{"click":_vm.applyBulkComment}},[_vm._v("\n          Apply\n        ")])],1)]):_vm._e()]),_vm._v(" "),_c('tab-search-bar',{attrs:{"items":_vm.listTabItems,"active-tab":_vm.activeList,"search":_vm.searchInput,"placeholder":"Name or member number"},on:{"tab-change":_vm.onListChange,"search-input":function($event){return _vm.$emit('search-input', $event)}}}),_vm._v(" "),_c('div',{staticClass:"action-buttons d-flex justify-content-between w-100 mt-3 mb-3"},[_c('div',{staticClass:"action-buttons__left"},[_c('div',[_c('router-link',{staticClass:"m-0 btn btn-block-mob btn-outline-primary",attrs:{"to":("/nominations/" + _vm.draftId + "/reassign-member")}},[_vm._v("Re-assign nominations")])],1),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('router-link',{staticClass:"m-0 btn btn-block-mob btn-outline-primary",attrs:{"to":("/nominations/" + _vm.draftId + "/bulk-email")}},[_vm._v("Send bulk email/text")])],1),_vm._v(" "),(_vm.drawIsPublished)?_c('div',{staticClass:"mt-2"},[_c('app-button',{staticClass:"m-0 btn-block-mob",attrs:{"type":"button","variant":"outline-primary","block":false},on:{"click":function($event){_vm.showResendModal = true}}},[_vm._v("Re-send draws notifications")])],1):_vm._e(),_vm._v(" "),(_vm.activeList === 'accept')?_c('div',{staticClass:"mt-2"},[_c('app-button',{staticClass:"m-0 btn-block-mob",attrs:{"type":"button","variant":"primary","block":false,"loading":_vm.sendingReminders},on:{"click":_vm.sendOverdueReminders}},[_c('svg',{staticStyle:{"margin-right":"8px","vertical-align":"middle","position":"relative","top":"2px"},attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.7158 9.37948V2.22974C17.7158 1.91365 17.4561 1.65869 17.1448 1.65869H1.07929C0.766467 1.65869 0.50824 1.91494 0.50824 2.22974V12.5086C0.50824 12.824 0.763917 13.0796 1.07929 13.0796H9.75304C9.73222 13.2672 9.72114 13.4577 9.72114 13.6507C9.72114 16.4846 12.0267 18.7901 14.8606 18.7901C17.6944 18.7901 20 16.4846 20 13.6507C20 11.8725 19.0922 10.3026 17.7158 9.37948ZM15.3628 2.80079L9.14853 7.23958L2.87504 2.80079H15.3628ZM1.65033 11.9375V3.33331L8.82026 8.40638C8.91908 8.47631 9.03459 8.51126 9.15009 8.51126C9.26643 8.51126 9.38274 8.47578 9.48202 8.40489L16.5737 3.3394V8.80524C16.0376 8.61512 15.461 8.51126 14.8606 8.51126C12.6271 8.51126 10.7222 9.94345 10.0151 11.9375H1.65033ZM14.8606 17.648C12.6564 17.648 10.8632 15.8548 10.8632 13.6507C10.8632 11.4466 12.6564 9.65336 14.8606 9.65336C17.0647 9.65336 18.8579 11.4466 18.8579 13.6507C18.8579 15.8548 17.0647 17.648 14.8606 17.648Z","fill":"white"}}),_c('path',{attrs:{"d":"M17.9045 12.8131C17.7629 12.6536 17.5157 12.6363 17.3524 12.7744L17.0739 13.0097C16.8399 11.8652 15.8023 11 14.5612 11C13.149 11 12 12.1212 12 13.4995C12 14.8783 13.149 16 14.5612 16C15.0657 16 15.5528 15.8575 15.9699 15.5879C16.1501 15.4714 16.1995 15.2344 16.0801 15.0586C15.9607 14.8827 15.7178 14.8346 15.5377 14.9511C15.2491 15.1376 14.9115 15.2361 14.5612 15.2361C13.5806 15.2361 12.7828 14.4571 12.7828 13.4995C12.7828 12.5425 13.5806 11.7639 14.5612 11.7639C15.3765 11.7639 16.0651 12.3016 16.2748 13.0324L15.9862 12.8214C15.8131 12.6949 15.5679 12.7292 15.4383 12.8981C15.3087 13.0669 15.3439 13.3063 15.5169 13.4328L16.472 14.1311C16.5417 14.182 16.6243 14.2073 16.7066 14.2073C16.7982 14.2073 16.8896 14.176 16.9629 14.1141L17.8648 13.352C18.0282 13.2138 18.046 12.9726 17.9045 12.8131Z","fill":"white"}})]),_vm._v(" "),_c('small',[_vm._v("SEND PAYMENT REMINDER")])])],1):_vm._e(),_vm._v(" "),(_vm.eventMembersAllowed)?_c('div',{staticClass:"mt-2"},[_c('router-link',{staticClass:"m-0 btn btn-block-mob btn-primary",attrs:{"to":("/draft-members/" + _vm.draftId)}},[_vm._v("Show Event Members in Draft")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"action-buttons__right"},[_c('div',{staticClass:"d-flex justify-content-end w-100 flex-column mb-4"},[_c('div',{staticClass:"d-flex h5 mr-5 justify-content-end"},[_vm._v("Biosecurity Form Report")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-end"},[_c('app-button',{staticClass:"ml-3",attrs:{"type":"button","variant":"primary","size":"sm","block":false,"loading":_vm.downloadingBiosecurityPdf},on:{"click":function($event){return _vm.downloadBiosecurityReport('pdf')}}},[_vm._v("Download PDF")]),_vm._v(" "),_c('app-button',{staticClass:"ml-3",attrs:{"type":"button","variant":"primary","size":"sm","block":false,"loading":_vm.downloadingBiosecurityCsv},on:{"click":function($event){return _vm.downloadBiosecurityReport('csv')}}},[_vm._v("Download CSV")])],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end w-100 flex-column"},[_c('div',{staticClass:"d-flex h5 mr-5 justify-content-end"},[_vm._v("Vehicle Information Report")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap justify-content-end"},[_c('app-button',{staticClass:"ml-3",attrs:{"type":"button","variant":"primary","size":"sm","block":false,"loading":_vm.downloadingVehiclesPdf},on:{"click":function($event){return _vm.downloadVehiclesReport()}}},[_vm._v("Download PDF")])],1)])])]),_vm._v(" "),(_vm.activeList === 'accept')?_c('f-radio-group',{attrs:{"name":"paymentStatusFilter","label":"Payment status filter","value":_vm.paymentFilter,"options":_vm.paymentFilterOptions,"inline":""},on:{"input":function($event){_vm.paymentFilter = $event}}}):_vm._e(),_vm._v(" "),_c('form-alert',{staticClass:"mt-2",attrs:{"message":_vm.bulkAlert.message.value,"type":_vm.bulkAlert.type.value}}),_vm._v(" "),(_vm.blockedAccept.length)?_c('div',{staticClass:"alert alert-warning mt-2 blocked-accept",attrs:{"role":"alert"}},[_c('button',{staticClass:"close blocked-accept__close",attrs:{"type":"button","aria-label":"Dismiss"},on:{"click":_vm.dismissBlockedAccept}},[_vm._v("×")]),_vm._v(" "),_c('p',{staticClass:"mb-2 font-weight-bold"},[_vm._v("\n      These competitors are already accepted into an overlapping draft. Move them to another list, then accept the rest:\n    ")]),_vm._v(" "),_c('ul',{staticClass:"blocked-accept__list list-unstyled mb-0"},_vm._l((_vm.blockedAccept),function(c){return _c('li',{key:c.id,staticClass:"blocked-accept__row"},[_c('button',{staticClass:"blocked-accept__search",attrs:{"type":"button","title":"Search for this competitor"},on:{"click":function($event){return _vm.searchBlocked(c)}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","width":"15","height":"15","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"fill":"currentColor","d":"M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14z"}})])]),_vm._v(" "),_c('span',{staticClass:"blocked-accept__name"},[_vm._v("\n          "+_vm._s(c.name)),(c.deleted)?_c('span',{staticClass:"text-muted"},[_vm._v(" (deleted)")]):_vm._e(),(c.draft)?[_vm._v(" — accepted in “"+_vm._s(c.draft)+"”")]:_vm._e()],2)])}),0)]):_vm._e(),_vm._v(" "),_c('nominations-dashboard-table',{attrs:{"nominations":_vm.filteredNominations,"loading":_vm.loadingNominations,"draft-id":_vm.draftId,"move-group":_vm.handleMoveGroup,"commit-options":_vm.commitOptions,"payment-status-options":_vm.paymentStatusOptions,"error-key":_vm.tableErrorKey,"selectable":true,"selected-ids":_vm.selectedGroupUserIds,"active-list":_vm.activeList,"event-mode":_vm.event != null},on:{"toggle-select":_vm.toggleSelect,"open-detail":_vm.onOpenDetail,"commit-change":_vm.onRowCommitChange,"payment-status-change":_vm.onRowPaymentStatusChange,"open-partial-payment":_vm.onOpenPartialPayment},scopedSlots:_vm._u([{key:"before-row",fn:function(ref){
var row = ref.row;
return [(_vm.rowAlert.alert.value.message && _vm.rowAlert.alert.value.rowId === row.user.id)?_c('row-alert',{attrs:{"message":_vm.rowAlert.alert.value.message,"type":_vm.rowAlert.alert.value.type,"alert-key":_vm.rowAlert.alert.value.id},on:{"dismiss":function($event){return _vm.rowAlert.clear()}}}):_vm._e()]}}])}),_vm._v(" "),(_vm.partialPaymentTarget != null)?_c('committee-partial-payment-popup',{attrs:{"draft-id":_vm.draftId,"user-id":_vm.partialPaymentTarget.userId,"payment-type":_vm.partialPaymentTarget.paymentType,"on-changed":_vm.markPartialPaymentChanged},on:{"success":_vm.onPartialPaymentSuccess,"close":_vm.closePartialPayment}}):_vm._e(),_vm._v(" "),(_vm.detailTarget != null)?_c('nomination-account-detail-popup',{attrs:{"draft-id":_vm.draftId,"user-id":_vm.detailTarget.userId,"list":_vm.detailTarget.list,"event-id":_vm.detailTarget.eventId,"draft-state-id":_vm.draftStateId,"draw-exists":_vm.drawExists,"on-changed":_vm.markDetailChanged},on:{"close":_vm.closeDetail}}):_vm._e(),_vm._v(" "),(_vm.pendingMove != null)?_c('confirm-modal',{on:{"confirm":_vm.confirmPendingMove,"cancel":function($event){_vm.pendingMove = null}}},[(_vm.pendingMove.warning === 'draw')?[_c('p',[_vm._v(_vm._s(_vm.closedDrawWarning))]),_vm._v(" "),_c('p',[_vm._v("To do this go to the "),_c('router-link',{attrs:{"to":{ name: 'DrawsDashboard' }}},[_vm._v("Draws page")]),_vm._v(".")],1),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("Proceed anyway?")])]:_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.acceptInvoiceWarning))])],2):_vm._e(),_vm._v(" "),(_vm.showResendModal)?_c('modal',{on:{"close":function($event){_vm.showResendModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',{staticClass:"font-weight-bold mb-2"},[_vm._v("Select events")]),_vm._v(" "),_c('p',{staticClass:"text-muted small mb-3"},[_vm._v("Leave all unchecked to resend to every event in the draft.")]),_vm._v(" "),_vm._l((_vm.events),function(ev){return _c('div',{key:ev.id,staticClass:"form-check mb-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resendEventIds),expression:"resendEventIds"}],staticClass:"form-check-input",attrs:{"id":("resend-event-" + (ev.id)),"type":"checkbox"},domProps:{"value":ev.id,"checked":Array.isArray(_vm.resendEventIds)?_vm._i(_vm.resendEventIds,ev.id)>-1:(_vm.resendEventIds)},on:{"change":function($event){var $$a=_vm.resendEventIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=ev.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.resendEventIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.resendEventIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.resendEventIds=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":("resend-event-" + (ev.id))}},[_vm._v(_vm._s(ev.name))])])})],2),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('app-button',{attrs:{"type":"button","variant":"primary","block":false,"loading":_vm.sendingResend},on:{"click":_vm.submitResend}},[_vm._v("Send")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){_vm.showResendModal = false}}},[_vm._v("Cancel")])],1)])]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"wrap-drafts dashboard committee_nomination_dashboard bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Nomination Dashboard")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    For your nominations to open at your selected time, you must contact the Campdraft One Team to review, approve,\n    and publish your Campdraft One setup. To check that your nominations will open at your selected time, you may\n    refer to your Campdraft One setup approval email, or navigate to \"Nominations\" where your draft should appear\n    with the nomination opening date and time listed.\n  ")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"historical_filter"},[_c('f-search-select',{attrs:{"id":"historical_year","label":"Filter by year","value":_vm.params.season,"options":_vm.years.map(function (y) { return ({ id: y, name: String(y) }); }),"searchable":false},on:{"input":function($event){_vm.setYear(Number($event))}}})],1)]),_vm._v(" "),_c('div',{staticClass:"drafts-filter display-md"},[_c('label',[_vm._v("Sort drafts by:")]),_vm._v(" "),_c('div',{staticClass:"drafts-filter__wrap"},[_c('div',{staticClass:"display-mob sortable position-relative"},[_c('button',{staticClass:"btn btn-link p-0",on:{"click":function($event){return _vm.setSort('noms_open')}}},[_vm._v("\n          Noms Open\n          "),_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.params.sort === 'noms_open' && _vm.params.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.params.sort === 'noms_open' && _vm.params.direction === 'desc' }]})])])]),_vm._v(" "),_c('div',{staticClass:"display-mob sortable position-relative"},[_c('button',{staticClass:"btn btn-link p-0",on:{"click":function($event){return _vm.setSort('start_date')}}},[_vm._v("\n          Start Date\n          "),_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.params.sort === 'start_date' && _vm.params.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.params.sort === 'start_date' && _vm.params.direction === 'desc' }]})])])]),_vm._v(" "),_c('div',{staticClass:"display-mob sortable position-relative"},[_c('button',{staticClass:"btn btn-link p-0",on:{"click":function($event){return _vm.setSort('end_date')}}},[_vm._v("\n          End Date\n          "),_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.params.sort === 'end_date' && _vm.params.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.params.sort === 'end_date' && _vm.params.direction === 'desc' }]})])])]),_vm._v(" "),_c('div',{staticClass:"sortable position-relative"},[_c('button',{staticClass:"btn btn-link p-0",on:{"click":function($event){return _vm.setSort('draft_state_id')}}},[_vm._v("\n          Status\n          "),_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.params.sort === 'draft_state_id' && _vm.params.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.params.sort === 'draft_state_id' && _vm.params.direction === 'desc' }]})])])])])]),_vm._v(" "),_c('grid-table',{staticClass:"mt-2",attrs:{"columns":_vm.columns,"rows":_vm.drafts,"loading":_vm.loading,"sort":_vm.params.sort,"direction":_vm.params.direction,"open-id":_vm.visibleOpenDraftId,"empty-text":"No drafts found for this year."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{staticClass:"btn btn-link text-wrap text-left p-0 text-break",attrs:{"to":{ name: 'Committees Dashboard', params: { draftId: String(row.id) }, query: _vm.nominationFilters.list ? { list: _vm.nominationFilters.list } : {} }}},[_vm._v("\n        "+_vm._s(row.name)+"\n      ")])]}},{key:"cell:noms_open",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.formatDateTime(row.noms_open))+" ")]}},{key:"cell:start_date",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.formatDate(row.start_date))+" ")]}},{key:"cell:end_date",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.formatDate(row.end_date))+" ")]}},{key:"cell:status",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"badge alert-success"},[_vm._v(_vm._s(row.state ? row.state.name : ''))])]}},{key:"cell:actions",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"actions__wrap"},[_c('app-tooltip',{attrs:{"text":"Add/Edit Events, Add/Edit Event Restrictions"}},[_c('router-link',{staticClass:"icon-btn icon-btn--view",attrs:{"to":{ name: 'Draft View', params: { id: row.id } }}})],1),_vm._v(" "),_c('app-tooltip',{attrs:{"text":"Edit Draft Details, Change Draft Status","align":"right"}},[_c('router-link',{staticClass:"icon-btn icon-btn--edit",attrs:{"to":{ name: 'Draft Edit', params: { id: row.id } }}})],1)],1)]}},{key:"cell:events",fn:function(ref){
var row = ref.row;
return [(_vm.openDraftId === row.id)?_c('a',{staticClass:"icon-btn",class:_vm.eventsCollapsed ? 'icon-btn--events' : 'icon-btn--events--open',attrs:{"href":"#","title":"Toggle events"},on:{"click":function($event){$event.preventDefault();_vm.eventsCollapsed = !_vm.eventsCollapsed}}}):_c('router-link',{staticClass:"icon-btn icon-btn--events",attrs:{"to":{ name: 'Committees Dashboard', params: { draftId: String(row.id) }, query: _vm.nominationFilters.list ? { list: _vm.nominationFilters.list } : {} },"title":"Toggle events"}})]}},{key:"expand",fn:function(ref){
var row = ref.row;
return [(_vm.subAlert.eventId == null)?_c('form-alert',{attrs:{"message":_vm.subAlert.message,"type":_vm.subAlert.type},on:{"dismiss":_vm.clearSubAlert}}):_vm._e(),_vm._v(" "),_c('committee-draft-events-table',{attrs:{"events":_vm.events,"totals":_vm.totals,"loading-events":_vm.loadingEvents,"reordering":_vm.reorderingEvents,"deleting":_vm.deleting,"draft-id":row.id,"draft-state-id":row.state ? row.state.id : null,"active-event-id":_vm.nominationFilters.event_id,"list":_vm.nominationFilters.list,"alert":_vm.subAlert},on:{"dismiss-alert":_vm.clearSubAlert,"lock":_vm.onLock,"drag-end":_vm.onDragEnd,"confirm-delete":_vm.confirmDelete,"confirm-split":_vm.confirmSplit}})]}}])}),_vm._v(" "),(_vm.openDraftId != null)?_c('committee-dashboard-nominations',{attrs:{"draft-id":_vm.openDraftId,"nominations":_vm.nominations,"loading-nominations":_vm.loadingNominations,"list-tab-items":_vm.listTabItems,"active-list":_vm.nominationFilters.list,"search-input":_vm.nominationSearchInput,"event":_vm.nominationEvent,"events":_vm.events,"event-members-allowed":_vm.openDraftEventMembersAllowed,"draft-state-id":_vm.openDraftStateId},on:{"list-change":_vm.onListChange,"search-input":_vm.onSearchInput,"reload":_vm.onNominationsReload}}):_vm._e(),_vm._v(" "),(_vm.eventToDelete)?_c('confirm-modal',{attrs:{"message":("You are about to delete event " + (_vm.eventToDelete.name) + ". Are you sure?"),"loading":_vm.deleting},on:{"confirm":_vm.handleDelete,"cancel":function($event){_vm.eventToDelete = null}}}):_vm._e(),_vm._v(" "),(_vm.eventToSplit != null)?_c('confirm-modal',{attrs:{"message":"Are you sure you want to split this event into A and B?","loading":_vm.splitting},on:{"confirm":_vm.handleSplit,"cancel":function($event){_vm.eventToSplit = null}}},[_c('div',{staticClass:"alert alert-info alert-simple text-center mt-3 mb-0",attrs:{"slot":"extra"},slot:"extra"},[_vm._v("\n      Splitting an event works differently depending on its settings: a regular, a combined\n      and a conjunction event are split in different ways.\n      "),_c('button',{staticClass:"btn btn-link p-0 align-baseline",attrs:{"type":"button"},on:{"click":function($event){_vm.showSplitInfo = true}}},[_vm._v("How does split work?")])])]):_vm._e(),_vm._v(" "),(_vm.showSplitInfo)?_c('doc-modal',{attrs:{"doc":"events.split"},on:{"close":function($event){_vm.showSplitInfo = false}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.85c8429f1be7668261a0.js